webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Icon_vue__ = __webpack_require__(218);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e7d3ea5_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Icon_vue__ = __webpack_require__(568);
function injectStyle (ssrContext) {
  __webpack_require__(567)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2e7d3ea5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Icon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e7d3ea5_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__ = __webpack_require__(214);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7da80e5d_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_Icon_vue__ = __webpack_require__(533);
function injectStyle (ssrContext) {
  __webpack_require__(531)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7da80e5d_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_Icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ADD_TO_QUERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return REMOVE_FROM_QUERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CLEAR_FROM_QUERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return RESET_QUERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CLEAR_QUERY_OF_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_EDUCATION_TO_QUERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADD_SKILL_YEARS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_EXPERIENCE_YEARS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SET_SORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SET_RESULTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SET_RESULT_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SET_NO_RESULTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SET_SKIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return HAS_RESIDENCE_PERMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return HAS_WORK_PERMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return NO_WORK_PERMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return LOG_IN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return LOG_OUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SET_ACTIVE_TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SET_ACTIVE_TAB_ONLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return UPDATE_TAB_COLUMN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return OPEN_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CLOSE_MODAL; });
var ADD_TO_QUERY = 'query/ADD';
var REMOVE_FROM_QUERY = 'query/REMOVE';
var CLEAR_FROM_QUERY = 'query/CLEAR';
var RESET_QUERY = 'query/RESET';
var CLEAR_QUERY_OF_TYPE = 'query/CLEAR_QUERY_OF_TYPE';

var ADD_EDUCATION_TO_QUERY = 'query/ADD_EDUCATION';
var ADD_SKILL_YEARS = 'query/ADD_SKILL_YEARS';
var ADD_EXPERIENCE_YEARS = 'query/ADD_EXPERIENCE_YEARS';

var SET_SORT = 'query/SET_SORT';
var SET_RESULTS = 'query/SET_RESULTS';
var SET_RESULT_ERROR = 'query/SET_RESULT_ERROR';
var SET_NO_RESULTS = 'query/SET_NO_RESULTS';
var SET_SKIP = 'query/SET_SKIP';

var HAS_RESIDENCE_PERMIT = 'query/HAS_RESIDENCE_PERMIT';
var HAS_WORK_PERMIT = 'query/HAS_WORK_PERMIT';
var NO_WORK_PERMIT = 'query/NO_WORK_PERMIT';

var LOG_IN = 'login/LOG_IN';
var LOG_OUT = 'login/LOG_OUT';

var SET_ACTIVE_TAB = 'tab/SET_ACTIVE';
var SET_ACTIVE_TAB_ONLY = 'tab/SET_ACTIVE_TAB_ONLY';
var UPDATE_TAB_COLUMN = 'tab/UPDATE_COLUMN';

var OPEN_MODAL = 'modal/OPEN';
var CLOSE_MODAL = 'modal/CLOSE';

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AfH3_vue__ = __webpack_require__(253);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b5a8ed4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AfH3_vue__ = __webpack_require__(658);
function injectStyle (ssrContext) {
  __webpack_require__(654)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5b5a8ed4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AfH3_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b5a8ed4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AfH3_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AfH2_vue__ = __webpack_require__(228);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5481cc5d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AfH2_vue__ = __webpack_require__(598);
function injectStyle (ssrContext) {
  __webpack_require__(597)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5481cc5d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AfH2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5481cc5d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AfH2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__ = __webpack_require__(217);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3a7a7f8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__ = __webpack_require__(566);
function injectStyle (ssrContext) {
  __webpack_require__(565)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d3a7a7f8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3a7a7f8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return sortByName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return unique; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return filterDuplicates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deconstructJWT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isIE11; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return testMobileDevice; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);



var addProps = function addProps() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
    language: 'sv'
  });
};

var sortByName = function sortByName(a, b) {
  return a.name.localeCompare(b.name, 'sv');
};

var unique = function unique(item, index, self) {
  return self.findIndex(function (t) {
    return t.taxonomy_path === item.taxonomy_path;
  }) === index;
};

var filterDuplicates = function filterDuplicates(array) {
  return array.filter(function (item, pos, self) {
    return self.indexOf(item) == pos;
  });
};

var deconstructJWT = function deconstructJWT(token) {
  var segments = token.split('.');

  if (!segments instanceof Array || segments.length !== 3) {
    throw new Error('Invalid JWT');
  }
  return JSON.parse(decodeURIComponent(escape(window.atob(segments[1]))));
};

var isIE11 = function isIE11() {
  return !!window.MSInputMethodContext && !!document.documentMode;
};

var testMobileDevice = function testMobileDevice() {
  return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  );
};

/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AfH1_vue__ = __webpack_require__(270);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c9b0ea28_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AfH1_vue__ = __webpack_require__(718);
function injectStyle (ssrContext) {
  __webpack_require__(717)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c9b0ea28"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AfH1_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c9b0ea28_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AfH1_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExternalLink_vue__ = __webpack_require__(219);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31988abe_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExternalLink_vue__ = __webpack_require__(570);
function injectStyle (ssrContext) {
  __webpack_require__(569)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31988abe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExternalLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31988abe_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExternalLink_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 77 */,
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AfH4_vue__ = __webpack_require__(241);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf0e5aec_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AfH4_vue__ = __webpack_require__(630);
function injectStyle (ssrContext) {
  __webpack_require__(629)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cf0e5aec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AfH4_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf0e5aec_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AfH4_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var docCookies = {
  getItem: function getItem(sKey) {
    if (!sKey) {
      return null;
    }
    return decodeURIComponent(document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*' + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1')) || null;
  },
  setItem: function setItem(sKey, sValue, vEnd, sPath, sDomain, bSecure) {
    if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
      return false;
    }
    var sExpires = '';
    if (vEnd) {
      switch (vEnd.constructor) {
        case Number:
          sExpires = vEnd === Infinity ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT' : '; max-age=' + vEnd;

          break;
        case String:
          sExpires = '; expires=' + vEnd;
          break;
        case Date:
          sExpires = '; expires=' + vEnd.toUTCString();
          break;
      }
    }
    document.cookie = encodeURIComponent(sKey) + '=' + encodeURIComponent(sValue) + sExpires + (sDomain ? '; domain=' + sDomain : '') + (sPath ? '; path=' + sPath : '') + (bSecure ? '; secure' : '');
    return true;
  },
  removeItem: function removeItem(sKey, sPath, sDomain) {
    if (!this.hasItem(sKey)) {
      return false;
    }
    document.cookie = encodeURIComponent(sKey) + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT' + (sDomain ? '; domain=' + sDomain : '') + (sPath ? '; path=' + sPath : '');
    return true;
  },
  hasItem: function hasItem(sKey) {
    if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
      return false;
    }
    return new RegExp('(?:^|;\\s*)' + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=').test(document.cookie);
  },
  keys: function keys() {
    var aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, '').split(/\s*(?:\=[^;]*)?;\s*/);
    for (var nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) {
      aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]);
    }
    return aKeys;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (docCookies);

/***/ }),
/* 111 */,
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AfSpinner_vue__ = __webpack_require__(244);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23e902f4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AfSpinner_vue__ = __webpack_require__(635);
function injectStyle (ssrContext) {
  __webpack_require__(634)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-23e902f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AfSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23e902f4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AfSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchDropdown_vue__ = __webpack_require__(245);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee4503ac_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchDropdown_vue__ = __webpack_require__(637);
function injectStyle (ssrContext) {
  __webpack_require__(636)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ee4503ac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee4503ac_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AfCheckbox_vue__ = __webpack_require__(250);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04adb52e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AfCheckbox_vue__ = __webpack_require__(648);
function injectStyle (ssrContext) {
  __webpack_require__(647)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-04adb52e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AfCheckbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04adb52e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AfCheckbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchLocalSearch_vue__ = __webpack_require__(251);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c159ce6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchLocalSearch_vue__ = __webpack_require__(651);
function injectStyle (ssrContext) {
  __webpack_require__(650)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c159ce6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchLocalSearch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c159ce6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchLocalSearch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchClear_vue__ = __webpack_require__(252);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbd60a9c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchClear_vue__ = __webpack_require__(653);
function injectStyle (ssrContext) {
  __webpack_require__(652)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dbd60a9c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchClear_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbd60a9c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchClear_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumbs_vue__ = __webpack_require__(282);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11c3f305_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumbs_vue__ = __webpack_require__(752);
function injectStyle (ssrContext) {
  __webpack_require__(751)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11c3f305"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumbs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11c3f305_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumbs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AfExpansionPanel_vue__ = __webpack_require__(249);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_494aacce_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AfExpansionPanel_vue__ = __webpack_require__(649);
function injectStyle (ssrContext) {
  __webpack_require__(646)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-494aacce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AfExpansionPanel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_494aacce_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AfExpansionPanel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AfLink_vue__ = __webpack_require__(258);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8355073e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AfLink_vue__ = __webpack_require__(669);
function injectStyle (ssrContext) {
  __webpack_require__(668)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8355073e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AfLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8355073e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AfLink_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var icons = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val) {
          if (!(val in icons)) {
            console.warn('Invalid prop: prop "name" is referring to an unregistered icon "' + val + '".' + '\nPlesase make sure you have imported this icon before using it.');
            return false;
          }
          return true;
        }
        console.warn('Invalid prop: prop "name" is required.');
        return false;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        console.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    klass: function klass() {
      return {
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      };
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    },
    raw: function raw() {
      if (!this.icon || !this.icon.raw) {
        return null;
      }
      var raw = this.icon.raw;
      var ids = {};
      raw = raw.replace(/\s(?:xml:)?id=["']?([^"')\s]+)/g, function (match, id) {
        var uniqueId = getId();
        ids[id] = uniqueId;
        return ' id="' + uniqueId + '"';
      });
      raw = raw.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (match, rawId, _, pointerId) {
        var id = rawId || pointerId;
        if (!id || !ids[id]) {
          return match;
        }

        return '#' + ids[id];
      });

      return raw;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.icon) {
      return;
    }
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;
    });
    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

var cursor = 0xd4937;
function getId() {
  return 'fa-' + (cursor++).toString(16);
}

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_App_AppHeader__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_App_AppFooter__ = __webpack_require__(575);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_0__components_App_AppHeader__["a" /* default */],
    AppFooter: __WEBPACK_IMPORTED_MODULE_1__components_App_AppFooter__["a" /* default */]
  },

  data: function data() {
    return {
      whiteBackground: false
    };
  },
  mounted: function mounted() {
    this.hasWhiteBackground();
  },


  watch: {
    $route: function $route() {
      this.hasWhiteBackground();
    }
  },

  methods: {
    hasWhiteBackground: function hasWhiteBackground() {
      var pages = ['/', '/arbetsgivarinformation', '/kontakta-oss', '/om-jobskills'];

      this.whiteBackground = pages.includes(window.location.pathname);
    }
  }
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Button_Button__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ExternalLink__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AfSidemenu__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_helpers__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_actionTypes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_cookies__ = __webpack_require__(110);












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AppHeader',
  components: {
    'af-button': __WEBPACK_IMPORTED_MODULE_1__components_Button_Button__["a" /* default */],
    'af-sidemenu': __WEBPACK_IMPORTED_MODULE_4__components_AfSidemenu__["a" /* default */],
    Icon: __WEBPACK_IMPORTED_MODULE_2__components_Icon__["a" /* default */],
    ExternalLink: __WEBPACK_IMPORTED_MODULE_3__components_ExternalLink__["a" /* default */]
  },
  data: function data() {
    return {
      jobskillsURL: window.__JOBSKILLS_URL__,
      baseURL: window.__BASE_URL__,
      sidebarOpen: false,
      sidebarLoading: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(['loggedIn', 'hasPermissionUserEmailBatches', 'hasPermissionUnlimitedSearch'])),
  created: function created() {
    this.verifyToken();
  },

  methods: {
    logout: function logout() {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_7__store_actionTypes__["k" /* LOG_OUT */]);
      __WEBPACK_IMPORTED_MODULE_8__utils_cookies__["a" /* default */].removeItem('search-token');
      this.$router.push('/logged-out');
    },
    login: function login() {
      window.location.href = __API_URL__ + 'auth/saml?returnUrl=' + __BASE_URL__ + 'sok';
    },
    toggleSidebarOpen: function toggleSidebarOpen() {
      this.sidebarOpen = !this.sidebarOpen;
      this.sidebarLoading = false;
    },
    verifyToken: function verifyToken() {
      if (!this.loggedIn && !__WEBPACK_IMPORTED_MODULE_8__utils_cookies__["a" /* default */].hasItem('search-token')) {
        return;
      }
      if (!__WEBPACK_IMPORTED_MODULE_8__utils_cookies__["a" /* default */].hasItem('search-token')) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_7__store_actionTypes__["k" /* LOG_OUT */]);
        this.$router.push('/');
        return;
      }

      var token = __WEBPACK_IMPORTED_MODULE_8__utils_cookies__["a" /* default */].getItem('search-token');
      var tokenExpire = Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["b" /* deconstructJWT */])(token).exp * 1000;

      if (Date.now() > tokenExpire) {
        __WEBPACK_IMPORTED_MODULE_8__utils_cookies__["a" /* default */].removeItem('search-token');
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_7__store_actionTypes__["k" /* LOG_OUT */]);
        this.$router.push('/');
      } else {
        var timeUntilExpire = tokenExpire - Date.now();
        setTimeout(this.verifyToken, timeUntilExpire);
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_7__store_actionTypes__["j" /* LOG_IN */]);
      }
    }
  }
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'af-button',
  props: {
    disabled: Boolean,
    lowercase: Boolean,
    size: String,
    buttonStyle: {
      default: 'default',
      type: String
    },
    type: {
      default: 'button',
      type: String
    }
  },
  methods: {
    handleClick: function handleClick() {
      this.$emit('clicked');
    }
  }
});

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Icon',

  props: {
    link: {
      required: false,
      type: Boolean
    },
    fill: {
      default: 'black',
      required: false,
      type: String
    },
    size: {
      default: 20,
      type: Number
    },
    spin: {
      required: false,
      type: Boolean
    },
    type: {
      required: true,
      type: String
    }
  },

  computed: {
    fillColor: function fillColor() {
      if (this.link) {
        return "rgb(19, 118, 157)";
      } else {
        return this.fill;
      }
    }
  }
});

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_0__components_Icon__["a" /* default */]
  },
  name: 'External-Link',
  props: {
    href: {
      required: true,
      type: String
    },
    inline: {
      required: false,
      type: Boolean
    }
  }
});

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'af-sidemenu',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_0__components_Icon__["a" /* default */]
  },
  data: function data() {
    return {
      jobskillsURL: window.__JOBSKILLS_URL__
    };
  },

  methods: {
    handleClick: function handleClick() {
      this.$emit('clicked');
    }
  }
});

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Button_Button__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Share__ = __webpack_require__(577);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AppFooter',
  components: {
    Button: __WEBPACK_IMPORTED_MODULE_1__components_Button_Button__["a" /* default */],
    Icon: __WEBPACK_IMPORTED_MODULE_0__components_Icon__["a" /* default */],
    'af-share': __WEBPACK_IMPORTED_MODULE_2__components_Share__["a" /* default */]
  },
  data: function data() {
    return {
      jobskillsURL: window.__JOBSKILLS_URL__,
      baseURL: window.__BASE_URL__
    };
  }
});

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'af-share',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_0__components_Icon__["a" /* default */]
  },

  data: function data() {
    return {
      jobskillsURL: window.__JOBSKILLS_URL__,
      baseURL: window.__BASE_URL__,
      shareOptions: [{
        link: 'mailto:?body=' + window.__BASE_URL__,
        iconType: 'envelope'
      }, {
        link: 'http://www.facebook.com/sharer.php?u=' + window.__BASE_URL__,
        iconType: 'facebook-f'
      }, {
        link: 'https://twitter.com/intent/tweet?text=' + window.__BASE_URL__,
        iconType: 'twitter'
      }, {
        link: 'https://www.linkedin.com/shareArticle?mini=true&url=' + window.__BASE_URL__,
        iconType: 'linkedin'
      }]
    };
  }
});

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SearchField__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SearchResults__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AfInformationBox__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AfH1__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SearchScrollToTop__ = __webpack_require__(719);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Search',
  components: {
    AfH1: __WEBPACK_IMPORTED_MODULE_3__components_AfH1__["a" /* default */],
    AfInformationBox: __WEBPACK_IMPORTED_MODULE_2__components_AfInformationBox__["a" /* default */],
    SearchField: __WEBPACK_IMPORTED_MODULE_0__SearchField__["a" /* default */],
    SearchResults: __WEBPACK_IMPORTED_MODULE_1__SearchResults__["a" /* default */],
    SearchScrollToTop: __WEBPACK_IMPORTED_MODULE_4__SearchScrollToTop__["a" /* default */]
  }
});

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SearchFieldInput__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SearchLocations__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SearchButton__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SearchFieldResults__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SearchTabs__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SearchTags__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_AfH3__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_graphql_tag__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_tagHelpers__ = __webpack_require__(693);




var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n        query SearchFields($language: LanguageCode) {\n          workgroups(language: $language, path: "*") {\n            name\n            path\n          }\n          professions(language: $language, path: "*") {\n            ...LeafNode\n          }\n          competences(language: $language, path: "*") {\n            ...LeafNode\n          }\n        }\n\n        fragment LeafNode on TaxonomyLeafNode {\n          name\n          path\n        }\n      '], ['\n        query SearchFields($language: LanguageCode) {\n          workgroups(language: $language, path: "*") {\n            name\n            path\n          }\n          professions(language: $language, path: "*") {\n            ...LeafNode\n          }\n          competences(language: $language, path: "*") {\n            ...LeafNode\n          }\n        }\n\n        fragment LeafNode on TaxonomyLeafNode {\n          name\n          path\n        }\n      ']);












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SearchField',
  components: {
    AfH3: __WEBPACK_IMPORTED_MODULE_10__components_AfH3__["a" /* default */],
    SearchFieldInput: __WEBPACK_IMPORTED_MODULE_4__SearchFieldInput__["a" /* default */],
    SearchLocations: __WEBPACK_IMPORTED_MODULE_5__SearchLocations__["a" /* default */],
    SearchFieldResults: __WEBPACK_IMPORTED_MODULE_7__SearchFieldResults__["a" /* default */],
    SearchTabs: __WEBPACK_IMPORTED_MODULE_8__SearchTabs__["a" /* default */],
    SearchTags: __WEBPACK_IMPORTED_MODULE_9__SearchTags__["a" /* default */],
    SearchButton: __WEBPACK_IMPORTED_MODULE_6__SearchButton__["a" /* default */]
  },

  data: function data() {
    return {
      hideTabs: true,
      query: '',
      workgroups: [],
      professions: [],
      competences: [],
      filteredCompetences: [],
      filteredProfessions: [],
      searchFieldsLoading: 0
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapState */])({
    searchQuery: function searchQuery(state) {
      return state.query;
    },
    skip: function skip(state) {
      return state.skip;
    }
  }), {
    formatTags: function formatTags() {
      if (this.searchQuery && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.searchQuery).length > 0) {
        return Object(__WEBPACK_IMPORTED_MODULE_12__utils_tagHelpers__["a" /* formatSearchTags */])(this.searchQuery);
      }

      return [];
    },
    hasQuery: function hasQuery() {
      return this.query.length > 0;
    }
  }),

  apollo: {
    searchData: {
      query: __WEBPACK_IMPORTED_MODULE_11_graphql_tag___default()(_templateObject),
      loadingKey: 'searchFieldsLoading',
      variables: function variables() {
        return {
          language: 'sv'
        };
      },
      update: function update(_ref) {
        var workgroups = _ref.workgroups,
            professions = _ref.professions,
            competences = _ref.competences;

        this.workgroups = workgroups;
        this.professions = professions;
        this.competences = competences;

        if (this.hasQuery) {
          this.filterSearch(this.query);
        }
      }
    }
  },

  methods: {
    resetSearchResults: function resetSearchResults() {
      this.query = '';
    },
    filterList: function filterList(list, query) {
      return list.reduce(function (acc, curr) {
        return acc.concat(curr);
      }, []).filter(function (item) {
        return item.name.toLowerCase().includes(query.toLowerCase());
      }).slice(0, 10).map(function (item) {
        var queryRegEx = new RegExp('(' + query + ')', 'ig');

        var splitPath = item.path.split('.');
        var found = '';
        if (splitPath.length === 3) {
          var parentPath = splitPath.slice(0, 2).join('.');

          list[0].find(function (item) {
            if (item.path === parentPath) {
              return found = item.name;
            }
          });
        }
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, item, {
          searchName: item.name.replace(queryRegEx, '<strong>$1</strong>'),
          parentName: found
        });
      });
    },
    filterSearch: function filterSearch(query) {
      this.filteredProfessions = this.filterList([this.workgroups, this.professions], query);
      this.filteredCompetences = this.filterList([this.competences], query);
    }
  }
});

/***/ }),
/* 225 */,
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchFieldInput_vue__ = __webpack_require__(227);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1be27f4a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchFieldInput_vue__ = __webpack_require__(599);
function injectStyle (ssrContext) {
  __webpack_require__(596)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1be27f4a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchFieldInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1be27f4a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchFieldInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AfH2__ = __webpack_require__(47);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SearchFieldInput',
  components: {
    AfH2: __WEBPACK_IMPORTED_MODULE_0__components_AfH2__["a" /* default */]
  },

  props: {
    label: {
      required: true,
      type: String
    },
    name: {
      required: true,
      type: String
    },
    placeholder: String,
    value: {
      required: true,
      type: String
    }
  },

  methods: {
    handleBlur: function handleBlur() {
      this.$emit('onBlur');
    },
    handleFocus: function handleFocus() {
      this.$emit('onFocus');
    },
    handleChange: function handleChange(event) {
      this.$emit('update:value', event.target.value);
    }
  }
});

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AfH2',
  props: {
    noMarginTop: {
      type: Boolean
    }
  }
});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SearchFieldInput__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_actionTypes__ = __webpack_require__(13);




var _templateObject = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n        query getCounties {\n          counties {\n            name\n            path\n            municipalities {\n              path\n              name\n            }\n          }\n        }\n      '], ['\n        query getCounties {\n          counties {\n            name\n            path\n            municipalities {\n              path\n              name\n            }\n          }\n        }\n      ']);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SearchLocations',
  components: {
    SearchFieldInput: __WEBPACK_IMPORTED_MODULE_3__SearchFieldInput__["a" /* default */]
  },

  data: function data() {
    return {
      city: '',
      foundCities: []
    };
  },


  computed: {
    hasFoundCities: function hasFoundCities() {
      return this.foundCities.length > 0 && this.city.length > 0;
    },
    noResults: function noResults() {
      return this.foundCities.length === 0 && this.city.length > 0;
    },
    displayDropdown: function displayDropdown() {
      return this.hasFoundCities || this.noResults;
    }
  },

  apollo: {
    counties: {
      query: __WEBPACK_IMPORTED_MODULE_4_graphql_tag___default()(_templateObject)
    }
  },

  methods: {
    clearSearch: function clearSearch() {
      this.city = '';
      this.foundCities = [];
    },
    findCity: function findCity() {
      var _this = this;

      if (!this.counties) {
        return;
      }

      this.foundCities = this.counties.map(function (county) {
        return [{
          name: county.name,
          path: county.path,
          __typename: county.__typename
        }].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(county.municipalities));
      }).reduce(function (acc, curr) {
        return acc.concat(curr);
      }, []).filter(function (_ref) {
        var name = _ref.name;

        return name.toLowerCase().includes(_this.city.toLowerCase());
      }).sort(function (a) {
        if (a.__typename === 'Municipality') {
          return -1;
        }
        return 1;
      });
    },
    addLocation: function addLocation(_ref2) {
      var name = _ref2.name,
          path = _ref2.path;

      var payload = { name: name, path: path };

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_actionTypes__["d" /* ADD_TO_QUERY */], {
        payload: payload,
        type: 'city'
      });

      window.eventBus.$emit('openExpansionPanel', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, payload, { type: 'city' }));

      this.clearSearch();
    }
  }
});

/***/ }),
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_actionTypes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(18);





var _templateObject = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n        query Search(\n          $input: SearchInput!\n          $sort: SortOrder\n          $skip: Int\n        ) {\n          search(input: $input, sort: $sort, skip: $skip) {\n            hits {\n              city\n              id\n              matches {\n                isMatch\n                text\n                type\n                years\n              }\n            }\n            total\n          }\n        }\n      '], ['\n        query Search(\n          $input: SearchInput!\n          $sort: SortOrder\n          $skip: Int\n        ) {\n          search(input: $input, sort: $sort, skip: $skip) {\n            hits {\n              city\n              id\n              matches {\n                isMatch\n                text\n                type\n                years\n              }\n            }\n            total\n          }\n        }\n      ']);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SearchButton',

  data: function data() {
    return {
      searchVariables: {}
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapState */])({
    searchQuery: function searchQuery(state) {
      return state.query;
    },
    skip: function skip(state) {
      return state.skip;
    },
    sort: function sort(state) {
      return state.sort;
    }
  })),

  watch: {
    searchQuery: {
      handler: function handler() {
        this.watchQueryHandler();
      },
      deep: true
    },
    skip: {
      handler: function handler() {
        this.handleSearch();
      }
    },
    sort: {
      handler: function handler() {
        this.handleSearch();
      }
    }
  },

  apollo: {
    search: {
      query: __WEBPACK_IMPORTED_MODULE_4_graphql_tag___default()(_templateObject),
      fetchPolicy: 'network-only',
      skip: function skip() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.searchVariables).length === 0;
      },
      variables: function variables() {
        return {
          input: this.searchVariables,
          skip: this.skip,
          sort: this.sort
        };
      },
      update: function update(_ref) {
        var search = _ref.search;

        this.handleSearchResults(search);
      },
      error: function error(_error) {
        this.handleError(_error);
      }
    }
  },

  methods: {
    handleSearch: function handleSearch() {
      var input = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.searchQuery, {
        city: this.searchQuery.city.map(function (c) {
          return c.path;
        }).filter(Boolean),
        educations: this.searchQuery.educations.map(function (e) {
          var eCopy = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, e);

          delete eCopy.name;
          delete eCopy.path;

          return eCopy;
        })
      });

      this.searchVariables = input;
    },
    handleSearchResults: function handleSearchResults(search) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_actionTypes__["s" /* SET_RESULTS */], search);
    },
    handleError: function handleError(error) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_actionTypes__["t" /* SET_RESULT_ERROR */], error);
    },
    watchQueryHandler: function watchQueryHandler() {
      var hasNoQuery = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.searchQuery).filter(function (category) {
        return category.length;
      }).length === 0;
      if (hasNoQuery) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_actionTypes__["r" /* SET_NO_RESULTS */]);
        return;
      }
      this.handleSearch();
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_actionTypes__["u" /* SET_SKIP */], 1);
    }
  }
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AfH4__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AfRange__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AfSpinner__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Button_Button__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Search_SearchDropdown__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_actionTypes__ = __webpack_require__(13);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SearchFieldResults',

  props: {
    competences: Array,
    professions: Array,
    isLoading: Number,
    query: String
  },

  components: {
    AfH4: __WEBPACK_IMPORTED_MODULE_1__components_AfH4__["a" /* default */],
    'af-button': __WEBPACK_IMPORTED_MODULE_4__components_Button_Button__["a" /* default */],
    AfRange: __WEBPACK_IMPORTED_MODULE_2__components_AfRange__["a" /* default */],
    AfSpinner: __WEBPACK_IMPORTED_MODULE_3__components_AfSpinner__["a" /* default */],
    SearchDropdown: __WEBPACK_IMPORTED_MODULE_5__views_Search_SearchDropdown__["a" /* default */]
  },

  data: function data() {
    return {
      expanded: [],
      expandedDropdown: [],
      years: [{
        name: 'Minst någon erfarenhet',
        path: 0
      }, {
        name: 'Minst 1 års erfarenhet',
        path: 1
      }, {
        name: 'Minst 2 års erfarenhet',
        path: 2
      }, {
        name: 'Minst 5 års erfarenhet',
        path: 5
      }]
    };
  },


  computed: {
    hasCompetences: function hasCompetences() {
      return this.competences.length > 0;
    },
    hasProfessions: function hasProfessions() {
      return this.professions.length > 0;
    },
    noResults: function noResults() {
      return this.professions.length === 0 && this.competences.length === 0 && this.query.length > 0 && this.isLoading !== 1;
    },
    displayOverlay: function displayOverlay() {
      return this.hasCompetences || this.hasProfessions || this.noResults;
    }
  },

  methods: {
    sliderState: function sliderState(path) {
      if (this.expanded.includes(path)) {
        return true;
      }

      return false;
    },
    dropdownState: function dropdownState(path) {
      if (this.expandedDropdown.includes(path)) {
        return true;
      }

      return false;
    },
    toggleSlider: function toggleSlider(_ref) {
      var path = _ref.path;

      if (this.expanded.includes(path)) {
        return this.expanded.splice(this.expanded.indexOf(path), 1);
      }

      this.expanded.push(path);
    },
    toggleDropdown: function toggleDropdown(_ref2) {
      var path = _ref2.path;

      if (this.expandedDropdown.includes(path)) {
        return this.expandedDropdown.splice(this.expandedDropdown.indexOf(path), 1);
      }

      this.expandedDropdown.push(path);
    },
    addProfession: function addProfession(professionPayload, _ref3) {
      var name = _ref3.name,
          path = _ref3.path;

      var gt = parseInt(professionPayload[0].years, 10);
      var lt = parseInt(professionPayload[1].years, 10);
      var years = [{
        modifier: 'gte',
        years: gt
      }];

      if (lt !== 10) {
        years = years.concat([{
          modifier: 'lte',
          years: lt
        }]);
      }

      var payload = {
        years: years,
        path: path,
        name: name
      };

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_6__store_actionTypes__["d" /* ADD_TO_QUERY */], {
        payload: payload,
        type: 'experiences'
      });

      window.eventBus.$emit('openExpansionPanel', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, payload, {
        type: 'experiences'
      }));

      this.searchDone();
    },
    addCompetence: function addCompetence(minYears, _ref4) {
      var name = _ref4.name,
          path = _ref4.path;

      var years = [{
        modifier: 'gte',
        years: minYears.path
      }];

      var payload = {
        years: years,
        path: path,
        name: name
      };

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_6__store_actionTypes__["d" /* ADD_TO_QUERY */], {
        payload: payload,
        type: 'skills'
      });

      window.eventBus.$emit('openExpansionPanel', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, payload, {
        type: 'skills'
      }));

      this.searchDone();
    },
    searchDone: function searchDone() {
      this.$emit('searchDone');
    }
  }
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Afh4'
});

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AfRange_vue__ = __webpack_require__(243);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f83963c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AfRange_vue__ = __webpack_require__(633);
function injectStyle (ssrContext) {
  __webpack_require__(631)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AfRange_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f83963c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AfRange_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nouislider__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nouislider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_nouislider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AfH4__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Button_Button__ = __webpack_require__(52);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'nouislider',

  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_2__components_Icon__["a" /* default */],
    AfButton: __WEBPACK_IMPORTED_MODULE_4__components_Button_Button__["a" /* default */],
    AfH4: __WEBPACK_IMPORTED_MODULE_3__components_AfH4__["a" /* default */]
  },

  props: {
    showButton: Boolean,
    config: {
      type: Object,
      required: true
    },
    values: {
      type: Array,
      required: true
    },
    id: {
      type: String,
      required: false
    }
  },

  data: function data() {
    return {
      slider: null,
      maxValue: 0,
      minValue: 0,
      initValues: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.minValue = this.values[0];
    this.maxValue = this.values[1];
    this.initValues = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.values));

    this.slider = document.getElementById(this.sliderId);
    this.config.start = this.values.map(function (value) {
      return parseInt(value, 10);
    });
    __WEBPACK_IMPORTED_MODULE_1_nouislider___default.a.create(this.slider, this.config);

    this.slider.noUiSlider.on('update', this.updateValue);

    this.slider.noUiSlider.on('change', function (newValues) {
      _this.$emit('newValueSet', newValues);
    });
  },


  computed: {
    sliderId: function sliderId() {
      return this.id === undefined ? this.uniqueId() : this.id;
    },
    isMaxValue: function isMaxValue() {
      return parseInt(this.maxValue, 10) === this.config.range.max[0];
    },
    isMinValue: function isMinValue() {
      return parseInt(this.minValue, 10) === this.config.range.min[0];
    }
  },

  methods: {
    updateValue: function updateValue(value, handle) {
      this.$set(this.values, handle, value[handle]);
      this.minValue = parseInt(value[0], 10);
      this.maxValue = parseInt(value[1], 10);
    },

    uniqueId: function uniqueId() {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
      }
      return 'vue-nouislider-' + s4() + s4();
    },

    click: function click(min, max) {
      var years = [{
        modifier: 'gt',
        years: min
      }, {
        modifier: 'lt',
        years: max
      }];

      this.$emit('clickedSliderButton', years);
    }
  }
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'af-spinner',

  props: {
    size: {
      default: 78,
      type: Number
    },
    margin: {
      default: 60,
      type: Number
    }
  }
});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SearchDropdown',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_0__components_Icon__["a" /* default */]
  },
  props: {
    oneLine: { default: false, type: Boolean },
    options: { default: [], type: Array },
    placeholder: String,
    inlinePlaceholder: {
      default: '',
      type: String
    },
    disabled: { default: false, type: Boolean },
    name: String,
    selector: { default: 'name', type: String },
    value: { default: null }
  },
  data: function data() {
    return {
      arrowSelected: null,
      open: false
    };
  },
  mounted: function mounted() {
    document.addEventListener('click', this.closeList);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('click', this.closeList);
  },

  computed: {
    getValue: function getValue() {
      var _this = this;

      if (this.options) {
        var found = this.options.find(function (_ref) {
          var path = _ref.path;
          return path === _this.value;
        });
        return found && found.name || '';
      }

      return null;
    },
    displayList: function displayList() {
      return this.open && this.options && this.options.length;
    },
    filteredOptions: function filteredOptions() {
      if (this.options.length) {
        return this.options;
      }
    }
  },
  methods: {
    arrowDown: function arrowDown() {
      if (this.arrowSelected === null) {
        this.arrowSelected = 0;
        return;
      }

      if (this.filteredOptions && this.arrowSelected >= this.filteredOptions.length - 1) {
        return;
      }

      if (this.arrowSelected >= 2) {
        this.$refs.results.scrollTop += this.$refs.resultItem[this.arrowSelected].offsetHeight;
      }

      this.arrowSelected += 1;
    },
    arrowUp: function arrowUp() {
      if (this.arrowSelected === null) {
        return;
      }

      if (this.arrowSelected === -1) {
        this.arrowSelected = null;
        return;
      }

      if (this.arrowSelected >= 2) {
        this.$refs.results.scrollTop -= this.$refs.resultItem[this.arrowSelected].offsetHeight;
      }

      this.arrowSelected -= 1;
    },
    arrowSelect: function arrowSelect() {
      var _this2 = this;

      if (this.arrowSelected === null) {
        var option = this.filteredOptions.filter(function (_ref2) {
          var path = _ref2.path;
          return path === _this2.value;
        })[0];
        this.setOption(option);
        return;
      }

      this.setOption(this.filteredOptions[this.arrowSelected]);
    },
    setOption: function setOption(option) {
      this.arrowSelected = null;
      this.open = false;
      this.$emit('changed', option);
    },
    emitChange: function emitChange(value) {
      this.$emit('inputChange', value);
    },
    openList: function openList() {
      if (this.disabled) {
        return false;
      }
      this.open = true;
    },
    closeList: function closeList() {
      this.open = false;
    }
  }
});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SearchTab__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SearchExperiences__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SearchCompetences__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SearchAsylumStatus__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SearchEducation__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SearchLanguages__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SearchLocation__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_actionTypes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_helpers__ = __webpack_require__(53);














/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SearchTabs',
  components: {
    SearchExperiences: __WEBPACK_IMPORTED_MODULE_2__SearchExperiences__["a" /* default */],
    SearchTab: __WEBPACK_IMPORTED_MODULE_1__SearchTab__["a" /* default */],
    SearchCompetences: __WEBPACK_IMPORTED_MODULE_3__SearchCompetences__["a" /* default */],
    SearchAsylumStatus: __WEBPACK_IMPORTED_MODULE_4__SearchAsylumStatus__["a" /* default */],
    SearchEducation: __WEBPACK_IMPORTED_MODULE_5__SearchEducation__["a" /* default */],
    SearchLanguages: __WEBPACK_IMPORTED_MODULE_6__SearchLanguages__["a" /* default */],
    SearchLocation: __WEBPACK_IMPORTED_MODULE_7__SearchLocation__["a" /* default */]
  },

  props: {
    hideTabs: Boolean
  },

  data: function data() {
    return {
      tabs: [{ name: 'experiences', title: 'Yrke' }, { name: 'skills', title: 'Kompetens' }, { name: 'languages', title: 'Språk' }, { name: 'asylumStatus', title: 'Arbetsstatus' }, { name: 'educations', title: 'Utbildning' }, { name: 'city', title: 'Område' }],
      isMobile: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapState */])(['activeTab'])),

  methods: {
    setActiveTab: function setActiveTab(activeTab) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_9__store_actionTypes__["p" /* SET_ACTIVE_TAB */], activeTab);
    }
  },

  mounted: function mounted() {
    this.isMobile = Object(__WEBPACK_IMPORTED_MODULE_10__utils_helpers__["f" /* testMobileDevice */])();
  }
});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SearchTab',

  props: {
    activeTab: {
      required: true,
      type: String
    },
    tabName: {
      required: true,
      type: String
    }
  },

  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_0__components_Icon__["a" /* default */]
  },

  computed: {
    numberOfSelectedItems: function numberOfSelectedItems() {
      return this.$store.getters.getQueryType(this.tabName);
    },
    hasSelectedItems: function hasSelectedItems() {
      return this.numberOfSelectedItems > 0;
    },
    isActive: function isActive() {
      return this.activeTab === this.tabName;
    },
    isInactive: function isInactive() {
      return this.activeTab !== '' && this.activeTab !== this.tabName;
    },
    portalName: function portalName() {
      return 'mobile-' + this.tabName;
    }
  },

  methods: {
    setActiveTab: function setActiveTab() {
      this.$emit('activeTab', this.tabName);
      window.eventBus.$emit('close-all-boxes');
    }
  }
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AfExpansionPanel__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AfSpinner__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SearchLocalSearch__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SearchClear__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_AfH3__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_actionTypes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex__ = __webpack_require__(18);





var _templateObject = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n        query WorkExperiences($language: LanguageCode) {\n          workareas(language: $language) {\n            name\n            path\n          }\n          workgroups(language: $language, path: "*") {\n            name\n            path\n          }\n          professions(language: $language, path: "*") {\n            name\n            path\n          }\n        }\n      '], ['\n        query WorkExperiences($language: LanguageCode) {\n          workareas(language: $language) {\n            name\n            path\n          }\n          workgroups(language: $language, path: "*") {\n            name\n            path\n          }\n          professions(language: $language, path: "*") {\n            name\n            path\n          }\n        }\n      ']);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SearchExperiences',
  components: {
    AfH3: __WEBPACK_IMPORTED_MODULE_9__components_AfH3__["a" /* default */],
    AfExpansionPanel: __WEBPACK_IMPORTED_MODULE_5__components_AfExpansionPanel__["a" /* default */],
    AfSpinner: __WEBPACK_IMPORTED_MODULE_6__components_AfSpinner__["a" /* default */],
    SearchClear: __WEBPACK_IMPORTED_MODULE_8__SearchClear__["a" /* default */],
    SearchLocalSearch: __WEBPACK_IMPORTED_MODULE_7__SearchLocalSearch__["a" /* default */]
  },

  data: function data() {
    return {
      searchList: [],
      loading: 0
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_11_vuex__["c" /* mapState */])({
    tree: function tree(state) {
      return state.tree.experiences;
    },
    experiences: function experiences(state) {
      return state.query.experiences;
    }
  })),

  mounted: function mounted() {
    if (this.experiences.length > 0) {
      this.experiences.forEach(function (experience) {
        window.eventBus.$emit('openExpansionPanel', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, experience, {
          type: 'experiences'
        }));
      });
    }
  },


  apollo: {
    experienceData: {
      query: __WEBPACK_IMPORTED_MODULE_4_graphql_tag___default()(_templateObject),
      fetchPolicy: 'cache-and-network',
      loadingKey: 'loading',
      variables: function variables() {
        return {
          language: 'sv'
        };
      },
      skip: function skip() {
        return this.tree.columnOne.length > 0;
      },
      update: function update(_ref) {
        var workareas = _ref.workareas,
            workgroups = _ref.workgroups,
            professions = _ref.professions;

        this.searchList = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(workareas), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(workgroups), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(professions));
        this.buildRecursiveStructure(workareas, workgroups, professions);
      }
    }
  },

  methods: {
    buildRecursiveStructure: function buildRecursiveStructure(workareas, workgroups, professions) {
      if (workareas.length === 0 || this.tree.columnOne.length > 0) {
        return;
      }

      var recursive = workareas.map(function (area) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, area, {
          children: workgroups.filter(function (group) {
            return area.path === group.path.split('.')[0];
          }).map(function (group) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, group, {
              children: professions.filter(function (prof) {
                return group.path === prof.path.split('.').slice(0, 2).join('.');
              }).map(function (prof) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()(prof);
              })
            }));
          })
        }));
      });

      var split = Math.ceil(recursive.length / 3);

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_10__store_actionTypes__["w" /* UPDATE_TAB_COLUMN */], {
        payload: {
          columnOne: recursive.slice(0, split),
          columnTwo: recursive.slice(split, split * 2),
          columnThree: recursive.slice(split * 2, split * 3)
        },
        type: 'experiences'
      });
    }
  }
});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AfCheckbox__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AfRange__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AfH4__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Search_SearchDropdown__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_actionTypes__ = __webpack_require__(13);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AfExpansionPanel',
  components: {
    AfCheckbox: __WEBPACK_IMPORTED_MODULE_2__components_AfCheckbox__["a" /* default */],
    AfRange: __WEBPACK_IMPORTED_MODULE_3__components_AfRange__["a" /* default */],
    Icon: __WEBPACK_IMPORTED_MODULE_1__components_Icon__["a" /* default */],
    SearchDropdown: __WEBPACK_IMPORTED_MODULE_5__views_Search_SearchDropdown__["a" /* default */],
    AfH4: __WEBPACK_IMPORTED_MODULE_4__components_AfH4__["a" /* default */]
  },

  props: {
    level: {
      default: 1,
      type: Number
    },
    model: Object,
    queryType: String
  },

  data: function data() {
    return {
      parent: this.model.parent || 'container',
      name: this.model.name,
      path: this.model.path,
      children: [],
      status: 'unchecked',
      years: 0,

      rangeMin: 0,
      rangeMax: 10,

      expanded: false,
      skillYears: [{
        name: 'Minst någon erfarenhet',
        path: 0
      }, {
        name: 'Minst 1 års erfarenhet',
        path: 1
      }, {
        name: 'Minst 2 års erfarenhet',
        path: 2
      }, {
        name: 'Minst 5 års erfarenhet',
        path: 5
      }],
      modifier: 'gte'
    };
  },
  created: function created() {
    var model = this.model;

    if (model.children) {
      this.children = model.children.map(function (child) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, child, {
          status: 'unchecked',
          parent: model.path
        });
      });
    }
  },
  mounted: function mounted() {
    window.eventBus.$on('RESET_QUERY', this.resetQuery);

    window.eventBus.$on('upside', this.handleUpside);

    window.eventBus.$on('downside', this.handleDownside);

    window.eventBus.$on('openExpansionPanel', this.handleLocalAndGlobalSearch);

    window.eventBus.$on('close-all-boxes', this.closePanel);

    window.eventBus.$on('removeTag', this.handleRemoveTag);

    window.eventBus.$on('clearLocal', this.handleClearLocal);

    window.eventBus.$on('searchRecommended', this.handleSearchRecommended);
  },
  beforeDestroy: function beforeDestroy() {
    window.eventBus.$off();
  },


  computed: {
    allChildrenChecked: function allChildrenChecked() {
      return this.children.every(function (_ref) {
        var status = _ref.status;
        return status === 'checked';
      });
    },
    allChildrenUnchecked: function allChildrenUnchecked() {
      return this.children.every(function (_ref2) {
        var status = _ref2.status;
        return status === 'unchecked';
      });
    },
    isFolder: function isFolder() {
      return this.children && this.children.length > 0;
    },
    isLevelOne: function isLevelOne() {
      return this.level === 1;
    },
    isLevelTwo: function isLevelTwo() {
      return this.level === 2;
    },
    isLevelThree: function isLevelThree() {
      return this.level === 3;
    },
    isExperiences: function isExperiences() {
      return this.status === 'checked' && this.queryType === 'experiences';
    },
    isSkills: function isSkills() {
      return this.status === 'checked' && this.queryType === 'skills';
    },
    numberOfSelectedChildren: function numberOfSelectedChildren() {
      if (!this.children.length) {
        return 0;
      }

      return this.children.filter(function (_ref3) {
        var status = _ref3.status;
        return status === 'checked';
      }).length;
    }
  },

  methods: {
    handleRemoveTag: function handleRemoveTag(_ref4) {
      var path = _ref4.path,
          type = _ref4.type;

      if (this.path.replace('county-', '') === path && this.queryType === type && this.status === 'checked') {
        this.resetQuery();
        this.emitUpsideAndDownsideEvent(this.path, 'unchecked', this.queryType);
      }
    },
    handleClearLocal: function handleClearLocal(type) {
      if (this.queryType === type) {
        this.resetQuery();
      }
    },
    handleSearchRecommended: function handleSearchRecommended(_ref5) {
      var path = _ref5.path,
          type = _ref5.type;

      if (this.path.replace('county-', '') === path && this.queryType === type) {
        this.setStatus('checked');
        this.emitUpsideAndDownsideEvent(this.path, 'checked', this.queryType);
      }
    },
    toggleExpanded: function toggleExpanded() {
      if (this.isFolder) {
        this.expanded = !this.expanded;
      }
    },
    expandPanel: function expandPanel() {
      if (this.isFolder) {
        this.expanded = true;
      }
    },
    closePanel: function closePanel() {
      if (this.isFolder) {
        this.expanded = false;
      }
    },
    resetQuery: function resetQuery() {
      this.status = 'unchecked';
      this.setChildStatuses('unchecked');
      this.expanded = false;
      this.years = 0;
    },
    setStatus: function setStatus(status) {
      this.status = status;
    },
    setChildStatuses: function setChildStatuses(status) {
      this.children = this.children.map(function (child) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, child, {
          status: status
        });
      });
    },
    emitUpsideAndDownsideEvent: function emitUpsideAndDownsideEvent(from, status, type) {
      this.emitUpsideEvent(from, status, type);
      this.emitDownsideEvent(from, status, type);
    },
    emitUpsideEvent: function emitUpsideEvent(from, status, type) {
      window.eventBus.$emit('upside', {
        from: from,
        status: status,
        type: type
      });
    },
    emitDownsideEvent: function emitDownsideEvent(from, status, type) {
      window.eventBus.$emit('downside', {
        from: from,
        status: status,
        type: type
      });
    },
    handleLocalAndGlobalSearch: function handleLocalAndGlobalSearch(_ref6) {
      var name = _ref6.name,
          path = _ref6.path,
          years = _ref6.years,
          type = _ref6.type;

      if (this.path.replace('county-', '') === path && this.queryType === type) {
        this.rangeMin = years && years[0] ? years[0].years : 0;
        this.rangeMax = years && years[1] ? years[1].years : 10;

        this.status = 'checked';
        this.setChildStatuses('checked');
        this.commitToQuery(name, path);
        this.emitUpsideAndDownsideEvent(this.path, 'checked', this.queryType);
      }
    },
    removeFromQuery: function removeFromQuery(path, type) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_6__store_actionTypes__["n" /* REMOVE_FROM_QUERY */], {
        path: path,
        type: type
      });
    },
    handleUpside: function handleUpside(payload) {
      var _this = this;

      var targetArr = this.children.filter(function (child) {
        return child.path === payload.from;
      });

      if (targetArr.length === 1 && payload.type === this.queryType) {
        var target = targetArr[0];

        target.status = payload.status;

        if (this.allChildrenChecked) {
          this.setStatus('checked');
          this.commitClear();
          this.commitToQuery(this.name, this.path);
        } else if (this.allChildrenUnchecked) {
          this.setStatus('unchecked');
        } else {
          this.setStatus('indeterminate');

          this.children.forEach(function (child) {
            var alreadyAdded = _this.$store.getters.hasValue(child.path, _this.queryType);

            if (child.status === 'checked' && !alreadyAdded) {
              _this.commitToQuery(child.name, child.path);
            } else if (child.status !== 'checked' && alreadyAdded) {
              _this.removeFromQuery(child.path, _this.queryType);
            }
          });
        }

        this.emitUpsideEvent(this.path, this.status, this.queryType);
      }
    },
    handleDownside: function handleDownside(payload) {
      if (payload.from === this.parent && payload.type === this.queryType) {
        if (payload.status === 'checked') {
          this.setStatus('checked');
          this.setChildStatuses('checked');
        } else if (payload.status === 'unchecked') {
          this.setStatus('unchecked');
          this.setChildStatuses('unchecked');
        }

        this.emitDownsideEvent(this.path, this.status, this.queryType);
      }
    },
    commitToQuery: function commitToQuery(name, path) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_6__store_actionTypes__["d" /* ADD_TO_QUERY */], {
        payload: {
          name: name,
          path: path
        },
        type: this.queryType
      });
    },
    commitClear: function commitClear() {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_6__store_actionTypes__["f" /* CLEAR_QUERY_OF_TYPE */], {
        path: this.path,
        type: this.queryType
      });
    },
    addToQuery: function addToQuery() {
      if (this.status === 'checked') {
        this.setStatus('unchecked');
        this.setChildStatuses('unchecked');
        this.commitClear();

        if (this.isLevelTwo || this.isLevelThree) {
          this.removeFromQuery(this.parent, this.queryType);
        }
      } else {
        this.setStatus('checked');
        this.setChildStatuses('checked');

        if (this.isLevelOne || this.isLevelTwo) {
          this.commitClear();
          this.commitToQuery(this.name, this.path);
        }
      }

      this.emitUpsideAndDownsideEvent(this.path, this.status, this.queryType);
    },
    addYearsToQuery: function addYearsToQuery(payload) {
      if (this.queryType === 'experiences') {
        var gt = parseInt(payload[0], 10);
        var lt = parseInt(payload[1], 10);

        var years = [{
          modifier: 'gte',
          years: gt
        }];

        if (lt !== 10) {
          years = years.concat([{
            modifier: 'lte',
            years: lt
          }]);
        }

        this.$store.commit(__WEBPACK_IMPORTED_MODULE_6__store_actionTypes__["b" /* ADD_EXPERIENCE_YEARS */], {
          years: years,
          name: this.name,
          path: this.path,
          type: this.queryType
        });
      } else {
        this.rangeMin = payload.path;

        this.$store.commit(__WEBPACK_IMPORTED_MODULE_6__store_actionTypes__["c" /* ADD_SKILL_YEARS */], {
          years: [{
            modifier: this.modifier,
            years: payload.path
          }],
          name: this.name,
          path: this.path,
          type: this.queryType
        });
      }
    }
  }
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AfCheckbox',

  props: {
    name: String,
    label: String,
    checked: Boolean,
    disabled: Boolean
  },

  methods: {
    onChange: function onChange(event, name) {
      this.$emit('changed', name, event.target.checked);
    }
  }
});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_actionTypes__ = __webpack_require__(13);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SearchLocalSearch',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_1__components_Icon__["a" /* default */]
  },

  data: function data() {
    return {
      hits: [],
      query: ''
    };
  },


  props: {
    list: Array,
    placeholder: String,
    queryType: {
      required: true,
      type: String
    }
  },

  computed: {
    hasHits: function hasHits() {
      return this.hits.length > 0;
    }
  },

  methods: {
    onSearch: function onSearch() {
      var searchString = this.query.toLowerCase();

      if (searchString.length < 2) {
        this.hits = [];
        return;
      }

      this.hits = this.list.filter(function (_ref) {
        var name = _ref.name;
        return name.toLowerCase().includes(searchString);
      }).map(function (hit) {
        var queryRegEx = new RegExp('(' + searchString + ')', 'ig');

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, hit, {
          highlightedName: hit.name.replace(queryRegEx, '<strong>$1</strong>')
        });
      });
    },
    onClickResult: function onClickResult(_ref2) {
      var name = _ref2.name,
          path = _ref2.path;

      this.hits = [];
      this.query = '';

      var payload = {
        name: name,
        path: path
      };

      if (this.queryType === 'languages') {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_actionTypes__["d" /* ADD_TO_QUERY */], {
          payload: payload,
          type: this.queryType
        });
      } else {
        window.eventBus.$emit('openExpansionPanel', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, payload, {
          type: this.queryType
        }));
      }
    }
  }
});

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_actionTypes__ = __webpack_require__(13);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SearchClear',

  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_0__components_Icon__["a" /* default */]
  },

  props: {
    queryType: {
      required: true,
      type: String
    }
  },

  computed: {
    hasSelectedItems: function hasSelectedItems() {
      return this.$store.getters.getQueryType(this.queryType) > 0;
    }
  },

  methods: {
    handleClear: function handleClear(event) {
      event.preventDefault();
      event.stopPropagation();

      window.eventBus.$emit('clearLocal', this.queryType);
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_actionTypes__["e" /* CLEAR_FROM_QUERY */], this.queryType);
    }
  }
});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AfTooltip__ = __webpack_require__(655);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Afh3',

  components: {
    AfTooltip: __WEBPACK_IMPORTED_MODULE_0__AfTooltip__["a" /* default */]
  },

  props: {
    tooltip: Boolean
  }
});

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AfH3__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Icon__ = __webpack_require__(4);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AfTooltip',

  components: {
    AfH3: __WEBPACK_IMPORTED_MODULE_0__components_AfH3__["a" /* default */],
    Icon: __WEBPACK_IMPORTED_MODULE_1__components_Icon__["a" /* default */]
  },

  data: function data() {
    return {
      open: false
    };
  },


  methods: {
    toggleContent: function toggleContent() {
      this.open = !this.open;
    },
    closeContent: function closeContent() {
      this.open = false;
    }
  }
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AfH3__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_AfExpansionPanel__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_AfSpinner__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SearchClear__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SearchLocalSearch__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SearchCompetencesSuggestions__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_actionTypes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuex__ = __webpack_require__(18);





var _templateObject = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n        query Competences($language: LanguageCode) {\n          competencegroups(language: $language) {\n            name\n            path\n          }\n          competences(path: "*", language: $language) {\n            name\n            path\n          }\n        }\n      '], ['\n        query Competences($language: LanguageCode) {\n          competencegroups(language: $language) {\n            name\n            path\n          }\n          competences(path: "*", language: $language) {\n            name\n            path\n          }\n        }\n      ']);












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SearchCompetences',

  components: {
    AfExpansionPanel: __WEBPACK_IMPORTED_MODULE_7__components_AfExpansionPanel__["a" /* default */],
    AfH3: __WEBPACK_IMPORTED_MODULE_6__components_AfH3__["a" /* default */],
    AfSpinner: __WEBPACK_IMPORTED_MODULE_8__components_AfSpinner__["a" /* default */],
    Icon: __WEBPACK_IMPORTED_MODULE_5__components_Icon__["a" /* default */],
    SearchClear: __WEBPACK_IMPORTED_MODULE_9__SearchClear__["a" /* default */],
    SearchLocalSearch: __WEBPACK_IMPORTED_MODULE_10__SearchLocalSearch__["a" /* default */],
    SearchCompetencesSuggestions: __WEBPACK_IMPORTED_MODULE_11__SearchCompetencesSuggestions__["a" /* default */]
  },

  data: function data() {
    return {
      searchList: [],
      loading: 0,
      competences: []
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_13_vuex__["c" /* mapState */])({
    tree: function tree(state) {
      return state.tree.skills;
    },
    skills: function skills(state) {
      return state.query.skills;
    }
  })),

  mounted: function mounted() {
    if (this.skills.length > 0) {
      this.skills.forEach(function (skill) {
        window.eventBus.$emit('openExpansionPanel', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, skill, {
          type: 'skills'
        }));
      });
    }
  },


  apollo: {
    experienceData: {
      query: __WEBPACK_IMPORTED_MODULE_4_graphql_tag___default()(_templateObject),
      fetchPolicy: 'cache-and-network',
      loadingKey: 'loading',
      variables: function variables() {
        return {
          language: 'sv'
        };
      },
      skip: function skip() {
        return this.tree.columnOne.length > 0;
      },
      update: function update(_ref) {
        var competencegroups = _ref.competencegroups,
            competences = _ref.competences;

        this.searchList = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(competencegroups), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(competences));
        this.buildRecursiveStructure(competencegroups, competences);
      }
    }
  },

  methods: {
    buildRecursiveStructure: function buildRecursiveStructure(competencegroups, competences) {
      if (competencegroups.length === 0 || this.tree.columnOne.length > 0) {
        return;
      }

      var recursive = competencegroups.map(function (area) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, area, {
          children: competences.filter(function (group) {
            return area.path === group.path.split('.').slice(0, 2).join('.');
          }).map(function (comp) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()(comp);
          })
        }));
      });

      var split = Math.ceil(recursive.length / 3);

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_12__store_actionTypes__["w" /* UPDATE_TAB_COLUMN */], {
        payload: {
          columnOne: recursive.slice(0, split),
          columnTwo: recursive.slice(split, split * 2),
          columnThree: recursive.slice(split * 2, split * 3)
        },
        type: 'skills'
      });
    }
  }
});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AfH3__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AfCheckbox__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_helpers__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_actionTypes__ = __webpack_require__(13);




var _templateObject = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n        query CompetencesForProcessions($language: LanguageCode, $paths: [String!]) {\n          competencesForProfessions(language: $language, paths: $paths) {\n            name\n            path\n            type\n          }\n        }\n      '], ['\n        query CompetencesForProcessions($language: LanguageCode, $paths: [String!]) {\n          competencesForProfessions(language: $language, paths: $paths) {\n            name\n            path\n            type\n          }\n        }\n      ']);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SearchCompetencesSuggestions',

  components: {
    AfH3: __WEBPACK_IMPORTED_MODULE_5__components_AfH3__["a" /* default */],
    AfCheckbox: __WEBPACK_IMPORTED_MODULE_6__components_AfCheckbox__["a" /* default */]
  },

  data: function data() {
    return {
      competences: []
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapState */])({
    experiences: function experiences(state) {
      return state.query.experiences;
    },
    skills: function skills(state) {
      return state.query.skills;
    }
  }), {
    shouldShow: function shouldShow() {
      return this.experiences.length && this.competences.length;
    }
  }),
  apollo: {
    suggestionsData: {
      query: __WEBPACK_IMPORTED_MODULE_4_graphql_tag___default()(_templateObject),
      loadingKey: 'loading',
      variables: function variables() {
        return {
          language: 'sv',
          paths: this.handleExperiences()
        };
      },
      update: function update(_ref) {
        var competencesForProfessions = _ref.competencesForProfessions;

        var unfilteredCompetences = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(competencesForProfessions));
        this.competences = Object(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["c" /* filterDuplicates */])(unfilteredCompetences);
      }
    }
  },

  methods: {
    handleExperiences: function handleExperiences() {
      return this.experiences.map(function (experience) {
        return experience.path;
      });
    },
    isAdded: function isAdded(competencePath) {
      var exists = this.skills.find(function (skill) {
        return skill.path === competencePath;
      });
      return exists ? true : false;
    },
    toggleInclude: function toggleInclude(path) {
      var skillAlreadyAdded = this.skills.find(function (skill) {
        return skill.path === path;
      });

      if (!skillAlreadyAdded) {
        this.addCompetence(path);
      } else {
        this.removeCompetence(path);
      }
    },
    addCompetence: function addCompetence(path) {
      var years = [{
        modifier: 'gte',
        years: 0
      }];

      var competenceToAdd = this.competences.find(function (competence) {
        return competence.path === path;
      });
      if (!competenceToAdd) {
        return;
      }

      var payload = {
        years: years,
        path: path,
        name: competenceToAdd.name
      };

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_8__store_actionTypes__["d" /* ADD_TO_QUERY */], {
        payload: payload,
        type: 'skills'
      });

      window.eventBus.$emit('openExpansionPanel', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, payload, {
        type: 'skills'
      }));
    },
    removeCompetence: function removeCompetence(path) {
      var payload = { type: 'skills', path: path };

      window.eventBus.$emit('removeTag', payload);
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_8__store_actionTypes__["n" /* REMOVE_FROM_QUERY */], payload);
    }
  }
});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_actionTypes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AfCheckbox__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AfH3__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AfH4__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AfLink__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Icon__ = __webpack_require__(4);











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SearchAsylumStatus',

  components: {
    AfCheckbox: __WEBPACK_IMPORTED_MODULE_3__components_AfCheckbox__["a" /* default */],
    AfH3: __WEBPACK_IMPORTED_MODULE_4__components_AfH3__["a" /* default */],
    AfH4: __WEBPACK_IMPORTED_MODULE_5__components_AfH4__["a" /* default */],
    AfLink: __WEBPACK_IMPORTED_MODULE_6__components_AfLink__["a" /* default */],
    Icon: __WEBPACK_IMPORTED_MODULE_7__components_Icon__["a" /* default */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['hasWorkPermitChecked', 'hasResidencePermitChecked', 'noWorkPermitChecked'])),

  methods: {
    hasResidencePermit: function hasResidencePermit(_, checked) {
      if (!checked) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_actionTypes__["n" /* REMOVE_FROM_QUERY */], {
          type: 'asylumStatus',
          path: 'hasResidencePermit',
          value: true
        });
      } else {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_actionTypes__["h" /* HAS_RESIDENCE_PERMIT */]);
      }
    },
    hasWorkPermit: function hasWorkPermit(_, checked) {
      if (!checked) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_actionTypes__["n" /* REMOVE_FROM_QUERY */], {
          type: 'asylumStatus',
          path: 'hasAtUnd',
          value: true
        });
      } else {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_actionTypes__["i" /* HAS_WORK_PERMIT */]);
      }
    },
    noWorkPermit: function noWorkPermit(_, checked) {
      if (!checked) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_actionTypes__["n" /* REMOVE_FROM_QUERY */], {
          type: 'asylumStatus',
          path: 'hasAtUnd',
          value: false
        });
      } else {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_actionTypes__["l" /* NO_WORK_PERMIT */]);
      }
    }
  }
});

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'af-link',

  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_0__components_Icon__["a" /* default */]
  },

  props: {
    href: {
      required: true,
      type: String
    },
    target: {
      default: '_self',
      type: String
    }
  }
});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_actionTypes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AfCheckbox__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AfH3__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SearchDropdown__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_AfInfoBox__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Button_Button__ = __webpack_require__(52);



var _templateObject = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n        query EducationLevels($language: LanguageCode!) {\n          educationLevels(language: $language) {\n            name\n            path\n            ranking\n          }\n          educationSubjects(language: $language) {\n            name\n            path\n          }\n        }\n      '], ['\n        query EducationLevels($language: LanguageCode!) {\n          educationLevels(language: $language) {\n            name\n            path\n            ranking\n          }\n          educationSubjects(language: $language) {\n            name\n            path\n          }\n        }\n      ']);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SearchEducation',

  components: {
    AfCheckbox: __WEBPACK_IMPORTED_MODULE_4__components_AfCheckbox__["a" /* default */],
    AfH3: __WEBPACK_IMPORTED_MODULE_5__components_AfH3__["a" /* default */],
    SearchDropdown: __WEBPACK_IMPORTED_MODULE_6__SearchDropdown__["a" /* default */],
    Icon: __WEBPACK_IMPORTED_MODULE_7__components_Icon__["a" /* default */],
    AfInfoBox: __WEBPACK_IMPORTED_MODULE_8__components_AfInfoBox__["a" /* default */],
    AfButton: __WEBPACK_IMPORTED_MODULE_9__components_Button_Button__["a" /* default */]
  },

  data: function data() {
    return {
      educationQuery: {
        name: '',
        path: '',
        ranking: 0,
        hasDegree: false,
        hasDocuments: false,
        hasDocumentsEnglish: false,
        years: [],
        subject: {
          name: '',
          path: ''
        }
      },
      infoLinks: [{
        text: 'Läs mer om hur UHR bedömer utländska utbildningar',
        href: 'https://www.uhr.se/bedomning-av-utlandsk-utbildning/',
        external: true
      }, {
        text: 'Läs mer om reglerade yrken',
        href: 'https://www.uhr.se/bedomning-av-utlandsk-utbildning/information-innan-ansokan/Arbeta-i-Sverige/Reglerade-yrken/',
        external: true
      }],
      educationLevels: [],
      educationSubjects: [],
      years: [{
        name: 'Oavsett antal år',
        path: 0
      }, {
        name: 'Minst ett år',
        path: 1
      }, {
        name: 'Minst två år',
        path: 2
      }, {
        name: 'Minst tre år',
        path: 3
      }, {
        name: 'Minst fyra år',
        path: 4
      }, {
        name: 'Minst fem år',
        path: 5
      }]
    };
  },


  computed: {
    getRanking: function getRanking() {
      return this.educationQuery.ranking;
    },
    getEducationPath: function getEducationPath() {
      return this.educationQuery.path;
    },
    getSubjectPath: function getSubjectPath() {
      return this.educationQuery.subject.path;
    },
    getYears: function getYears() {
      if (this.educationQuery.years.length) {
        return this.educationQuery.years[0].years;
      }
      return null;
    },
    getHasDegree: function getHasDegree() {
      return this.educationQuery.hasDegree;
    },
    getHasDocuments: function getHasDocuments() {
      return this.educationQuery.hasDocuments;
    },
    getHasDocumentsEnglish: function getHasDocumentsEnglish() {
      return this.educationQuery.hasDocumentsEnglish;
    },
    getSortedEducationSubjects: function getSortedEducationSubjects() {
      if (!this.educationSubjects.length) {
        return [];
      }

      return this.educationSubjects.sort(function (a, b) {
        if (a.path === 0 || a.name < b.name) {
          return -1;
        }

        if (a.name > b.name) {
          return 1;
        }

        return 0;
      });
    }
  },

  apollo: {
    educationLevelsData: {
      query: __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default()(_templateObject),
      variables: function variables() {
        return {
          language: 'sv'
        };
      },
      update: function update(_ref) {
        var educationLevels = _ref.educationLevels,
            educationSubjects = _ref.educationSubjects;

        this.handleApolloUpdate({ educationLevels: educationLevels, educationSubjects: educationSubjects });
      }
    }
  },

  methods: {
    handleApolloUpdate: function handleApolloUpdate(_ref2) {
      var educationLevels = _ref2.educationLevels,
          educationSubjects = _ref2.educationSubjects;

      this.educationLevels = educationLevels.slice(0);
      this.educationSubjects = educationSubjects.slice(0);
    },
    toggleInclude: function toggleInclude(event) {
      if (this.educationQuery[event] === undefined) {
        return;
      }

      this.educationQuery[event] = !this.educationQuery[event];
    },
    setEducationRanking: function setEducationRanking(event) {
      this.educationQuery.ranking = event.ranking;
      this.educationQuery.path = event.path;
      this.educationQuery.name = event.name;
    },
    setEducationSubject: function setEducationSubject(event) {
      this.educationQuery.subject = { name: event.name, path: event.path };
    },
    setEducationYears: function setEducationYears(event) {
      this.educationQuery.years = [{ modifier: 'gt', years: event.path }];
    },
    updateEducation: function updateEducation() {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_actionTypes__["a" /* ADD_EDUCATION_TO_QUERY */], {
        payload: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.educationQuery),
        type: 'educations'
      });

      this.educationQuery = {
        name: '',
        path: '',
        ranking: 0,
        hasDegree: false,
        hasDocuments: false,
        hasDocumentsEnglish: false,
        years: [],
        subject: {
          name: '',
          path: ''
        }
      };
    }
  }
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'af-info-box',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_0__components_Icon__["a" /* default */]
  },
  props: {
    links: Array,
    onLinkClick: Function
  }
});

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AfH3__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SearchLanguage__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SearchClear__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SearchLocalSearch__ = __webpack_require__(115);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n        query getLanguages($language: LanguageCode) {\n          languageSkills(language: $language) {\n            name\n            path\n          }\n        }\n      '], ['\n        query getLanguages($language: LanguageCode) {\n          languageSkills(language: $language) {\n            name\n            path\n          }\n        }\n      ']);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SearchLanguages',
  components: {
    AfH3: __WEBPACK_IMPORTED_MODULE_1__components_AfH3__["a" /* default */],
    Icon: __WEBPACK_IMPORTED_MODULE_4__components_Icon__["a" /* default */],
    SearchClear: __WEBPACK_IMPORTED_MODULE_5__SearchClear__["a" /* default */],
    SearchLanguage: __WEBPACK_IMPORTED_MODULE_3__SearchLanguage__["a" /* default */],
    SearchLocalSearch: __WEBPACK_IMPORTED_MODULE_6__SearchLocalSearch__["a" /* default */]
  },

  data: function data() {
    return {
      defaultLanguages: [],
      languages: []
    };
  },


  apollo: {
    languagesData: {
      query: __WEBPACK_IMPORTED_MODULE_2_graphql_tag___default()(_templateObject),
      variables: function variables() {
        return {
          language: 'sv'
        };
      },
      update: function update(_ref) {
        var languageSkills = _ref.languageSkills;

        var defaultLanguageNames = ['Svenska', 'Persiska (Farsi)', 'Engelska', 'Tigrinja/Tigrinska', 'Arabiska', 'Somaliska'];

        this.languages = languageSkills;
        this.defaultLanguages = languageSkills.filter(function (_ref2) {
          var name = _ref2.name;
          return defaultLanguageNames.includes(name);
        });
      }
    }
  }
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actionTypes__ = __webpack_require__(13);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SearchLanguage',

  props: {
    name: {
      required: true,
      type: String
    },
    path: {
      required: true,
      type: String
    }
  },

  computed: {
    label: function label() {
      return 'search-checkbox-' + this.path;
    },
    checked: function checked() {
      return this.$store.getters.hasLanguage(this.name);
    }
  },

  methods: {
    addToQuery: function addToQuery(payload) {
      if (!this.checked) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_actionTypes__["d" /* ADD_TO_QUERY */], {
          payload: payload,
          type: 'languages'
        });
      } else {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_actionTypes__["n" /* REMOVE_FROM_QUERY */], {
          path: payload.path,
          type: 'languages'
        });
      }
    }
  }
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AfH3__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AfExpansionPanel__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AfSpinner__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SearchClear__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SearchLocalSearch__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_graphql_tag__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_actionTypes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex__ = __webpack_require__(18);





var _templateObject = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n        query getCounties {\n          counties {\n            name\n            path\n            municipalities {\n              path\n              name\n            }\n          }\n        }\n      '], ['\n        query getCounties {\n          counties {\n            name\n            path\n            municipalities {\n              path\n              name\n            }\n          }\n        }\n      ']);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SearchLocation',

  components: {
    AfH3: __WEBPACK_IMPORTED_MODULE_4__components_AfH3__["a" /* default */],
    AfExpansionPanel: __WEBPACK_IMPORTED_MODULE_5__components_AfExpansionPanel__["a" /* default */],
    AfSpinner: __WEBPACK_IMPORTED_MODULE_6__components_AfSpinner__["a" /* default */],
    SearchClear: __WEBPACK_IMPORTED_MODULE_7__SearchClear__["a" /* default */],
    SearchLocalSearch: __WEBPACK_IMPORTED_MODULE_8__SearchLocalSearch__["a" /* default */]
  },

  data: function data() {
    return {
      searchList: []
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_11_vuex__["c" /* mapState */])({
    tree: function tree(state) {
      return state.tree.locations;
    },
    city: function city(state) {
      return state.query.city;
    }
  })),

  mounted: function mounted() {
    if (this.city.length > 0) {
      this.city.forEach(function (c) {
        window.eventBus.$emit('openExpansionPanel', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, c, {
          type: 'city'
        }));
      });
    }
  },


  apollo: {
    counties: {
      query: __WEBPACK_IMPORTED_MODULE_9_graphql_tag___default()(_templateObject),
      fetchPolicy: 'cache-and-network',
      skip: function skip() {
        return this.tree.columnOne.length > 0;
      },
      update: function update(_ref) {
        var counties = _ref.counties;

        this.buildSearchList(counties);
        this.buildRecursiveStructure(counties);
      }
    }
  },

  methods: {
    sortByName: function sortByName(a, b) {
      return a.name.localeCompare(b.name, 'sv');
    },
    buildSearchList: function buildSearchList(counties) {
      this.searchList = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze___default()(counties.map(function (_ref2) {
        var name = _ref2.name,
            path = _ref2.path,
            municipalities = _ref2.municipalities,
            __typename = _ref2.__typename;
        return [{
          name: name,
          path: path,
          __typename: __typename
        }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(municipalities));
      }).reduce(function (acc, curr) {
        return acc.concat(curr);
      }, []).sort(this.sortByName));
    },
    buildRecursiveStructure: function buildRecursiveStructure(counties) {
      var _this = this;

      if (counties.length === 0 || this.tree.columnOne.length > 0) {
        return;
      }

      var recursive = counties.map(function (county) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze___default()({
          name: county.name,
          path: 'county-' + county.path,
          children: county.municipalities.slice().sort(_this.sortByName).map(function (muni) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze___default()(muni);
          })
        });
      }).sort(this.sortByName);

      var split = Math.ceil(recursive.length / 3);

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_10__store_actionTypes__["w" /* UPDATE_TAB_COLUMN */], {
        payload: {
          columnOne: recursive.slice(0, split),
          columnTwo: recursive.slice(split, split * 2),
          columnThree: recursive.slice(split * 2, split * 3)
        },
        type: 'locations'
      });
    }
  }
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SearchTag__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_actionTypes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AfH3__ = __webpack_require__(22);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SearchTags',

  components: {
    AfH3: __WEBPACK_IMPORTED_MODULE_3__components_AfH3__["a" /* default */],
    Icon: __WEBPACK_IMPORTED_MODULE_2__components_Icon__["a" /* default */],
    SearchTag: __WEBPACK_IMPORTED_MODULE_0__SearchTag__["a" /* default */]
  },

  props: {
    tags: {
      required: true,
      type: Array
    }
  },

  computed: {
    hasTags: function hasTags() {
      return this.tags.length > 0;
    }
  },

  methods: {
    resetQuery: function resetQuery() {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_actionTypes__["o" /* RESET_QUERY */]);
      window.eventBus.$emit('RESET_QUERY');
    }
  }
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_actionTypes__ = __webpack_require__(13);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SearchTag',

  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_0__components_Icon__["a" /* default */]
  },

  props: {
    tag: {
      required: true,
      type: Object
    }
  },

  computed: {
    isExperienceTag: function isExperienceTag() {
      return this.tag.type === 'experiences' && this.yearGtModifier;
    },
    isEducationTag: function isEducationTag() {
      return this.tag.type === 'educations' && this.yearGtModifier;
    },
    isSkillTag: function isSkillTag() {
      return this.tag.type === 'skills';
    },
    hasSubject: function hasSubject() {
      return this.tag.subject && this.tag.subject.name;
    },
    yearGtModifier: function yearGtModifier() {
      return this.tag.years.length > 0 && this.tag.years[0].years;
    },
    yearLtModifier: function yearLtModifier() {
      if (!this.tag.years[1] || this.tag.years[1].years === 10) {
        return 'över 10';
      }

      return this.tag.years[1].years;
    },
    skillLevel: function skillLevel() {
      return !!this.yearGtModifier ? this.yearGtModifier + ' \xE5rs' : 'någon';
    },
    hasDuplicateTag: function hasDuplicateTag() {
      if (this.tag.type === 'experiences' || this.tag.type === 'skills') {
        return this.$store.getters.hasDuplicateTag(this.tag.name);
      }

      return false;
    },
    tagName: function tagName() {
      switch (this.tag.type) {
        case 'experiences':
          return 'Yrke';
        case 'skills':
          return 'Kompetens';
        default:
          return '';
      }
    }
  },

  filters: {
    clean: function clean(tag) {
      if (!tag) {
        return '';
      }

      var hasParenthesis = tag.indexOf('(');

      if (hasParenthesis !== -1) {
        return tag.substr(0, hasParenthesis);
      }

      return tag;
    }
  },

  methods: {
    remove: function remove(_ref) {
      var type = _ref.type,
          path = _ref.path,
          subject = _ref.subject,
          value = _ref.value;

      var payload = { type: type, path: path, value: value };

      if (type === 'educations' && subject && subject.path) {
        payload = {
          type: type,
          path: path,
          subject: {
            path: subject.path
          }
        };
      }

      window.eventBus.$emit('removeTag', payload);
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_actionTypes__["n" /* REMOVE_FROM_QUERY */], payload);
    },
    openTab: function openTab(type) {
      if (type === 'hasAtUnd' || type === 'seekingAsylum' || type === 'hasResidencePermit') {
        type = 'asylumStatus';
      }

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_actionTypes__["q" /* SET_ACTIVE_TAB_ONLY */], type);
    }
  }
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SearchPagination__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SearchSort__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AfH2__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_helpers__ = __webpack_require__(53);











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SearchResults',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_3__components_Icon__["a" /* default */],
    SearchPagination: __WEBPACK_IMPORTED_MODULE_4__SearchPagination__["a" /* default */],
    SearchSort: __WEBPACK_IMPORTED_MODULE_5__SearchSort__["a" /* default */],
    AfH2: __WEBPACK_IMPORTED_MODULE_6__components_AfH2__["a" /* default */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapState */])(['results', 'hasSearched', 'noResults']), {
    hasResults: function hasResults() {
      var resultsBoxSection = document.getElementById("resultsBox");
      if (resultsBoxSection) {
        var observer = new IntersectionObserver(function (_ref) {
          var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 1),
              e = _ref2[0];

          return e.target.toggleAttribute('stuck', e.intersectionRatio < 1);
        }, { threshold: [1] });
        observer.observe(resultsBoxSection);

        var cardHeight = 180;
        if (window.innerWidth < 768) {
          cardHeight = 120;
        }
        resultsBoxSection.style.bottom = '-' + this.results.total * cardHeight + 'px';
      }

      return this.results.total > 0;
    },
    hasNoResults: function hasNoResults() {
      return this.hasSearched && this.results.total === 0;
    },
    targetDestination: function targetDestination() {
      return Object(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["d" /* isIE11 */])() ? "_blank" : "_self";
    },
    hasError: function hasError() {
      return this.$store.getters.hasError;
    }
  }),

  data: function data() {
    return {
      baseURL: window.__BASE_URL__
    };
  },


  methods: {
    matchedRequirements: function matchedRequirements(matches) {
      return matches.filter(function (match) {
        return match.isMatch;
      });
    }
  }
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_actionTypes__ = __webpack_require__(13);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SearchPagination',

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])({
    results: function results(state) {
      return state.results;
    },
    skip: function skip(state) {
      return state.skip;
    }
  }), {
    pageCount: function pageCount() {
      return Math.ceil(this.results.total / 10);
    }
  }),

  watch: {
    skip: {
      handler: function handler() {
        this.setSelectedPage();
      }
    }
  },

  methods: {
    setActivePage: function setActivePage(page) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_actionTypes__["u" /* SET_SKIP */], page);
    },
    setSelectedPage: function setSelectedPage() {
      if (this.$refs.paginate) {
        this.$refs.paginate.selected = this.skip / 10;
      }
    }
  },

  mounted: function mounted() {
    this.setSelectedPage();
  }
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SearchDropdown__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_actionTypes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(18);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SearchSort',

  components: {
    SearchDropdown: __WEBPACK_IMPORTED_MODULE_1__SearchDropdown__["a" /* default */]
  },

  data: function data() {
    return {
      options: [{
        name: 'Relevans',
        path: 'relevance',
        value: 'relevance'
      }, {
        name: 'Yrkeserfarenhet',
        path: 'experiences',
        value: 'experiences'
      }, {
        name: 'Utbildning',
        path: 'educations',
        value: 'educations'
      }, {
        name: 'Kompetenser',
        path: 'skills',
        value: 'skills'
      }]
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapState */])({
    sort: function sort(state) {
      return state.sort;
    }
  })),

  methods: {
    updateSort: function updateSort(_ref) {
      var value = _ref.value;

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_actionTypes__["v" /* SET_SORT */], value);
    }
  }
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AfH2__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AfLink__ = __webpack_require__(165);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'af-information-box',

  components: {
    AfH2: __WEBPACK_IMPORTED_MODULE_0__components_AfH2__["a" /* default */],
    AfLink: __WEBPACK_IMPORTED_MODULE_1__components_AfLink__["a" /* default */]
  },

  props: {
    image: String,
    linkUrl: String,
    linkTarget: String
  }
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AfH1',
  props: {
    noUnderline: Boolean
  }
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SearchScrollToTop',

  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_0__components_Icon__["a" /* default */]
  },

  data: function data() {
    return {
      show: false
    };
  },
  mounted: function mounted() {
    document.addEventListener('scroll', this.shouldShow);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('scroll', this.shouldShow);
  },


  methods: {
    shouldShow: function shouldShow() {
      this.show = window.scrollY > window.innerHeight - 340 ? true : false;
    }
  }
});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AfH1__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AfH2__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Button_Button__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AfLink__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ExternalLink__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Icon__ = __webpack_require__(4);









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'af-button': __WEBPACK_IMPORTED_MODULE_2__components_Button_Button__["a" /* default */],
    AfH1: __WEBPACK_IMPORTED_MODULE_0__components_AfH1__["a" /* default */],
    AfH2: __WEBPACK_IMPORTED_MODULE_1__components_AfH2__["a" /* default */],
    AfLink: __WEBPACK_IMPORTED_MODULE_3__components_AfLink__["a" /* default */],
    ExternalLink: __WEBPACK_IMPORTED_MODULE_4__components_ExternalLink__["a" /* default */],
    Icon: __WEBPACK_IMPORTED_MODULE_5__components_Icon__["a" /* default */]
  },
  name: 'login',
  methods: {
    login: function login() {
      if (this.$store.getters.loggedIn) {
        this.$router.push('/sok');
      } else {
        window.location.href = __API_URL__ + 'auth/saml?returnUrl=' + __BASE_URL__ + 'sok';
      }
    }
  }
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ExperienceRow__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_List__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Breadcrumbs__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_AfH1__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Modal__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_ModalContent__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_AfInformationNotification__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_AfH2__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_AfPopover__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Button_Button__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__MessageForm__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ProfileInfo__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__queries__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_helpers__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuex__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__store_actionTypes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_cookies__ = __webpack_require__(110);


























/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'profile',

  components: {
    ExperienceRow: __WEBPACK_IMPORTED_MODULE_5__components_ExperienceRow__["a" /* default */],
    Icon: __WEBPACK_IMPORTED_MODULE_7__components_Icon__["a" /* default */],
    List: __WEBPACK_IMPORTED_MODULE_6__components_List__["a" /* default */],
    Breadcrumbs: __WEBPACK_IMPORTED_MODULE_8__components_Breadcrumbs__["a" /* default */],
    'af-button': __WEBPACK_IMPORTED_MODULE_15__components_Button_Button__["a" /* default */],
    'af-h1': __WEBPACK_IMPORTED_MODULE_9__components_AfH1__["a" /* default */],
    'af-h2': __WEBPACK_IMPORTED_MODULE_13__components_AfH2__["a" /* default */],
    'af-popover': __WEBPACK_IMPORTED_MODULE_14__components_AfPopover__["a" /* default */],
    'af-information-notification': __WEBPACK_IMPORTED_MODULE_12__components_AfInformationNotification__["a" /* default */],
    'message-form': __WEBPACK_IMPORTED_MODULE_16__MessageForm__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_10__components_Modal__["a" /* default */],
    ModalContent: __WEBPACK_IMPORTED_MODULE_11__components_ModalContent__["a" /* default */],
    ProfileInfo: __WEBPACK_IMPORTED_MODULE_17__ProfileInfo__["a" /* default */]
  },
  data: function data() {
    return {
      user: {},
      loading: 0
    };
  },

  apollo: __WEBPACK_IMPORTED_MODULE_18__queries__["a" /* viewUser */],
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_20_vuex__["b" /* mapGetters */])(['hasPermissionUnlimitedSearch']), {
    name: function name() {
      return 'Profil #' + this.user.id;
    },
    personalInformation: function personalInformation() {
      if (!__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.user).length) {
        return [];
      }

      var _user = this.user,
          seeking_asylum = _user.seeking_asylum,
          has_at_und = _user.has_at_und,
          has_residence_permit = _user.has_residence_permit,
          city = _user.city;


      var cityName = city ? city.name : null;

      var eje = [cityName ? { label: 'Kommun:', value: cityName } : { label: 'Kommun:', value: 'Ej angivet' }, seeking_asylum && !has_at_und ? 'Jag har inte rätt att jobba än' : false, seeking_asylum && has_at_und ? 'Jag har rätt att jobba' : false, has_residence_permit ? 'Jag har uppehållstillstånd' : false].filter(Boolean);

      return eje;
    },
    languages: function languages() {
      if (!this.user.languageSkills) {
        return [];
      }

      return this.user.languageSkills.filter(__WEBPACK_IMPORTED_MODULE_19__utils_helpers__["g" /* unique */]).map(function (language) {
        return language.name;
      }).sort();
    },
    educations: function educations() {
      if (!this.user.education) {
        return [];
      }

      return this.user.education.slice().sort(__WEBPACK_IMPORTED_MODULE_19__utils_helpers__["e" /* sortByName */]);
    },
    experiences: function experiences() {
      if (!this.user.experience) {
        return [];
      }

      return this.user.experience.filter(__WEBPACK_IMPORTED_MODULE_19__utils_helpers__["g" /* unique */]).sort(__WEBPACK_IMPORTED_MODULE_19__utils_helpers__["e" /* sortByName */]);
    },
    skills: function skills() {
      if (!this.user.skills) {
        return [];
      }

      return this.user.skills.filter(__WEBPACK_IMPORTED_MODULE_19__utils_helpers__["g" /* unique */]).sort(__WEBPACK_IMPORTED_MODULE_19__utils_helpers__["e" /* sortByName */]);
    },
    career: function career() {
      if (!this.user.career) {
        return [];
      }

      return this.user.career.filter(__WEBPACK_IMPORTED_MODULE_19__utils_helpers__["g" /* unique */]).sort(__WEBPACK_IMPORTED_MODULE_19__utils_helpers__["e" /* sortByName */]);
    },
    isSeekingAsylum: function isSeekingAsylum() {
      return this.user.seeking_asylum;
    },
    hasResidencePermit: function hasResidencePermit() {
      return this.user.has_residence_permit;
    },
    hasATUND: function hasATUND() {
      return this.user.has_at_und;
    }
  }),

  methods: {
    downloadCV: function downloadCV() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data, response, blob, filename, link;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = {
                  token: __WEBPACK_IMPORTED_MODULE_22__utils_cookies__["a" /* default */].getItem('search-token'),
                  include: ['asylumStatus', 'career', 'education', 'experience', 'languageSkills', 'skills', 'city'],
                  language: 'sv'
                };
                _context.next = 3;
                return fetch(window.__API_URL__ + 'jobseekerpdf/' + _this.user.id, {
                  headers: { 'content-type': 'application/json' },
                  method: 'POST',
                  body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data)
                });

              case 3:
                response = _context.sent;
                _context.next = 6;
                return response.blob();

              case 6:
                blob = _context.sent;
                filename = 'jobskills-profile.pdf';

                if (typeof window.navigator.msSaveBlob !== 'undefined') {
                  window.navigator.msSaveBlob(blob, filename);
                } else {
                  link = document.createElement('a');

                  link.href = window.URL.createObjectURL(blob);
                  link.download = filename;

                  if (document.body) {
                    document.body.appendChild(link);
                  }

                  link.click();

                  if (document.body) {
                    document.body.removeChild(link);
                  }
                }

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    openMessageModal: function openMessageModal() {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_21__store_actionTypes__["m" /* OPEN_MODAL */], 'ModalMessage');
    }
  }
});

/***/ }),
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ExperienceRow',
  props: {
    title: String,
    subtitle: [String, Number],
    suffix: String,
    strongTitle: Boolean
  }
});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'List',
  props: {
    items: Array
  },
  computed: {
    hasItems: function hasItems() {
      return this.items && this.items.length > 0;
    }
  }
});

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Breadcrumbs',
  props: {
    currentTitle: {
      type: String,
      required: true
    },
    parentTitle: {
      type: String,
      required: true
    },
    parentUrl: {
      type: String,
      required: true
    }
  }
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_actionTypes__ = __webpack_require__(13);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Modal',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_1__components_Icon__["a" /* default */]
  },
  props: ['name'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['currentModal']), {
    isOpen: function isOpen() {
      return this.currentModal === this.name;
    }
  }),
  methods: {
    closeModal: function closeModal() {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_actionTypes__["g" /* CLOSE_MODAL */]);
    }
  }
});

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AfH2__ = __webpack_require__(47);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ModalContent',
  components: {
    AfH2: __WEBPACK_IMPORTED_MODULE_0__components_AfH2__["a" /* default */]
  }
});

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AfH4__ = __webpack_require__(78);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProfileInfo',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_0__components_Icon__["a" /* default */],
    AfH4: __WEBPACK_IMPORTED_MODULE_1__components_AfH4__["a" /* default */]
  },
  props: {
    onLinkClick: Function
  }
});

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AfH3__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Icon__ = __webpack_require__(4);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AfPopover',

  components: {
    AfH3: __WEBPACK_IMPORTED_MODULE_0__components_AfH3__["a" /* default */],
    Icon: __WEBPACK_IMPORTED_MODULE_1__components_Icon__["a" /* default */]
  },

  data: function data() {
    return {
      open: false
    };
  },


  methods: {
    toggleContent: function toggleContent() {
      this.open = !this.open;
    },
    closeContent: function closeContent() {
      this.open = false;
    }
  }
});

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Button_Button__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AfSuccessNotification__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_AfErrorNotification__ = __webpack_require__(770);




var _templateObject = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n              mutation SendMessageToUser($input: SendMessageToUserInput!) {\n                sendMessageToUser(input: $input)\n              }\n            '], ['\n              mutation SendMessageToUser($input: SendMessageToUserInput!) {\n                sendMessageToUser(input: $input)\n              }\n            ']);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'message-form',
  props: {
    userId: {
      required: true,
      type: String
    }
  },
  components: {
    'af-button': __WEBPACK_IMPORTED_MODULE_4__components_Button_Button__["a" /* default */],
    'af-error-notification': __WEBPACK_IMPORTED_MODULE_7__components_AfErrorNotification__["a" /* default */],
    'af-success-notification': __WEBPACK_IMPORTED_MODULE_6__components_AfSuccessNotification__["a" /* default */],
    Icon: __WEBPACK_IMPORTED_MODULE_5__components_Icon__["a" /* default */]
  },
  data: function data() {
    return {
      email: '',
      message: '',
      name: '',
      title: '',
      status: ''
    };
  },

  methods: {
    sendMessage: function sendMessage() {
      var _this = this;

      this.status = '';

      this.$validator.validateAll().then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(isValid) {
          var SEND_MESSAGE;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!isValid) {
                    _context.next = 11;
                    break;
                  }

                  _context.prev = 1;
                  SEND_MESSAGE = __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default()(_templateObject);
                  _context.next = 5;
                  return _this.$apollo.mutate({
                    mutation: SEND_MESSAGE,
                    variables: {
                      input: {
                        email: _this.email,
                        message: _this.message,
                        name: _this.name,
                        title: _this.title,
                        userId: parseInt(_this.userId, 10)
                      }
                    }
                  });

                case 5:

                  _this.status = 'success';
                  _context.next = 11;
                  break;

                case 8:
                  _context.prev = 8;
                  _context.t0 = _context['catch'](1);

                  _this.status = 'error';

                case 11:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this, [[1, 8]]);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'af-success-notification',

  components: {
    'icon': __WEBPACK_IMPORTED_MODULE_0__components_Icon__["a" /* default */]
  }
});

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'af-success-notification',

  components: {
    'icon': __WEBPACK_IMPORTED_MODULE_0__components_Icon__["a" /* default */]
  }
});

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AfH4__ = __webpack_require__(78);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProfileInfo',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_0__components_Icon__["a" /* default */],
    AfH4: __WEBPACK_IMPORTED_MODULE_1__components_AfH4__["a" /* default */]
  },
  props: {
    onLinkClick: Function
  }
});

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'accessdenied',
  data: function data() {
    return {
      error: ''
    };
  },
  created: function created() {
    this.error = this.$route.query.error;
  }
});

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AfH1__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ExternalLink__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Icon__ = __webpack_require__(4);






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AfH1: __WEBPACK_IMPORTED_MODULE_0__components_AfH1__["a" /* default */],
    ExternalLink: __WEBPACK_IMPORTED_MODULE_1__components_ExternalLink__["a" /* default */],
    Icon: __WEBPACK_IMPORTED_MODULE_2__components_Icon__["a" /* default */]
  },
  name: 'PageNotFound',
  data: function data() {
    return {
      baseURL: window.__BASE_URL__
    };
  }
});

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AfH1__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AfH2__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AfH3__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ExternalLink__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Breadcrumbs__ = __webpack_require__(117);








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AfH1: __WEBPACK_IMPORTED_MODULE_0__components_AfH1__["a" /* default */],
    AfH2: __WEBPACK_IMPORTED_MODULE_1__components_AfH2__["a" /* default */],
    AfH3: __WEBPACK_IMPORTED_MODULE_2__components_AfH3__["a" /* default */],
    ExternalLink: __WEBPACK_IMPORTED_MODULE_3__components_ExternalLink__["a" /* default */],
    Breadcrumbs: __WEBPACK_IMPORTED_MODULE_4__components_Breadcrumbs__["a" /* default */]
  },
  name: 'employerinfo'
});

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AfH1__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AfH2__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AfH3__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ExternalLink__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Breadcrumbs__ = __webpack_require__(117);









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AfH1: __WEBPACK_IMPORTED_MODULE_0__components_AfH1__["a" /* default */],
    AfH2: __WEBPACK_IMPORTED_MODULE_1__components_AfH2__["a" /* default */],
    AfH3: __WEBPACK_IMPORTED_MODULE_2__components_AfH3__["a" /* default */],
    ExternalLink: __WEBPACK_IMPORTED_MODULE_3__components_ExternalLink__["a" /* default */],
    Icon: __WEBPACK_IMPORTED_MODULE_4__components_Icon__["a" /* default */],
    Breadcrumbs: __WEBPACK_IMPORTED_MODULE_5__components_Breadcrumbs__["a" /* default */]
  },
  name: 'Contact'
});

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AfH1__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AfH2__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ExternalLink__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Breadcrumbs__ = __webpack_require__(117);








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AfH1: __WEBPACK_IMPORTED_MODULE_0__components_AfH1__["a" /* default */],
    AfH2: __WEBPACK_IMPORTED_MODULE_1__components_AfH2__["a" /* default */],
    ExternalLink: __WEBPACK_IMPORTED_MODULE_2__components_ExternalLink__["a" /* default */],
    Icon: __WEBPACK_IMPORTED_MODULE_3__components_Icon__["a" /* default */],
    Breadcrumbs: __WEBPACK_IMPORTED_MODULE_4__components_Breadcrumbs__["a" /* default */]
  },
  name: 'AboutJobskills'
});

/***/ }),
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handleErrors", function() { return handleErrors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "authLink", function() { return authLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "swedish", function() { return swedish; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_polyfill__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_polyfill__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_what_input__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_what_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_what_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_whatwg_fetch__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__variables_icons__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vee_validate_dist_locale_sv__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vee_validate_dist_locale_sv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vee_validate_dist_locale_sv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vee_validate__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__App__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__router__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_store__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_actionTypes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_apollo_cache_hermes__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_apollo_cache_hermes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_apollo_cache_hermes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_apollo_client__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_apollo_link__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_apollo_link_context__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_apollo_link_error__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_apollo_link_http__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_apollo__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuejs_paginate__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuejs_paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vuejs_paginate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_scrollto__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_portal_vue__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_portal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_portal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_awesome_components_Icon__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_cookies__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__utils_helpers__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__utils_requiredFields__ = __webpack_require__(845);






























var logOut = function logOut() {
  __WEBPACK_IMPORTED_MODULE_11__store_store__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_12__store_actionTypes__["k" /* LOG_OUT */]);
  __WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */].push('/');
};

var handleErrors = function handleErrors(_ref) {
  var graphQLErrors = _ref.graphQLErrors;

  var token = __WEBPACK_IMPORTED_MODULE_24__utils_cookies__["a" /* default */].getItem('search-token');

  if (graphQLErrors.length > 0 && !token) {
    logOut();
  }
};

var authLink = Object(__WEBPACK_IMPORTED_MODULE_16_apollo_link_context__["a" /* setContext */])(function (root, _ref2) {
  var headers = _ref2.headers;

  var token = __WEBPACK_IMPORTED_MODULE_24__utils_cookies__["a" /* default */].getItem('search-token');

  if (!token) {
    return { headers: headers };
  }

  var tokenExpires = Object(__WEBPACK_IMPORTED_MODULE_25__utils_helpers__["b" /* deconstructJWT */])(token).exp;

  if (Date.now() - tokenExpires * 1000 > 0) {
    __WEBPACK_IMPORTED_MODULE_24__utils_cookies__["a" /* default */].removeItem('search-token');
    logOut();

    return { headers: headers };
  }

  return {
    headers: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, headers, {
      Authorization: token ? 'Bearer ' + token : ''
    })
  };
});

var httpLink = new __WEBPACK_IMPORTED_MODULE_18_apollo_link_http__["a" /* HttpLink */]({
  uri: __API_URL__ + 'graphql'
});

var link = __WEBPACK_IMPORTED_MODULE_15_apollo_link__["a" /* ApolloLink */].from([Object(__WEBPACK_IMPORTED_MODULE_17_apollo_link_error__["a" /* onError */])(handleErrors), authLink, httpLink]);

var apolloClient = new __WEBPACK_IMPORTED_MODULE_14_apollo_client__["a" /* ApolloClient */]({
  cache: new __WEBPACK_IMPORTED_MODULE_13_apollo_cache_hermes__["Hermes"]({
    entityIdForNode: function entityIdForNode(r) {
      if (r.path && r.__typename) {
        return r.__typename + ':' + r.path;
      }

      if (r.id && r.__typename) {
        return r.__typename + ':' + r.id;
      }

      return r.id;
    },
    addTypename: true
  }),
  link: link,
  connectToDevTools: true
});

var swedish = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_7_vee_validate_dist_locale_sv___default.a, {
  messages: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_7_vee_validate_dist_locale_sv___default.a.messages, {
    email: 'Ogiltig mejladress',
    required: __WEBPACK_IMPORTED_MODULE_26__utils_requiredFields__["a" /* requiredFields */]
  })
});

__WEBPACK_IMPORTED_MODULE_8_vee_validate__["a" /* Validator */].localize('sv', swedish);

__WEBPACK_IMPORTED_MODULE_6_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vee_validate__["b" /* default */], {
  events: 'blur'
});
__WEBPACK_IMPORTED_MODULE_6_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_19_vue_apollo__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_6_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_21_vue_scrollto___default.a);
__WEBPACK_IMPORTED_MODULE_6_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_22_portal_vue___default.a);
__WEBPACK_IMPORTED_MODULE_6_vue__["default"].component('AwesomeIcon', __WEBPACK_IMPORTED_MODULE_23_vue_awesome_components_Icon__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_6_vue__["default"].component('paginate', __WEBPACK_IMPORTED_MODULE_20_vuejs_paginate___default.a);

var apolloProvider = new __WEBPACK_IMPORTED_MODULE_19_vue_apollo__["a" /* default */]({
  defaultClient: apolloClient
});

__WEBPACK_IMPORTED_MODULE_6_vue__["default"].config.productionTip = false;

window.eventBus = new __WEBPACK_IMPORTED_MODULE_6_vue__["default"]({});

new __WEBPACK_IMPORTED_MODULE_6_vue__["default"]({
  apolloProvider: apolloProvider,
  router: __WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_11__store_store__["a" /* default */],
  el: '#app',
  components: { App: __WEBPACK_IMPORTED_MODULE_9__App__["a" /* default */] },
  template: '<App/>'
});

/***/ }),
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);


if (!String.prototype.startsWith) {
  String.prototype.startsWith = function (searchString, position) {
    position = position || 0;
    return this.substr(position, searchString.length) === searchString;
  };
}

if (!('classList' in document.createElementNS('http://www.w3.org/2000/svg', 'g'))) {
  var descr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(HTMLElement.prototype, 'classList');
  Object.defineProperty(SVGElement.prototype, 'classList', descr);
}

/***/ }),
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_icons_angle_down__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_icons_angle_right__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons_angle_up__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_icons_bars__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_icons_caret_down__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_icons_caret_up__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_icons_check__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_icons_chevron_left__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_awesome_icons_chevron_right__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_awesome_icons_circle__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_awesome_icons_circle_o_notch__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_awesome_icons_download__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_awesome_icons_envelope__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_awesome_icons_exclamation_circle__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_awesome_icons_external_link__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_awesome_icons_info_circle__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_awesome_icons_phone__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_awesome_icons_search__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_awesome_icons_times__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_awesome_icons_undo__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_awesome_icons_user__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_awesome_icons_facebook_f__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_awesome_icons_twitter__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_awesome_icons_linkedin__ = __webpack_require__(556);



























/***/ }),
/* 530 */,
/* 531 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 532 */,
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.klass,style:(_vm.style),attrs:{"version":"1.1","role":_vm.label ? 'img' : 'presentation',"aria-label":_vm.label,"x":_vm.x,"y":_vm.y,"width":_vm.width,"height":_vm.height,"viewBox":_vm.box}},[_vm._t("default",[(_vm.icon && _vm.icon.paths)?_vm._l((_vm.icon.paths),function(path,i){return _c('path',_vm._b({key:("path-" + i)},'path',path,false))}):_vm._e(),_vm._v(" "),(_vm.icon && _vm.icon.polygons)?_vm._l((_vm.icon.polygons),function(polygon,i){return _c('polygon',_vm._b({key:("polygon-" + i)},'polygon',polygon,false))}):_vm._e(),_vm._v("\b\n    "),(_vm.icon && _vm.icon.raw)?[_c('g',{domProps:{"innerHTML":_vm._s(_vm.raw)}})]:_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(215);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dea1056_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(581);
function injectStyle (ssrContext) {
  __webpack_require__(562)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dea1056_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 562 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppHeader_vue__ = __webpack_require__(216);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_efc498ae_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeader_vue__ = __webpack_require__(574);
function injectStyle (ssrContext) {
  __webpack_require__(564)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-efc498ae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_efc498ae_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 564 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 565 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",class:{
    'btn-default': _vm.buttonStyle === 'default',
    'btn-primary': _vm.buttonStyle === 'primary',
    'btn-nis-primary': _vm.buttonStyle === 'nis-primary',
    'btn-success': _vm.buttonStyle === 'success',
    'btn-sm': _vm.size === 'small',
    'btn-lg': _vm.size === 'large',
    'btn-lowercase': _vm.lowercase
  },attrs:{"disabled":_vm.disabled,"type":_vm.type},on:{"click":_vm.handleClick}},[_vm._t("icon"),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 567 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-wrapper"},[_c('awesome-icon',{attrs:{"color":_vm.fillColor,"height":_vm.size,"name":_vm.type,"spin":_vm.spin,"width":_vm.size}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 569 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:{ inline: _vm.inline },attrs:{"href":_vm.href,"target":"_blank"}},[_c('icon',{attrs:{"link":"","type":"external-link"}}),_vm._v(" "),_c('span',[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AfSidemenu_vue__ = __webpack_require__(220);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6aad54a8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AfSidemenu_vue__ = __webpack_require__(573);
function injectStyle (ssrContext) {
  __webpack_require__(572)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6aad54a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AfSidemenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6aad54a8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AfSidemenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 572 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidemenu__wrap"},[_c('div',{staticClass:"sidemenu__close-wrap"},[_c('span',{on:{"click":_vm.handleClick}},[_vm._v("Stäng "),_c('icon',{attrs:{"fill":"white","type":"times"}})],1)]),_vm._v(" "),_c('div',{staticClass:"sidemenu__link-wrap"},[_c('span',{on:{"click":_vm.handleClick}},[_c('router-link',{attrs:{"to":"/arbetsgivarinformation"}},[_vm._v("\n      Att anställa asylsökande och nyanlända\n      ")])],1)]),_vm._v(" "),_c('div',{staticClass:"sidemenu__link-wrap"},[_c('span',{on:{"click":_vm.handleClick}},[_c('router-link',{attrs:{"to":"/om-jobskills"}},[_vm._v("\n      Om Jobskills\n      ")])],1)]),_vm._v(" "),_c('div',{staticClass:"sidemenu__link-bottom"},[_c('a',{attrs:{"href":_vm.jobskillsURL}},[_c('icon',{attrs:{"link":"","type":"angle-right"}}),_vm._v(" Gå till Jobskills för arbetssökande")],1)]),_vm._v(" "),_c('div',{staticClass:"sidemenu__link-bottom"},[_c('span',{on:{"click":_vm.handleClick}},[_c('router-link',{staticClass:"sidemenu__link-bottom-phone",attrs:{"to":"/kontakta-oss"}},[_c('icon',{attrs:{"link":"","type":"phone"}}),_vm._v(" Kontakt")],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',{staticClass:"app-header"},[_c('div',{staticClass:"header__inner"},[(_vm.hasPermissionUnlimitedSearch)?_c('div',{staticClass:"header__title-bar"},[_c('h1',{staticClass:"header__title"},[_vm._v("Jobskills")]),_vm._v(" "),_c('h2',{staticClass:"header__subtitle"},[_vm._v("Sök")])]):_c('div',{staticClass:"header__title-bar"},[_c('router-link',{staticClass:"header__title-bar-wrap",attrs:{"to":"/"}},[_c('img',{staticClass:"header__logo",attrs:{"src":(_vm.baseURL + "static/img/jobskills_logo.png")}})]),_vm._v(" "),_c('div',{staticClass:"separator"}),_vm._v(" "),_c('img',{staticClass:"header__logo-af",attrs:{"src":(_vm.baseURL + "static/img/af_logo_new_dark.svg")}})],1),_vm._v(" "),_c('div',{staticClass:"header__switch-wrap",class:{
        'header__switch-wrap-hidden': _vm.loggedIn
      }},[_c('a',{staticClass:"header__switch-external",attrs:{"href":_vm.jobskillsURL}},[_vm._v("Arbetssökande")]),_vm._v(" "),_c('router-link',{staticClass:"header__switch-internal",attrs:{"to":"/"}},[_vm._v("Arbetsgivare")])],1),_vm._v(" "),_c('div',{staticClass:"header__login-wrap"},[(_vm.loggedIn)?_c('div',{staticClass:"logged-in"},[_c('af-button',{staticClass:"logged-in__white-btn",attrs:{"lowercase":"","buttonStyle":"default"},on:{"clicked":_vm.logout}},[_c('icon',{attrs:{"slot":"icon","type":"user"},slot:"icon"}),_vm._v("\n            Logga ut\n          ")],1),_vm._v(" "),_c('af-button',{staticClass:"logged-out__blue-btn",attrs:{"lowercase":"","buttonStyle":"primary"},on:{"clicked":_vm.logout}},[_c('icon',{attrs:{"slot":"icon","fill":"white","type":"user"},slot:"icon"}),_vm._v("\n            Logga ut\n          ")],1)],1):_c('div',{staticClass:"logged-out"},[_c('af-button',{staticClass:"logged-out__white-btn",attrs:{"lowercase":"","buttonStyle":"default"},on:{"clicked":_vm.login}},[_c('icon',{attrs:{"slot":"icon","type":"user"},slot:"icon"}),_vm._v(" Logga in\n          ")],1),_vm._v(" "),_c('af-button',{staticClass:"logged-out__blue-btn",attrs:{"lowercase":"","buttonStyle":"primary"},on:{"clicked":_vm.login}},[_c('icon',{attrs:{"slot":"icon","fill":"white","type":"user"},slot:"icon"}),_vm._v(" Logga in\n          ")],1)],1),_vm._v(" "),_c('af-button',{staticClass:"header__logo_menu",attrs:{"lowercase":"","buttonStyle":"primary"},on:{"clicked":_vm.toggleSidebarOpen}},[_c('icon',{attrs:{"slot":"icon","fill":"white","type":"bars"},slot:"icon"}),_vm._v("\n          Meny\n        ")],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"header__sidemenu",class:{
    'header__sidemenu_open': _vm.sidebarOpen,
    'header__sidemenu_close': !_vm.sidebarLoading && !_vm.sidebarOpen
  }},[_c('af-sidemenu',{on:{"clicked":_vm.toggleSidebarOpen}})],1),_vm._v(" "),(_vm.hasPermissionUserEmailBatches)?_c('header',{staticClass:"app-header-navigation"},[_c('div',{staticClass:"header__inner"},[_c('ul',{staticClass:"header__navigation"},[_c('li',[_c('router-link',{attrs:{"to":"start"}},[_vm._v("Sök")]),_vm._v(" "),_c('router-link',{attrs:{"to":"utskick"}},[_vm._v("Utskick")])],1)])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppFooter_vue__ = __webpack_require__(221);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c40b7900_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppFooter_vue__ = __webpack_require__(580);
function injectStyle (ssrContext) {
  __webpack_require__(576)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c40b7900"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c40b7900_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 576 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Share_vue__ = __webpack_require__(222);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01f6beff_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Share_vue__ = __webpack_require__(579);
function injectStyle (ssrContext) {
  __webpack_require__(578)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01f6beff"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Share_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01f6beff_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Share_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 578 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"af-share"},[_c('div',[_vm._v("Tipsa en vän om Jobskills")]),_vm._v(" "),_c('div',{staticClass:"af-share__options"},_vm._l((_vm.shareOptions),function(option){return _c('a',{key:option.iconType,staticClass:"af-share__link",attrs:{"href":option.link}},[_c('icon',{attrs:{"fill":"#fff","type":option.iconType}})],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"app-footer"},[_c('div',{staticClass:"footer__inner"},[_c('div',{staticClass:"footer__aside"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"footer__links"},[_c('div',{staticClass:"footer__link"},[_c('router-link',{attrs:{"to":"/om-jobskills"}},[_vm._v("\n            Om Jobskills\n          ")])],1),_vm._v(" "),_c('div',{staticClass:"footer__link"},[_c('router-link',{attrs:{"to":"/arbetsgivarinformation"}},[_vm._v("\n            Arbetsgivarinformation\n          ")])],1),_vm._v(" "),_c('div',{staticClass:"footer__link"},[_c('a',{attrs:{"href":_vm.jobskillsURL}},[_vm._v("\n            Gå till Jobskills för Arbetssökande\n          ")])]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"footer__logo--desktop"},[_c('a',{attrs:{"href":"https://www.arbetsformedlingen.se","target":"_blank"}},[_c('img',{attrs:{"src":(_vm.baseURL + "static/img/af_logo_new.svg")}})])])]),_vm._v(" "),_c('div',{staticClass:"footer__content"},[_c('div',{staticClass:"footer__separator"}),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"footer__separator"}),_vm._v(" "),_c('div',{staticClass:"footer__logo--mobile"},[_c('a',{attrs:{"href":"https://www.arbetsformedlingen.se","target":"_blank"}},[_c('img',{attrs:{"src":(_vm.baseURL + "static/img/af_logo_new.svg")}})])]),_vm._v(" "),_c('div',{staticClass:"footer__link footer__facebook-link",attrs:{"target":"_blank"}},[_c('a',{attrs:{"href":"http://facebook.com/jobskills.se"}},[_vm._v("Följ Jobskills på Facebook")]),_vm._v(" "),_c('af-share')],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer__links"},[_c('div',{staticClass:"footer__link"},[_c('a',{attrs:{"href":"https://arbetsformedlingen.se/kontakt/","target":"_blank"}},[_vm._v("\n            Kontakta oss\n          ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer__link"},[_c('a',{attrs:{"href":"https://arbetsformedlingen.se/om-webbplatsen/juridisk-information/sa-hanterar-vi-dina-personuppgifter","target":"_blank"}},[_vm._v("\n            Så hanterar vi dina personuppgifter\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer__section"},[_c('h2',{staticClass:"footer__section-title"},[_vm._v("Om Jobskills")]),_vm._v(" "),_c('p',[_vm._v("Jobskills är en tjänst för personer som är nya i Sverige och för arbetsgivare som vill hitta ny kompetens. Tjänsten är framtagen av Arbetsförmedlingen med syfte att underlätta etableringen på arbetsmarknaden för personer som är nya i Sverige.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('app-header'),_vm._v(" "),_c('div',{staticClass:"app-content",class:{
      'app-content-white': _vm.whiteBackground
    }},[_c('router-view')],1),_vm._v(" "),_c('app-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Search_Search__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Login__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Profile_Profile__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_403__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_404__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_LoggedOut__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_EmployerInfo__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Contact__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_AboutJobskills__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__navigationGuards__ = __webpack_require__(798);













__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  base: window.__BASE__,
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_3__views_Login__["a" /* default */]
  }, {
    path: '/sok',
    name: 'Sök',
    component: __WEBPACK_IMPORTED_MODULE_2__views_Search_Search__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_11__navigationGuards__["a" /* requireToken */]
  }, {
    path: '/profile/:id',
    name: 'Profile',
    component: __WEBPACK_IMPORTED_MODULE_4__views_Profile_Profile__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_11__navigationGuards__["a" /* requireToken */]
  }, {
    path: '/403',
    name: '403',
    component: __WEBPACK_IMPORTED_MODULE_5__views_403__["a" /* default */]
  }, {
    path: '/logged-out',
    name: 'logout',
    component: __WEBPACK_IMPORTED_MODULE_7__views_LoggedOut__["a" /* default */]
  }, {
    path: '/arbetsgivarinformation',
    name: 'EmployerInfo',
    component: __WEBPACK_IMPORTED_MODULE_8__views_EmployerInfo__["a" /* default */]
  }, {
    path: '/kontakta-oss',
    name: 'Contact',
    component: __WEBPACK_IMPORTED_MODULE_9__views_Contact__["a" /* default */]
  }, {
    path: '/om-jobskills',
    name: 'AboutJobskills',
    component: __WEBPACK_IMPORTED_MODULE_10__views_AboutJobskills__["a" /* default */]
  }, {
    path: '*',
    name: '404',
    component: __WEBPACK_IMPORTED_MODULE_6__views_404__["a" /* default */]
  }],
  scrollBehavior: function scrollBehavior() {
    return { x: 0, y: 0 };
  }
}));

/***/ }),
/* 583 */,
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__ = __webpack_require__(223);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_395838af_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__(722);
function injectStyle (ssrContext) {
  __webpack_require__(585)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-395838af"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_395838af_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 585 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchField_vue__ = __webpack_require__(224);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f47ae65_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchField_vue__ = __webpack_require__(694);
function injectStyle (ssrContext) {
  __webpack_require__(587)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1f47ae65"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchField_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f47ae65_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchField_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 587 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 597 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"h2",class:[_vm.noMarginTop ? 'h2-no-margin-top' : '']},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-field-input"},[_c('af-h2',{attrs:{"noMarginTop":""}},[_c('label',{staticClass:"search-field-input__label",attrs:{"for":_vm.name}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n    ")])]),_vm._v(" "),_c('input',{staticClass:"search-field-input__input",attrs:{"id":_vm.name,"name":_vm.name,"placeholder":_vm.placeholder,"type":"text"},domProps:{"value":_vm.value},on:{"blur":_vm.handleBlur,"focus":_vm.handleFocus,"input":_vm.handleChange}}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchLocations_vue__ = __webpack_require__(229);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75381300_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchLocations_vue__ = __webpack_require__(620);
function injectStyle (ssrContext) {
  __webpack_require__(601)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-75381300"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchLocations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75381300_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchLocations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 601 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-counties"},[(_vm.displayDropdown)?_c('div',{staticClass:"search-counties__overlay",on:{"click":_vm.clearSearch}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"search-counties__fields"},[_c('search-field-input',{attrs:{"value":_vm.city,"label":"I vilket område?","name":"county","placeholder":"Skriv kommun eller län"},on:{"update:value":[function($event){_vm.city=$event},_vm.findCity]}},[[(_vm.hasFoundCities)?_c('ul',{staticClass:"search-counties__results"},_vm._l((_vm.foundCities),function(city){return _c('li',{key:city.path,staticClass:"search-counties__results-item",on:{"click":function($event){_vm.addLocation(city)}}},[_c('strong',[_vm._v(_vm._s(city.name))]),_vm._v(" "),(city.__typename === 'Municipality')?_c('span',[_vm._v("kommun")]):_vm._e()])}),0):_vm._e(),_vm._v(" "),(_vm.noResults)?_c('ul',{staticClass:"search-counties__results search-counties__results--no-results"},[_c('li',{staticClass:"search-counties__no-results-item"},[_vm._v("\n            Tyvärr finns inte det område du söker\n          ")])]):_vm._e()]],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchButton_vue__ = __webpack_require__(239);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31c9a6df_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchButton_vue__ = __webpack_require__(626);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31c9a6df_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchFieldResults_vue__ = __webpack_require__(240);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33fd24b4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchFieldResults_vue__ = __webpack_require__(638);
function injectStyle (ssrContext) {
  __webpack_require__(628)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-33fd24b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchFieldResults_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33fd24b4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchFieldResults_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 628 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 629 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"h4"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 631 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 632 */,
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider"},[_c('af-h4',{staticClass:"slider-title"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"slider-values"},[(_vm.isMinValue)?_c('span',[_vm._v("0 år")]):_c('span',[_vm._v(_vm._s(_vm.minValue)+" år")]),_vm._v(" "),(_vm.isMaxValue)?_c('span',[_vm._v("över "+_vm._s(_vm.maxValue)+" år")]):_c('span',[_vm._v(_vm._s(_vm.maxValue)+" år")])]),_vm._v(" "),_c('div',{staticClass:"vue-nouislider",attrs:{"id":_vm.sliderId}}),_vm._v(" "),(_vm.showButton)?_c('div',{staticClass:"slider__button"},[_c('af-button',{attrs:{"buttonStyle":"primary","lowercase":""},on:{"clicked":function($event){_vm.click(_vm.minValue, _vm.maxValue)}}},[_vm._v("\n      Lägg till\n    ")])],1):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.isMinValue && !_vm.showButton)?_c('div',{staticClass:"slider__information"},[_c('icon',{staticClass:"slider__information-icon",attrs:{"link":"","type":"info-circle"}}),_vm._v(" "),_c('span',[_vm._v("Valet inkluderar kandidater som angett yrket som ett yrkesönskemål.")])],1):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 634 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-wrapper"},[_c('div',{staticClass:"loading-indicator",style:({
      height: _vm.size + 'px',
      marginBottom: _vm.margin + 'px',
      marginTop: _vm.margin + 'px',
      width: _vm.size + 'px'
    }),attrs:{"aria-live":"assertive","aria-label":"Vänta, informationen laddas..."}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 636 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown",class:{ oneLine: _vm.oneLine }},[(_vm.placeholder)?_c('label',{staticClass:"dropdown__label"},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"dropdown__select-wrapper"},[_c('div',{staticClass:"dropdown__select",class:{ oneLine: _vm.oneLine, open: _vm.open, disabled: _vm.disabled },on:{"click":function($event){$event.stopPropagation();return _vm.openList($event)}}},[_c('input',{staticClass:"dropdown__input",attrs:{"disabled":_vm.disabled,"name":_vm.name,"placeholder":_vm.inlinePlaceholder,"readonly":""},domProps:{"value":_vm.getValue},on:{"keyup":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.arrowSelect($event)},function($event){if(!('button' in $event)&&$event.keyCode!==38){ return null; }return _vm.arrowUp($event)},function($event){if(!('button' in $event)&&$event.keyCode!==40){ return null; }return _vm.arrowDown($event)}]}}),_vm._v(" "),_c('icon',{class:{ 'icon-disabled': _vm.disabled },attrs:{"type":_vm.open ? 'caret-up' : 'caret-down'}})],1),_vm._v(" "),(_vm.displayList)?_c('ul',{ref:"results",staticClass:"dropdown__list"},_vm._l((_vm.filteredOptions),function(option,index){return _c('li',{key:index,ref:"resultItem",refInFor:true,staticClass:"dropdown__list-item",class:{ active: _vm.arrowSelected === index },on:{"click":function($event){_vm.setOption(option)}}},[_vm._v("\n        "+_vm._s(option[_vm.selector])+"\n      ")])}),0):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.displayOverlay)?_c('div',{staticClass:"search-field-results__overlay",on:{"click":_vm.searchDone}}):_vm._e(),_vm._v(" "),(_vm.isLoading === 1)?_c('div',{staticClass:"search-field-results"},[_c('section',{staticClass:"search-fields-results__sections"},[_c('div',{staticClass:"search-field-results__section"},[_c('af-h4',[_vm._v("\n          Yrken\n        ")]),_vm._v(" "),(_vm.isLoading === 1)?_c('af-spinner',{attrs:{"margin":30,"size":45}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"search-field-results__section"},[_c('af-h4',[_vm._v("\n          Kompetenser\n        ")]),_vm._v(" "),(_vm.isLoading === 1)?_c('af-spinner',{attrs:{"margin":30,"size":45}}):_vm._e()],1)])]):_vm._e(),_vm._v(" "),(_vm.hasCompetences || _vm.hasProfessions)?_c('div',[(!_vm.noResults)?_c('div',{staticClass:"search-field-results"},[_c('section',{staticClass:"search-fields-results__sections"},[(_vm.hasProfessions)?_c('div',{staticClass:"search-field-results__section"},[_c('af-h4',[_vm._v("\n            YRKEN\n          ")]),_vm._v(" "),_c('ul',{staticClass:"search-field-results__list"},_vm._l((_vm.professions),function(profession){return _c('li',{key:profession.path,staticClass:"search-field-results__list-item"},[(!profession.parentName.length)?_c('div',{domProps:{"innerHTML":_vm._s(profession.searchName)},on:{"click":function($event){_vm.toggleSlider(profession)}}}):_c('div',{domProps:{"innerHTML":_vm._s(((profession.searchName) + " (" + (profession.parentName) + ")"))},on:{"click":function($event){_vm.toggleSlider(profession)}}}),_vm._v(" "),(_vm.sliderState(profession.path))?_c('div',{staticClass:"search-field-results__range"},[_c('af-range',{attrs:{"showButton":true,"config":{step: 1, connect: true, range: {min: [0], max: [10]}},"values":[0, 10]},on:{"clickedSliderButton":function($event){_vm.addProfession($event, profession)}}},[_vm._v("\n                  Vilken erfarenhet krävs?\n                ")])],1):_vm._e()])}),0)],1):_vm._e(),_vm._v(" "),(_vm.hasCompetences)?_c('div',{staticClass:"search-field-results__section"},[_c('af-h4',[_vm._v("\n            KOMPETENSER\n          ")]),_vm._v(" "),_c('ul',{staticClass:"search-field-results__list"},_vm._l((_vm.competences),function(competence){return _c('li',{key:competence.path,staticClass:"search-field-results__list-item"},[_c('div',{staticClass:"search-field-results__competence__title",domProps:{"innerHTML":_vm._s(competence.searchName)},on:{"click":function($event){_vm.toggleDropdown(competence)}}}),_vm._v(" "),(_vm.dropdownState(competence.path))?_c('div',{staticClass:"search-field-results__dropdown"},[_c('af-h4',{staticClass:"search-field-results__dropdown-title"},[_vm._v("Vilken erfarenhet efterfrågas?")]),_vm._v(" "),_c('search-dropdown',{attrs:{"options":_vm.years,"inlinePlaceholder":"Välj kompetensnivå","label":"Vilken erfarenhet efterfrågas?","name":"competenceYears"},on:{"changed":function($event){_vm.addCompetence($event, competence)}}})],1):_vm._e()])}),0)],1):_vm._e()])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.noResults)?_c('div',{staticClass:"search-field-results__no-results"},[_vm._v("\n    Tyvärr finns inte det du söker\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchTabs_vue__ = __webpack_require__(246);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dfe0aa4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchTabs_vue__ = __webpack_require__(686);
function injectStyle (ssrContext) {
  __webpack_require__(640)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6dfe0aa4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchTabs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dfe0aa4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchTabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 640 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchTab_vue__ = __webpack_require__(247);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d826135_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchTab_vue__ = __webpack_require__(643);
function injectStyle (ssrContext) {
  __webpack_require__(642)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d826135"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchTab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d826135_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchTab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 642 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-tab-wrap",class:{
    'search-tab-wrap--active': _vm.isActive
  }},[_c('div',{staticClass:"search-tab",class:{
      'search-tab--active': _vm.isActive,
      'search-tab--inactive': _vm.isInactive,
    },attrs:{"role":"button"},on:{"click":_vm.setActiveTab}},[_c('span',{staticClass:"search-tab__text"},[_vm._t("default"),_vm._v(" "),(_vm.hasSelectedItems)?_c('span',{staticClass:"search-tab__text-number"},[_vm._v(_vm._s(_vm.numberOfSelectedItems))]):_vm._e()],2),_vm._v(" "),(_vm.isActive)?_c('icon',{attrs:{"link":"","type":"angle-up"}}):_c('icon',{attrs:{"link":"","type":"angle-down"}})],1),_vm._v(" "),_c('portal-target',{attrs:{"name":_vm.portalName}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchExperiences_vue__ = __webpack_require__(248);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fafd6de_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchExperiences_vue__ = __webpack_require__(659);
function injectStyle (ssrContext) {
  __webpack_require__(645)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5fafd6de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchExperiences_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fafd6de_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchExperiences_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 645 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 646 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 647 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox"},[_c('input',{staticClass:"input",attrs:{"disabled":_vm.disabled,"id":_vm.name,"name":_vm.name,"type":"checkbox"},domProps:{"checked":_vm.checked},on:{"change":function($event){_vm.onChange($event, _vm.name)}}}),_vm._v(" "),_c('label',{staticClass:"indicator",attrs:{"for":_vm.name}}),_vm._v(" "),_c('label',{staticClass:"checkbox__label",attrs:{"for":_vm.name}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"af-expansion-panel",class:{
    'af-expansion-panel--level-2': _vm.isLevelTwo,
    'af-expansion-panel--level-3': _vm.isLevelThree,
    'af-expansion-panel--active': _vm.expanded,
    'af-expansion-panel--is-folder': _vm.isFolder
  }},[_c('div',{staticClass:"panel",class:{
      'panel--level-2': _vm.isLevelTwo,
      'panel--level-3': _vm.isLevelThree,
      'panel--is-folder': _vm.isFolder,
      'panel--active': _vm.expanded
    }},[_c('div',{class:'panel__checkbox-indicator ' + _vm.status,attrs:{"role":"button"},on:{"click":_vm.addToQuery}}),_vm._v(" "),_c('div',{staticClass:"panel__title",on:{"click":_vm.toggleExpanded}},[_c('div',{staticClass:"panel__title-name"},[_vm._v("\n        "+_vm._s(_vm.name)+"\n        "),(_vm.numberOfSelectedChildren)?_c('strong',[_vm._v(_vm._s(_vm.numberOfSelectedChildren)+" val")]):_vm._e()]),_vm._v(" "),(_vm.isFolder)?_c('div',{staticClass:"panel__toggle"},[(_vm.expanded)?_c('span',{staticClass:"panel__close"},[_vm._v("\n          Stäng\n          "),_c('icon',{attrs:{"fill":_vm.isLevelOne ? 'white' : 'black',"type":"angle-up"}})],1):_c('icon',{staticClass:"panel__icon",attrs:{"link":"","type":"angle-down"}})],1):_vm._e()])]),_vm._v(" "),(_vm.isExperiences)?_c('div',{staticClass:"panel__range"},[_c('af-range',{attrs:{"config":{step: 1, connect: true, range: {min: [0], max: [10]}},"values":[_vm.rangeMin, _vm.rangeMax]},on:{"newValueSet":function($event){_vm.addYearsToQuery($event, _vm.model)}}},[_vm._v("\n      Vilken erfarenhet efterfrågas?\n    ")])],1):_vm._e(),_vm._v(" "),(_vm.isSkills)?_c('div',{staticClass:"panel__range"},[_c('div',{staticClass:"panel__range-dropdown"},[_c('af-h4',{staticClass:"panel__range-title"},[_vm._v("Vilken erfarenhet efterfrågas?")]),_vm._v(" "),_c('search-dropdown',{attrs:{"options":_vm.skillYears,"value":_vm.rangeMin,"inlinePlaceholder":"Välj kompetensnivå","label":"Vilken erfarenhet efterfrågas?","name":"educationYears"},on:{"changed":_vm.addYearsToQuery}})],1)]):_vm._e(),_vm._v(" "),(_vm.isFolder)?_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.expanded),expression:"expanded"}]},_vm._l((_vm.children),function(child){return _c('af-expansion-panel',{key:child.path,attrs:{"level":_vm.level + 1,"model":child,"queryType":_vm.queryType},on:{"openParent":_vm.expandPanel}})}),1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 650 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-local__search-wrapper"},[_c('div',{staticClass:"search-local__search-field"},[_c('icon',{staticClass:"search-local__search-icon",attrs:{"fill":"rgb(113, 117, 121)","type":"search"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.query),expression:"query"}],staticClass:"search-local__search-input",class:{
        'search-local__search-icon--results': _vm.hasHits
      },attrs:{"placeholder":_vm.placeholder},domProps:{"value":(_vm.query)},on:{"keyup":_vm.onSearch,"input":function($event){if($event.target.composing){ return; }_vm.query=$event.target.value}}})],1),_vm._v(" "),(_vm.hasHits)?_c('ul',{staticClass:"search-local__search-results"},_vm._l((_vm.hits),function(hit){return _c('li',{key:hit.path,staticClass:"search-local__search-result",domProps:{"innerHTML":_vm._s(hit.highlightedName)},on:{"click":function($event){_vm.onClickResult(hit)}}})}),0):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 652 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasSelectedItems)?_c('footer',{staticClass:"search__footer"},[_c('a',{staticClass:"search__clear-link",attrs:{"href":"#"},on:{"click":function($event){_vm.handleClear($event)}}},[_c('icon',{attrs:{"link":"","type":"times"}}),_vm._v("\n    Rensa alla val\n  ")],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 654 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AfTooltip_vue__ = __webpack_require__(254);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea9f2f94_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AfTooltip_vue__ = __webpack_require__(657);
function injectStyle (ssrContext) {
  __webpack_require__(656)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ea9f2f94"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AfTooltip_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea9f2f94_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AfTooltip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 656 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"af-tooltip"},[_c('div',{staticClass:"af-tooltip__link",on:{"click":_vm.toggleContent}},[_c('icon',{attrs:{"link":"","size":18,"type":"info-circle"}}),_vm._v(" "),_c('span',{staticClass:"af-tooltip__link-title"},[_vm._v("Info")])],1),_vm._v(" "),(_vm.open)?_c('div',{staticClass:"af-tooltip__content"},[_c('div',{staticClass:"af-tooltip__close",on:{"click":_vm.closeContent}},[_c('icon',{attrs:{"fill":"#767676","type":"times"}})],1),_vm._v(" "),_vm._t("tooltip")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"h3"},[_vm._t("default"),_vm._v(" "),(_vm.tooltip)?_c('af-tooltip',[_c('template',{slot:"tooltip"},[_vm._t("tooltip")],2)],2):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-experiences",class:{ 'search-experiences--loading': _vm.loading }},[_c('div',{staticClass:"search-experiences__search"},[_c('search-local-search',{attrs:{"list":_vm.searchList,"placeholder":"Sök yrken","queryType":"experiences"}})],1),_vm._v(" "),_c('header',{staticClass:"search-experiences__header"},[_c('af-h3',[_vm._v("Välj bland yrkeskategorier")])],1),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"spinner-wrap"},[_c('af-spinner')],1):[_c('div',{staticClass:"search-experiences__columns"},[_c('div',{staticClass:"search__column"},[_c('ul',_vm._l((_vm.tree.columnOne),function(model){return _c('af-expansion-panel',{key:model.path,attrs:{"model":model,"queryType":"experiences"}})}),1)]),_vm._v(" "),_c('div',{staticClass:"search__column"},[_c('ul',_vm._l((_vm.tree.columnTwo),function(model){return _c('af-expansion-panel',{key:model.path,attrs:{"model":model,"queryType":"experiences"}})}),1)]),_vm._v(" "),_c('div',{staticClass:"search__column"},[_c('ul',_vm._l((_vm.tree.columnThree),function(model){return _c('af-expansion-panel',{key:model.path,attrs:{"model":model,"queryType":"experiences"}})}),1)])]),_vm._v(" "),_c('search-clear',{attrs:{"queryType":"experiences"}})]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchCompetences_vue__ = __webpack_require__(255);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41096d0c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchCompetences_vue__ = __webpack_require__(665);
function injectStyle (ssrContext) {
  __webpack_require__(661)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-41096d0c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchCompetences_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41096d0c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchCompetences_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 661 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchCompetencesSuggestions_vue__ = __webpack_require__(256);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31da1044_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchCompetencesSuggestions_vue__ = __webpack_require__(664);
function injectStyle (ssrContext) {
  __webpack_require__(663)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31da1044"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchCompetencesSuggestions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31da1044_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchCompetencesSuggestions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 663 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldShow)?_c('div',[_c('header',{staticClass:"search-competences-suggestions__header"},[_c('af-h3',[_vm._v("Föreslagna kompetenser")]),_vm._v(" "),_c('ul',{staticClass:"search-competences-suggestions__tags"},_vm._l((_vm.experiences),function(e){return _c('li',{key:e.path},[_vm._v(_vm._s(e.name))])}),0)],1),_vm._v(" "),_c('section',{staticClass:"search-competences-suggestions__options"},_vm._l((_vm.competences),function(competence){return _c('div',{key:("suggestions-" + (competence.path)),staticClass:"search-competences-suggestions__options-option"},[_c('af-checkbox',{attrs:{"checked":_vm.isAdded(competence.path),"label":competence.name,"name":competence.path},on:{"changed":function($event){_vm.toggleInclude($event)}}},[_vm._v("\n        "+_vm._s(competence.name)+"\n      ")])],1)}),0)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-competences",class:{ 'search-competences--loading': _vm.loading }},[_c('div',{staticClass:"search-competences__search"},[_c('search-local-search',{attrs:{"list":_vm.searchList,"placeholder":"Sök kompetenser","queryType":"skills"}})],1),_vm._v(" "),_c('search-competences-suggestions'),_vm._v(" "),_c('af-h3',{staticClass:"search-competences__header"},[_vm._v("Välj bland kompetenser")]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"spinner-wrap"},[_c('af-spinner')],1):_c('div',{staticClass:"search-competences__columns"},[_c('div',{staticClass:"search__column"},[_c('ul',_vm._l((_vm.tree.columnOne),function(model){return _c('af-expansion-panel',{key:model.path,attrs:{"model":model,"queryType":"skills"}})}),1)]),_vm._v(" "),_c('div',{staticClass:"search__column"},[_c('ul',_vm._l((_vm.tree.columnTwo),function(model){return _c('af-expansion-panel',{key:model.path,attrs:{"model":model,"queryType":"skills"}})}),1)]),_vm._v(" "),_c('div',{staticClass:"search__column"},[_c('ul',_vm._l((_vm.tree.columnThree),function(model){return _c('af-expansion-panel',{key:model.path,attrs:{"model":model,"queryType":"skills"}})}),1)])]),_vm._v(" "),_c('search-clear',{attrs:{"queryType":"skills"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchAsylumStatus_vue__ = __webpack_require__(257);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c2babdc_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchAsylumStatus_vue__ = __webpack_require__(670);
function injectStyle (ssrContext) {
  __webpack_require__(667)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7c2babdc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchAsylumStatus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c2babdc_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchAsylumStatus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 667 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 668 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"information-box__link",attrs:{"target":_vm.target,"to":_vm.href}},[_c('icon',{staticClass:"information-box__link-icon",attrs:{"link":"","type":"angle-right"}}),_vm._v(" "),_c('span',{staticClass:"information-box__link-text"},[_vm._t("link")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-asylum-status"},[_c('header',{staticClass:"search-asylum-status__header"},[_c('af-h3',[_vm._v("\n      Arbetsstatus\n    ")])],1),_vm._v(" "),_c('div',{staticClass:"search-asylum-status__read-more"},[_c('af-link',{attrs:{"href":"/arbetsgivarinformation"}},[_c('template',{slot:"link"},[_vm._v("\n        Läs mer om att anställa personer som är nya i Sverige\n      ")])],2)],1),_vm._v(" "),_c('section',[_c('div',{staticClass:"search-asylum-status__box"},[_c('div',{staticClass:"search-asylum-status__box-frame"},[_c('af-checkbox',{attrs:{"checked":_vm.hasResidencePermitChecked,"name":"hasResidencePermit"},on:{"changed":_vm.hasResidencePermit}},[_vm._v("\n          Personer med uppehållstillstånd")])],1),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"search-asylum-status__box"},[_c('div',{staticClass:"search-asylum-status__box-frame"},[_c('af-checkbox',{attrs:{"checked":_vm.hasWorkPermitChecked,"name":"hasAtUnd"},on:{"changed":_vm.hasWorkPermit}},[_vm._v("\n          Personer som "),_c('strong',[_vm._v("får")]),_vm._v(" jobba")])],1),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"search-asylum-status__box"},[_c('div',{staticClass:"search-asylum-status__box-frame"},[_c('af-checkbox',{attrs:{"checked":_vm.noWorkPermitChecked,"name":"seekingAsylum"},on:{"changed":_vm.noWorkPermit}},[_vm._v("\n          Personer som "),_c('strong',[_vm._v("inte får")]),_vm._v(" jobba än")])],1),_vm._v(" "),_vm._m(2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-asylum-status__box-content"},[_c('p',[_vm._v("En person med uppehållstillstånd kan anställas precis som vanligt. Det finns inga speciella regler eller krav du behöver förhålla dig till som arbetsgivare. I vissa fall kan du få ekonomiskt stöd när du anställer nyanlända personer.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-asylum-status__box-content"},[_c('p',[_vm._v("\n          En person får jobba i Sverige om personen har ett bevis om AT-UND "),_c('em',[_vm._v("(undantag från kravet på arbetstillstånd)")]),_vm._v(" på sitt LMA-kort.\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-asylum-status__box-content"},[_c('p',[_vm._v("\n          En person som ännu inte har fått ett bevis om AT-UND "),_c('em',[_vm._v("(undantag från kravet på arbetstillstånd)")]),_vm._v(" på sitt LMA-kort får inte jobba i Sverige.\n        ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("\n          Vill du anställa en person som ännu inte fått bevis AT-UND? Be personen kontakta Migrationsverket för att fråga om hen kommer att få AT-UND.\n        ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchEducation_vue__ = __webpack_require__(259);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51a63437_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchEducation_vue__ = __webpack_require__(676);
function injectStyle (ssrContext) {
  __webpack_require__(672)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-51a63437"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchEducation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51a63437_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchEducation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 672 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AfInfoBox_vue__ = __webpack_require__(260);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a44a473_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AfInfoBox_vue__ = __webpack_require__(675);
function injectStyle (ssrContext) {
  __webpack_require__(674)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4a44a473"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AfInfoBox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a44a473_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AfInfoBox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 674 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"info-box"},[_c('h3',{staticClass:"info-box__title"},[_c('icon',{attrs:{"link":"","type":"info-circle"}}),_vm._v(" "),_c('span',[_vm._t("title")],2)],1),_vm._v(" "),_vm._t("content"),_vm._v(" "),_vm._l((_vm.links),function(link){return _c('a',{key:link.text,staticClass:"info-box__link",attrs:{"href":link.href,"target":"_blank"}},[_c('icon',{attrs:{"link":"","type":"angle-right"}}),_vm._v("\n    "+_vm._s(link.text)+"\n  ")],1)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-education"},[_c('header',{staticClass:"search-education__header"},[_c('af-h3',[_vm._v("Välj lägsta utbildningsnivå")])],1),_vm._v(" "),_c('div',{staticClass:"search-education__wrapper"},[_c('div',{staticClass:"search-education__box-wrap"},[_c('div',{staticClass:"search-education__box"},[_c('h4',[_vm._v("Lägsta Utbildningsnivå")]),_vm._v(" "),_c('search-dropdown',{attrs:{"options":_vm.educationLevels,"value":_vm.getEducationPath,"inlinePlaceholder":"Välj utbildningsnivå","name":"educationRanking"},on:{"changed":function($event){_vm.setEducationRanking($event)}}}),_vm._v(" "),(_vm.getRanking >= 50)?_c('div',{staticClass:"search-education__box-subcategories"},[_vm._m(0),_vm._v(" "),_c('search-dropdown',{attrs:{"options":_vm.getSortedEducationSubjects,"value":_vm.getSubjectPath,"inlinePlaceholder":"Välj utbildningsinriktning","name":"educationSubject"},on:{"changed":function($event){_vm.setEducationSubject($event)}}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('search-dropdown',{attrs:{"options":_vm.years,"value":_vm.getYears,"inlinePlaceholder":"Välj minsta antal år","name":"educationYears"},on:{"changed":function($event){_vm.setEducationYears($event)}}})],1):_vm._e(),_vm._v(" "),(_vm.getRanking >= 40)?_c('div',[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"search-education__box-frame"},[_c('af-checkbox',{attrs:{"checked":_vm.getHasDegree,"name":"hasDegree"},on:{"changed":function($event){_vm.toggleInclude($event)}}},[_vm._v("\n              Krav på examen\n            ")])],1),_vm._v(" "),_c('div',{staticClass:"search-education__box-frame"},[_c('af-checkbox',{attrs:{"checked":_vm.getHasDocuments,"name":"hasDocuments"},on:{"changed":function($event){_vm.toggleInclude($event)}}},[_vm._v("\n              Krav på dokument\n            ")])],1),_vm._v(" "),_c('div',{staticClass:"search-education__box-frame"},[_c('af-checkbox',{attrs:{"checked":_vm.getHasDocumentsEnglish,"name":"hasDocumentsEnglish"},on:{"changed":function($event){_vm.toggleInclude($event)}}},[_vm._v("\n              Krav på dokument på engelska\n            ")])],1)]):_vm._e(),_vm._v(" "),(_vm.getRanking)?_c('div',{staticClass:"search-education__box-button"},[_c('af-button',{attrs:{"buttonStyle":"primary","lowercase":""},on:{"clicked":_vm.updateEducation}},[_vm._v("\n            Lägg till\n          ")])],1):_vm._e()],1)]),_vm._v(" "),_c('af-info-box',{staticClass:"search-education__info-box",attrs:{"links":_vm.infoLinks}},[_c('template',{slot:"title"},[_vm._v("Bedömning av utländska utbildningar")]),_vm._v(" "),_c('p',{attrs:{"slot":"content"},slot:"content"},[_vm._v("Myndigheten Universitets- och högskolerådet (UHR) bedömer utländska utbildningar och ger utlåtanden om vad utländska utbildningar motsvarar i det svenska utbildningssystemet.")]),_vm._v(" "),_c('p',{attrs:{"slot":"content"},slot:"content"},[_vm._v("UHR bedömer yrkesutbildningar och akademiska utbildningar på gymnasial och eftergymnasial nivå.")]),_vm._v(" "),_c('p',{attrs:{"slot":"content"},slot:"content"},[_vm._v("För yrken som är reglerade i Sverige (till exempel yrken inom sjukvård och utbildning) är det den aktuella myndigheten som bedömer utbildningen och ger en legitimation för yrket.")]),_vm._v(" "),_c('p',{attrs:{"slot":"content"},slot:"content"},[_vm._v("Alla personer som är nya i Sverige kan ansöka om att få sin utbildning bedömd och om att få legitimation för reglerade yrken.")]),_vm._v(" "),_c('p',{attrs:{"slot":"content"},slot:"content"},[_vm._v("Personer med uppehållstillstånd som är inskrivna på Arbetsförmedlingen kan få hjälp att validera sin yrkeskunskap genom Arbetsförmedlingen om de saknar intyg eller utbildningsdokument.")])],2)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_vm._v("Utbildningsinriktning "),_c('span',[_vm._v("(valfri)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_vm._v("Antal år "),_c('span',[_vm._v("(valfri)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_vm._v("Utbildningsdokument "),_c('span',[_vm._v("(valfri)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchLanguages_vue__ = __webpack_require__(261);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0de722ec_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchLanguages_vue__ = __webpack_require__(682);
function injectStyle (ssrContext) {
  __webpack_require__(678)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0de722ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchLanguages_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0de722ec_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchLanguages_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 678 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchLanguage_vue__ = __webpack_require__(262);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e422588_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchLanguage_vue__ = __webpack_require__(681);
function injectStyle (ssrContext) {
  __webpack_require__(680)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e422588"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchLanguage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e422588_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchLanguage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 680 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"search-language",attrs:{"for":_vm.label}},[_c('input',{staticClass:"search-language__checkbox",attrs:{"id":_vm.label,"type":"checkbox"},domProps:{"checked":_vm.checked},on:{"change":function($event){_vm.addToQuery({ name: _vm.name, path: _vm.path })}}}),_vm._v(" "),_c('label',{staticClass:"search-language__checkbox-indicator",attrs:{"for":_vm.label}}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-languages"},[_c('div',{staticClass:"search-languages__title"},[_c('af-h3',[_vm._v("Välj språk")])],1),_vm._v(" "),_c('div',{staticClass:"search-languages__search"},[_c('div',{staticClass:"search-languages__search-result"},_vm._l((_vm.defaultLanguages),function(item){return _c('search-language',{key:item.path,attrs:{"name":item.name,"path":item.path}},[_vm._v("\n        "+_vm._s(item.name)+"\n      ")])}),1),_vm._v(" "),_c('div',{staticClass:"search-languages__search-wrapper"},[_c('search-local-search',{attrs:{"list":_vm.languages,"placeholder":"Andra språk","queryType":"languages"}})],1)]),_vm._v(" "),_c('search-clear',{attrs:{"queryType":"languages"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchLocation_vue__ = __webpack_require__(263);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_140a1867_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchLocation_vue__ = __webpack_require__(685);
function injectStyle (ssrContext) {
  __webpack_require__(684)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-140a1867"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchLocation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_140a1867_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchLocation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 684 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-location"},[_c('div',{staticClass:"search-location__search"},[_c('search-local-search',{attrs:{"list":_vm.searchList,"placeholder":"Sök kommun eller län","queryType":"city"}})],1),_vm._v(" "),_c('header',{staticClass:"search-location__header"},[_c('af-h3',[_vm._v("Välj område")])],1),_vm._v(" "),_c('div',{staticClass:"search-location__columns"},[_c('div',{staticClass:"search__column"},[_c('ul',_vm._l((_vm.tree.columnOne),function(model){return _c('af-expansion-panel',{key:'city' + model.path,attrs:{"model":model,"queryType":"city"}})}),1)]),_vm._v(" "),_c('div',{staticClass:"search__column"},[_c('ul',_vm._l((_vm.tree.columnTwo),function(model){return _c('af-expansion-panel',{key:'city' + model.path,attrs:{"model":model,"queryType":"city"}})}),1)]),_vm._v(" "),_c('div',{staticClass:"search__column"},[_c('ul',_vm._l((_vm.tree.columnThree),function(model){return _c('af-expansion-panel',{key:'city' + model.path,attrs:{"model":model,"queryType":"city"}})}),1)])]),_vm._v(" "),_c('search-clear',{attrs:{"queryType":"city"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-tabs-wrap",class:{ 'search-tabs-wrap--hidden': _vm.hideTabs }},[_c('div',{staticClass:"search-tabs"},_vm._l((_vm.tabs),function(tab){return _c('search-tab',{key:tab.name,attrs:{"activeTab":_vm.activeTab,"tabName":tab.name},on:{"activeTab":_vm.setActiveTab}},[_vm._v("\n      "+_vm._s(tab.title)+"\n    ")])}),1),_vm._v(" "),_c('portal-target',{attrs:{"name":"desktop"}}),_vm._v(" "),_c('div',{staticClass:"search-field-list-select"},[_c('search-experiences',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab === 'experiences'),expression:"activeTab === 'experiences'"}]}),_vm._v(" "),_c('search-competences',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab === 'skills'),expression:"activeTab === 'skills'"}]}),_vm._v(" "),_c('search-languages',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab === 'languages'),expression:"activeTab === 'languages'"}]}),_vm._v(" "),_c('search-asylum-status',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab === 'asylumStatus'),expression:"activeTab === 'asylumStatus'"}]}),_vm._v(" "),_c('search-education',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab === 'educations'),expression:"activeTab === 'educations'"}]}),_vm._v(" "),_c('search-location',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab === 'city'),expression:"activeTab === 'city'"}]})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchTags_vue__ = __webpack_require__(264);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_530d321d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchTags_vue__ = __webpack_require__(692);
function injectStyle (ssrContext) {
  __webpack_require__(688)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-530d321d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchTags_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_530d321d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchTags_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 688 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchTag_vue__ = __webpack_require__(265);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a89a16b8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchTag_vue__ = __webpack_require__(691);
function injectStyle (ssrContext) {
  __webpack_require__(690)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a89a16b8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchTag_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a89a16b8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchTag_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 690 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag"},[_c('div',{attrs:{"role":"button"},on:{"click":function($event){_vm.openTab(_vm.tag.type)}}},[_vm._v("\n    "+_vm._s(_vm._f("clean")(_vm.tag.name))+"\n    "),(_vm.hasDuplicateTag)?_c('span',[_vm._v("("+_vm._s(_vm.tagName)+")")]):_vm._e()]),_vm._v(" "),(_vm.isSkillTag)?_c('span',{staticClass:"tooltiptext"},[_vm._v("\n    Minst "+_vm._s(_vm.skillLevel)+" erfarenhet\n  ")]):_vm._e(),_vm._v(" "),(_vm.isExperienceTag)?_c('span',{staticClass:"tooltiptext"},[_vm._v("\n    "+_vm._s(_vm.yearGtModifier)+" - "+_vm._s(_vm.yearLtModifier)+" år\n  ")]):_vm._e(),_vm._v(" "),(_vm.hasSubject)?_c('span',{staticClass:"tag__subject"},[_vm._v("\n    ("+_vm._s(_vm.hasSubject)+")\n  ")]):_vm._e(),_vm._v(" "),(_vm.isEducationTag)?_c('span',{staticClass:"tooltiptext"},[_vm._v("\n    Minst "+_vm._s(_vm.yearGtModifier)+" år\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"remove-wrap",attrs:{"role":"button"},on:{"click":function($event){_vm.remove(_vm.tag)}}},[_c('icon',{staticClass:"remove",attrs:{"fill":"white","size":16,"type":"times"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tags-wrap",class:{
      'tags--has-tags': _vm.hasTags
    }},[(_vm.hasTags)?_c('af-h3',[_vm._v("Dina val")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"tags"},[_vm._l((_vm.tags),function(tag){return _c('search-tag',{key:(tag.type) + "-" + (tag.path) + (tag.value !== undefined ? ("-" + (tag.value)): ''),attrs:{"tag":tag}})}),_vm._v(" "),(_vm.hasTags)?_c('button',{staticClass:"tags__reset",on:{"click":_vm.resetQuery}},[_c('icon',{staticClass:"tags__reset-icon",attrs:{"fill":"white","size":16,"type":"undo"}}),_vm._v("\n      Rensa alla val\n    ")],1):_vm._e()],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export handleAsylumStatuses */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatSearchTags; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);


var handleAsylumStatuses = function handleAsylumStatuses(_ref) {
  var asylumStatus = _ref.asylumStatus;

  return asylumStatus.map(function (status) {
    if (status.hasAtUnd) {
      return {
        name: 'Har rätt att jobba',
        type: 'asylumStatus',
        path: 'hasAtUnd',
        value: true
      };
    } else if (status.hasResidencePermit) {
      return {
        name: 'Har uppehållstillstånd',
        type: 'asylumStatus',
        path: 'hasResidencePermit',
        value: true
      };
    } else {
      return {
        name: 'Har inte rätt att jobba än',
        type: 'asylumStatus',
        path: 'hasAtUnd',
        value: false
      };
    }
  });
};

var formatSearchTags = function formatSearchTags(tags) {
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(tags).map(function (key) {
    if (key === 'asylumStatus') {
      return handleAsylumStatuses(tags);
    }

    return tags[key].map(function (t) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, t, {
        type: key
      });
    });
  }).filter(Boolean).reduce(function (p, c) {
    return p.concat(c);
  }, []);
};

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-field-wrap"},[_c('div',{staticClass:"search-field"},[_c('div',{staticClass:"search-field__query"},[_c('search-field-input',{attrs:{"value":_vm.query,"label":"Vad söker du?","name":"query","placeholder":"Skriv t.ex. golvläggare eller butikssäljare"},on:{"update:value":[function($event){_vm.query=$event},_vm.filterSearch]}}),_vm._v(" "),_c('search-locations'),_vm._v(" "),_c('search-button'),_vm._v(" "),(_vm.hasQuery)?_c('search-field-results',{attrs:{"competences":_vm.filteredCompetences,"isLoading":_vm.searchFieldsLoading,"professions":_vm.filteredProfessions,"query":_vm.query},on:{"searchDone":_vm.resetSearchResults}}):_vm._e()],1),_vm._v(" "),_c('search-tags',{attrs:{"tags":_vm.formatTags}})],1),_vm._v(" "),_c('div',{staticClass:"search-field-tabs-wrap"},[_c('af-h3',{staticClass:"search-field__title"},[_vm._v("Förfina din sökning")]),_vm._v(" "),_c('search-tabs')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchResults_vue__ = __webpack_require__(266);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_edc39a76_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchResults_vue__ = __webpack_require__(713);
function injectStyle (ssrContext) {
  __webpack_require__(696)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-edc39a76"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchResults_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_edc39a76_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchResults_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 696 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchPagination_vue__ = __webpack_require__(267);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04f54415_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchPagination_vue__ = __webpack_require__(709);
function injectStyle (ssrContext) {
  __webpack_require__(708)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchPagination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04f54415_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchPagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 708 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pageCount > 1)?_c('div',[_c('paginate',{ref:"paginate",attrs:{"click-handler":_vm.setActivePage,"page-count":_vm.pageCount,"prev-text":"«","next-text":"»","container-class":"pagination"}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchSort_vue__ = __webpack_require__(268);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39d4f83c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchSort_vue__ = __webpack_require__(712);
function injectStyle (ssrContext) {
  __webpack_require__(711)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-39d4f83c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchSort_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39d4f83c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchSort_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 711 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('search-dropdown',{attrs:{"oneLine":true,"options":this.options,"value":this.sort,"name":"searchSort","placeholder":"Sortera efter: "},on:{"changed":_vm.updateSort,"inputChange":_vm.updateSort}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"resultsBox",attrs:{"id":"resultsBox"}},[(_vm.hasResults)?_c('div',[_c('div',{staticClass:"results"},[_c('div',{staticClass:"results__title-wrapper"},[_c('div',{staticClass:"scrollDownArrows",attrs:{"id":"scrollDownArrows"}},[_c('img',{staticClass:"scroll-down-icon",attrs:{"src":(_vm.baseURL + "static/img/scroll_down.png")}})]),_vm._v(" "),_c('af-h2',{staticClass:"results__title"},[_c('span',{staticClass:"results__title-matched"},[_vm._v("\n            "+_vm._s(_vm.results.total)+"\n          ")]),_vm._v("\n           kandidater matchar\n        ")]),_vm._v(" "),_c('div',{staticClass:"results__sort"},[_c('search-sort')],1)],1),_vm._v(" "),_c('ul',_vm._l((_vm.results.hits),function(result){return _c('router-link',{key:result.id,staticClass:"result",attrs:{"to":'/profile/' + result.id,"target":_vm.targetDestination}},[_c('div',{staticClass:"result__avatar"},[_c('img',{staticClass:"result__avatar-image",attrs:{"src":(_vm.baseURL + "static/img/avatar.svg")}})]),_vm._v(" "),_c('ul',{staticClass:"result__matches"},[(result.city)?_c('li',{staticClass:"result__match"},[_c('icon',{staticClass:"result__icon-dot",attrs:{"link":"","size":10,"type":"circle"}}),_vm._v(" "),_c('strong',{staticClass:"result__label"},[_vm._v("Bor:")]),_vm._v(" "+_vm._s(result.city)+"\n            ")],1):_vm._e(),_vm._v(" "),_vm._l((_vm.matchedRequirements(result.matches)),function(match,i){return _c('li',{key:i,staticClass:"result__match"},[_c('icon',{staticClass:"result__icon",attrs:{"fill":"rgb(72, 134, 0)","size":18,"type":"check"}}),_vm._v(" "),_c('strong',{staticClass:"result__label"},[_vm._v(_vm._s(match.type)+":")]),_vm._v(" "+_vm._s(match.text)+"\n            ")],1)})],2)])}),1),_vm._v(" "),_c('search-pagination')],1)]):_vm._e(),_vm._v(" "),(_vm.hasNoResults && !_vm.noResults)?_c('div',{staticClass:"no-results"},[_c('af-h2',{attrs:{"noMarginTop":""}},[_vm._v("Sökresultat saknas")]),_vm._v(" "),_c('p',[_vm._v("Tyvärr, vi kan inte hitta några kandidater som matchar din sökning. Prova att utöka din sökning genom att ta bort kriterier.")])],1):_vm._e(),_vm._v(" "),(_vm.hasError)?_c('div',{staticClass:"no-results"},[_c('af-h2',{attrs:{"noMarginTop":""}},[_vm._v("Ett fel uppstod")])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AfInformationBox_vue__ = __webpack_require__(269);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d352b0a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AfInformationBox_vue__ = __webpack_require__(716);
function injectStyle (ssrContext) {
  __webpack_require__(715)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1d352b0a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AfInformationBox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d352b0a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AfInformationBox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 715 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"information-box"},[_c('div',{staticClass:"information-box__textwrap"},[_c('af-h2',{attrs:{"noMarginTop":""}},[_vm._t("title")],2),_vm._v(" "),_c('p',{staticClass:"information-box__content"},[_vm._t("content")],2),_vm._v(" "),(_vm.linkUrl)?_c('af-link',{attrs:{"href":_vm.linkUrl,"target":_vm.linkTarget}},[_c('template',{slot:"link"},[_vm._t("link")],2)],2):_vm._e()],1),_vm._v(" "),_c('img',{staticClass:"information-box__image",attrs:{"src":_vm.image}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 717 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"h1",class:{'no-underline': _vm.noUnderline}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchScrollToTop_vue__ = __webpack_require__(271);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bece866_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchScrollToTop_vue__ = __webpack_require__(721);
function injectStyle (ssrContext) {
  __webpack_require__(720)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1bece866"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchScrollToTop_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bece866_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchScrollToTop_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 720 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('.app'),expression:"'.app'"}],staticClass:"scrollToTop__wrapper"},[_c('icon',{staticClass:"scrollToTop__icon",attrs:{"fill":"white","type":"angle-up"}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-wrap"},[_c('header',{staticClass:"search-wrap__header"},[_c('af-h1',{attrs:{"noUnderline":""}},[_vm._v("Sök kompetens i Jobskills")])],1),_vm._v(" "),_c('search-field'),_vm._v(" "),_c('search-results'),_vm._v(" "),_c('search-scroll-to-top'),_vm._v(" "),_c('div',{staticClass:"information-boxes"},[_c('af-information-box',{attrs:{"image":"static/img/hitta_ratt.svg"}},[_c('template',{slot:"title"},[_vm._v("Hitta rätt person för jobbet")]),_vm._v(" "),_c('template',{slot:"content"},[_vm._v("I Jobskills kandidatbank kan du söka bland många arbetssökande. De som\nmatchar dina önskemål bäst visas högst upp i sökresultatet. Du kan ändra\ndin sökning genom att lägga till eller ta bort val för att få en bättre\nmatchning.")])],2),_vm._v(" "),_c('af-information-box',{attrs:{"image":"static/img/ta_kontakt.svg","linkUrl":"/arbetsgivarinformation"}},[_c('template',{slot:"title"},[_vm._v("Ta kontakt och anställ")]),_vm._v(" "),_c('template',{slot:"content"},[_vm._v("När du har hittat en person som passar kan du använda kontaktuppgifterna på personens profil och ta kontakt. Läs mer om vad som gäller när du anställer asylsökande och nyanlända så att du kan känna dig trygg i din roll som arbetsgivare. ")]),_vm._v(" "),_c('template',{slot:"link"},[_vm._v("Läs mer om att anställa personer som är nya i Sverige")])],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(272);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae54073e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(725);
function injectStyle (ssrContext) {
  __webpack_require__(724)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ae54073e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae54073e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 724 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"login__top"},[_c('div',{staticClass:"login__inner"},[_c('div',{staticClass:"box"},[_c('af-h1',[_vm._v("Hitta ny kompetens!")]),_vm._v(" "),_c('p',[_vm._v("\n          Med Jobskills kan du hitta rätt person för jobbet och fånga upp ny\n          kompetens tidigt. Här kan du nå arbetssökande personer som är nya i\n          Sverige. De arbetssökande beskriver själva sin utbildning och\n          erfarenhet och ansvarar för informationen i sin kompetensprofil.\n        ")]),_vm._v(" "),_c('div',{staticClass:"box__footer"},[_c('af-button',{attrs:{"buttonStyle":"nis-primary","lowercase":""},on:{"clicked":_vm.login}},[_vm._v("Sök kompetens i Jobskills")])],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"login__middle"},[_c('div',{staticClass:"login__inner"},[_c('div',{staticClass:"box--middle"},[_c('af-h2',{attrs:{"noMarginTop":""}},[_vm._v("Att anställa personer som är nya i Sverige")]),_vm._v(" "),_c('p',[_vm._v("\n          När du anställer personer som är nya i Sverige har du chans att\n          fånga ny kompetens tidigt samtidigt som du bidrar till\n          integrationen.\n        ")]),_vm._v(" "),_c('router-link',{staticClass:"box--middle-link",attrs:{"target":"_blank","to":"/arbetsgivarinformation"}},[_c('icon',{attrs:{"link":"","type":"angle-right"}}),_vm._v("\n          Läs mer om att anställa personer som är nya i Sverige\n        ")],1)],1),_vm._v(" "),_c('div',{staticClass:"box--middle"},[_c('af-h2',{attrs:{"noMarginTop":""}},[_vm._v("Vad är Jobskills?")]),_vm._v(" "),_c('p',[_vm._v("\n          Jobskills är ett digitalt verktyg där personer som är nya i Sverige\n          kan göra ett cv på sitt förstaspråk via valbara alternativ.\n          Kompetensprofilerna översätts till svenska, och du som arbetsgivare\n          kan söka efter kandidater utifrån erfarenheter, kompetenser och\n          utbildning.\n        ")]),_vm._v(" "),_c('router-link',{staticClass:"box--middle-link",attrs:{"to":"/om-jobskills"}},[_c('icon',{attrs:{"link":"","type":"angle-right"}}),_vm._v("\n          Läs mer om Jobskills\n        ")],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"login__bottom"},[_c('div',{staticClass:"login__inner"},[_c('div',{staticClass:"box box--bottom"},[_c('af-h2',{attrs:{"noMarginTop":""}},[_vm._v("Hur får jag tillgång till sökverktyget?")]),_vm._v(" "),_c('p',[_vm._v("\n          För att få tillgång till Jobskills sökverktyg behöver du ha ett\n          arbetsgivarkonto hos Arbetsförmedlingen. Med arbetsgivarkontot får\n          du också tillgång till andra tjänster hos Arbetsförmedlingen, t.ex.\n          möjligheten att lägga upp annonser på Platsbanken.\n        ")]),_vm._v(" "),_c('external-link',{staticClass:"box--middle-link",attrs:{"href":"https://arbetsformedlingen.se/for-arbetsgivare/skapa-arbetsgivarkonto#/valjforetag"}},[_vm._v("Skapa ett arbetsgivarkonto")])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(273);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_619e1291_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(779);
function injectStyle (ssrContext) {
  __webpack_require__(727)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-619e1291"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_619e1291_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 727 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExperienceRow_vue__ = __webpack_require__(280);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_970c2bb2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExperienceRow_vue__ = __webpack_require__(747);
function injectStyle (ssrContext) {
  __webpack_require__(746)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-970c2bb2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExperienceRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_970c2bb2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExperienceRow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 746 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"experience"},[_c('p',[_c('span',{staticClass:"title",class:_vm.strongTitle && 'title-strong'},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),(_vm.subtitle)?_c('p',[_vm._v(_vm._s(_vm.subtitle)+" "+_vm._s(_vm.suffix))]):_vm._e(),_vm._v(" "),_c('p',[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(281);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d043cef0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(750);
function injectStyle (ssrContext) {
  __webpack_require__(749)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d043cef0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d043cef0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 749 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasItems)?_c('ul',_vm._l((_vm.items),function(item){return _c('li',{key:item.value,staticClass:"item"},[_c('span',{class:{label: item.label}},[_vm._v("\n      "+_vm._s(item.label || item)+"\n    ")]),_vm._v("\n    "+_vm._s(item.value)+"\n  ")])}),0):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 751 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"outer-wrapper"},[_c('nav',{staticClass:"breadcrumbs"},[_c('ul',{staticClass:"breadcrumbs__list"},[_c('li',{staticClass:"breadcrumbs__list-item"},[_c('router-link',{attrs:{"to":_vm.parentUrl}},[_vm._v(_vm._s(_vm.parentTitle))])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumbs__list-item"},[_c('span',[_vm._v("/")]),_vm._v(" "+_vm._s(_vm.currentTitle)+"\n      ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__ = __webpack_require__(283);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e50c8ecc_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__(755);
function injectStyle (ssrContext) {
  __webpack_require__(754)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e50c8ecc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e50c8ecc_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 754 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.isOpen)?_c('div',{staticClass:"modal-wrap"},[_c('div',{staticClass:"overlay",on:{"click":_vm.closeModal}}),_vm._v(" "),_c('transition',{attrs:{"appear":"","name":"slide-up"}},[_c('div',{staticClass:"modal-inner-wrap"},[_c('div',{staticClass:"close",on:{"click":_vm.closeModal}},[_vm._v("\n          Stäng\n          "),_c('icon',{staticClass:"close-icon",attrs:{"fill":"white","type":"times"}})],1),_vm._v(" "),_c('div',{staticClass:"modal-content"},[_vm._t("default")],2)])])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalContent_vue__ = __webpack_require__(284);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7533ba14_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalContent_vue__ = __webpack_require__(758);
function injectStyle (ssrContext) {
  __webpack_require__(757)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7533ba14"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7533ba14_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 757 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal__content"},[_vm._t("notification"),_vm._v(" "),_c('af-h2',[_vm._t("title")],2),_vm._v(" "),_c('section',[_vm._t("content")],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AfInformationNotification_vue__ = __webpack_require__(285);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7814d7bb_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AfInformationNotification_vue__ = __webpack_require__(761);
function injectStyle (ssrContext) {
  __webpack_require__(760)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7814d7bb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AfInformationNotification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7814d7bb_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AfInformationNotification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 760 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-notification"},[_c('icon',{staticClass:"info-notification__icon",attrs:{"fill":"rgb(6, 118, 159)","type":"info-circle"}}),_vm._v(" "),_c('div',{staticClass:"info-notification__content"},[_c('af-h4',[_vm._t("title")],2),_vm._v(" "),_vm._t("content")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AfPopover_vue__ = __webpack_require__(286);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8a7e834_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AfPopover_vue__ = __webpack_require__(764);
function injectStyle (ssrContext) {
  __webpack_require__(763)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b8a7e834"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AfPopover_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8a7e834_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AfPopover_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 763 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"af-popover"},[_c('div',{staticClass:"af-popover__link",on:{"click":_vm.toggleContent}},[_c('icon',{attrs:{"fill":"#1616B2","size":18,"type":"info-circle"}}),_vm._v(" "),_c('span',{staticClass:"af-popover__link-title"},[_vm._t("title")],2)],1),_vm._v(" "),(_vm.open)?_c('div',{staticClass:"af-popover__content"},[_c('div',{staticClass:"af-popover__close",on:{"click":_vm.closeContent}},[_c('icon',{attrs:{"fill":"#767676","type":"times"}})],1),_vm._v(" "),_vm._t("message")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageForm_vue__ = __webpack_require__(287);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ac4de75_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageForm_vue__ = __webpack_require__(773);
function injectStyle (ssrContext) {
  __webpack_require__(766)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5ac4de75"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ac4de75_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 766 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AfSuccessNotification_vue__ = __webpack_require__(288);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c243297a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AfSuccessNotification_vue__ = __webpack_require__(769);
function injectStyle (ssrContext) {
  __webpack_require__(768)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c243297a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AfSuccessNotification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c243297a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AfSuccessNotification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 768 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification notification--success"},[_c('div',{staticClass:"notification__icon"},[_c('icon',{attrs:{"fill":"#6a9432","type":"check"}})],1),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AfErrorNotification_vue__ = __webpack_require__(289);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3de3aa48_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AfErrorNotification_vue__ = __webpack_require__(772);
function injectStyle (ssrContext) {
  __webpack_require__(771)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3de3aa48"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AfErrorNotification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3de3aa48_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AfErrorNotification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 771 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification notification--error"},[_c('div',{staticClass:"notification__icon"},[_c('icon',{attrs:{"fill":"#c80b1c","type":"exclamation-circle"}})],1),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.sendMessage($event)}}},[_c('div',{staticClass:"af-input"},[_c('label',{staticClass:"af-label",attrs:{"for":"name"}},[_vm._v("Kontaktperson")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"af-input__field",attrs:{"id":"name","name":"name","placeholder":"Ange ditt namn","type":"text"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('name')),expression:"errors.has('name')"}],staticClass:"af-form-error"},[_c('icon',{attrs:{"fill":"#c80b1c","type":"exclamation-circle"}}),_vm._v(" "),_c('div',{staticClass:"af-form-error__text"},[_vm._v(_vm._s(_vm.errors.first('name')))])],1)]),_vm._v(" "),_c('div',{staticClass:"af-input"},[_c('label',{staticClass:"af-label",attrs:{"for":"email"}},[_vm._v("Din mejl")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"},{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"af-input__field",attrs:{"id":"email","name":"email","placeholder":"Ange din mejladress","type":"text"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('email')),expression:"errors.has('email')"}],staticClass:"af-form-error"},[_c('icon',{attrs:{"fill":"#c80b1c","type":"exclamation-circle"}}),_vm._v(" "),_c('div',{staticClass:"af-form-error__text"},[_vm._v(_vm._s(_vm.errors.first('email')))])],1)]),_vm._v(" "),_c('div',{staticClass:"af-input"},[_c('label',{staticClass:"af-label",attrs:{"for":"title"}},[_vm._v("Rubrik")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.title),expression:"title"}],staticClass:"af-input__field",attrs:{"id":"title","name":"title","placeholder":"Ange ett ämne","type":"text"},domProps:{"value":(_vm.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.title=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('title')),expression:"errors.has('title')"}],staticClass:"af-form-error"},[_c('icon',{attrs:{"fill":"#c80b1c","type":"exclamation-circle"}}),_vm._v(" "),_c('div',{staticClass:"af-form-error__text"},[_vm._v(_vm._s(_vm.errors.first('title')))])],1)]),_vm._v(" "),_c('div',{staticClass:"af-textarea"},[_c('label',{staticClass:"af-label",attrs:{"for":"message"}},[_vm._v("Meddelande")]),_vm._v(" "),_c('textarea',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.message),expression:"message"}],staticClass:"af-textarea__field",attrs:{"id":"message","name":"message","placeholder":"Börja gärna meddelandet med att presentera ditt företag och din roll.","type":"text"},domProps:{"value":(_vm.message)},on:{"input":function($event){if($event.target.composing){ return; }_vm.message=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('message')),expression:"errors.has('message')"}],staticClass:"af-form-error"},[_c('icon',{attrs:{"fill":"#c80b1c","type":"exclamation-circle"}}),_vm._v(" "),_c('div',{staticClass:"af-form-error__text"},[_vm._v(_vm._s(_vm.errors.first('message')))])],1)]),_vm._v(" "),(_vm.status === 'success')?_c('af-success-notification',[_vm._v("\n    Ditt meddelande har skickats!\n  ")]):_vm._e(),_vm._v(" "),(_vm.status === 'error')?_c('af-error-notification',[_vm._v("\n    Ett fel uppstod när meddelandet skickades. Vad god försök igen.\n  ")]):_vm._e(),_vm._v(" "),_c('af-button',{attrs:{"buttonStyle":"nis-primary","lowercase":"","size":"large","type":"submit"}},[_vm._v("\n    Skicka meddelande\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileInfo_vue__ = __webpack_require__(290);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42fb9d98_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileInfo_vue__ = __webpack_require__(776);
function injectStyle (ssrContext) {
  __webpack_require__(775)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-42fb9d98"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42fb9d98_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 775 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"profile-info"},[_c('af-h4',{staticClass:"profile-info-header"},[_c('icon',{staticClass:"profile-info__icon",attrs:{"fill":"rgb(6, 118, 159)","type":"info-circle"}}),_vm._v(" "),_vm._t("title")],2),_vm._v(" "),_vm._t("content"),_vm._v(" "),_c('router-link',{staticClass:"profile-info__link",attrs:{"target":"_blank","to":"/arbetsgivarinformation"}},[_c('icon',{attrs:{"link":"","type":"angle-right"}}),_vm._v(" "),_c('span',{staticClass:"profile-info__link-text"},[_vm._t("link")],2)],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return viewUser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__queries_viewUser_graphql__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__queries_viewUser_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__queries_viewUser_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_helpers__ = __webpack_require__(53);



var viewUser = {
  viewUser: {
    query: __WEBPACK_IMPORTED_MODULE_0__queries_viewUser_graphql___default.a,
    loadingKey: 'loading',
    variables: function variables() {
      return Object(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["a" /* addProps */])({
        id: this.$route.params.id
      });
    },
    result: function result(_ref) {
      var data = _ref.data;

      this.user = data.viewUser;
    }
  }
};

/***/ }),
/* 778 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"viewUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"city"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"seeking_asylum"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"has_at_und"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"has_residence_permit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"experience"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"taxonomy_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"taxonomy_path"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"years"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"skills"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"taxonomy_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"taxonomy_path"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"years"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"career"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"taxonomy_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"taxonomy_path"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"languageSkills"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"taxonomy_path"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"education"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"years"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasDegree"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasDocuments"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasDocumentsEnglish"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"taxonomy_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"educationSubject"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":656}};
    doc.loc.source = {"body":"query viewUser($id: String!) {\r\n  viewUser(id: $id) {\r\n    id\r\n    city {\r\n      name\r\n    }\r\n    seeking_asylum\r\n    has_at_und\r\n    has_residence_permit\r\n    experience {\r\n      name\r\n      taxonomy_id\r\n      taxonomy_path\r\n      years\r\n    }\r\n    skills {\r\n      name\r\n      taxonomy_id\r\n      taxonomy_path\r\n      years\r\n    }\r\n    career {\r\n      name\r\n      taxonomy_id\r\n      taxonomy_path\r\n    }\r\n    languageSkills {\r\n      name\r\n      taxonomy_path\r\n    }\r\n    education {\r\n      name\r\n      years\r\n      hasDegree\r\n      hasDocuments\r\n      hasDocumentsEnglish\r\n      taxonomy_id\r\n      educationSubject {\r\n        name\r\n      }\r\n    }\r\n  }\r\n}\r\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',{key:"profile-loaded"},[_c('div',{staticClass:"profile"},[_c('af-button',{attrs:{"secondary":"true"},on:{"clicked":_vm.downloadCV}},[_c('Icon',{attrs:{"slot":"icon","size":16,"type":"download"},slot:"icon"}),_vm._v("\n      Ladda ned\n    ")],1),_vm._v(" "),_c('div',{staticClass:"profile-content"},[_c('section',{staticClass:"profile-row"},[_c('section',{staticClass:"section-personal"},[_c('af-h1',{staticClass:"section-title"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('list',{staticClass:"profile__list-items",attrs:{"items":_vm.personalInformation}}),_vm._v(" "),_c('div',{staticClass:"popover-wrap"},[_c('af-popover',[_c('template',{slot:"title"},[_vm._v("Varför får jag inte se fler personuppgifter?")]),_vm._v(" "),_c('template',{slot:"message"},[_vm._v("\n               Våra användares integritet är viktig. Därför visar vi bara de personuppgifter som behövs för att du ska kunna bedöma deras kompetens. Du kontaktar användarna enkelt genom att skicka ett meddelande.\n              ")])],2)],1),_vm._v(" "),_c('div',{staticClass:"message-button"},[_c('af-button',{attrs:{"buttonStyle":"nis-primary","lowercase":"","size":"large"},on:{"clicked":_vm.openMessageModal}},[_vm._v("\n            Skicka meddelande\n          ")])],1)],1),_vm._v(" "),(_vm.isSeekingAsylum && !_vm.hasATUND)?_c('profile-info',{staticClass:"profile-info--no-at-und"},[_c('template',{slot:"title"},[_vm._v("\n              Detta är en person som inte får jobba än\n            ")]),_vm._v(" "),_c('template',{slot:"content"},[_c('p',[_vm._v("\n                En person som ännu inte har fått ett bevis om AT-UND "),_c('em',[_vm._v("(undantag från kravet på arbetstillstånd)")]),_vm._v(" på sitt LMA-kort får inte jobba i Sverige.\n              ")]),_vm._v(" "),_c('p',[_vm._v("\n                Vill du anställa en person som ännu inte fått bevis AT-UND?  Be personen kontakta Migrationsverket för att fråga om hen kommer att få AT-UND.\n              ")])]),_vm._v(" "),_c('template',{slot:"link"},[_vm._v("\n            Läs mer om att anställa en person som inte har rätt att arbeta än\n          ")])],2):_vm._e(),_vm._v(" "),(_vm.isSeekingAsylum && _vm.hasATUND)?_c('profile-info',[_c('template',{slot:"title"},[_vm._v("\n            Detta är en person som får jobba\n          ")]),_vm._v(" "),_c('p',{attrs:{"slot":"content"},slot:"content"},[_vm._v("\n            En person får jobba i Sverige om personen har ett bevis om AT-UND "),_c('em',[_vm._v("(undantag från kravet på arbetstillstånd)")]),_vm._v(" på sitt LMA-kort.\n          ")]),_vm._v(" "),_c('template',{slot:"link"},[_vm._v("\n            Läs mer om att anställa en person som har rätt att arbeta\n          ")])],2):_vm._e(),_vm._v(" "),(_vm.hasResidencePermit)?_c('profile-info',[_c('template',{slot:"title"},[_vm._v("\n            Detta är en person med uppehållstillstånd\n          ")]),_vm._v(" "),_c('p',{attrs:{"slot":"content"},slot:"content"},[_vm._v("\n            En person med uppehållstillstånd kan anställas precis som vanligt. Det finns inga speciella regler eller krav du behöver förhålla dig till som arbetsgivare. I vissa fall kan du få ekonomiskt stöd när du anställer nyanlända personer.\n          ")]),_vm._v(" "),_c('template',{slot:"link"},[_vm._v("\n            Läs mer om att anställa en person med uppehållstillstånd\n          ")])],2):_vm._e()],1),_vm._v(" "),_c('section',{staticClass:"profile-row"},[_c('section',{staticClass:"section-work"},[_c('af-h2',[_vm._v("Yrkeserfarenheter")]),_vm._v(" "),_vm._l((_vm.experiences),function(row,index){return _c('experience-row',{key:'experience-' + index + row.taxonomy_id,attrs:{"subtitle":row.years,"title":row.name,"suffix":"år"}})})],2),_vm._v(" "),_c('section',{staticClass:"section-career"},[_c('af-h2',[_vm._v("Övriga yrkesönskemål")]),_vm._v(" "),_vm._l((_vm.career),function(row,index){return _c('experience-row',{key:'career-' + index + row.taxonomy_id,attrs:{"title":row.name}})})],2)]),_vm._v(" "),_c('section',{staticClass:"profile-row"},[_c('section',{staticClass:"section-skills"},[_c('af-h2',[_vm._v("Kompetenser")]),_vm._v(" "),_vm._l((_vm.skills),function(row,index){return _c('experience-row',{key:'skill-' + index + row.taxonomy_id,attrs:{"subtitle":row.years,"title":row.name,"suffix":"år"}})})],2),_vm._v(" "),_c('section',{staticClass:"section-education"},[_c('af-h2',[_vm._v("Utbildning")]),_vm._v(" "),_vm._l((_vm.educations),function(row,index){return _c('experience-row',{key:'edu-' + index + row.taxonomy_id,attrs:{"subtitle":row.name,"title":row.educationSubject.name,"strongTitle":""}},[_c('ul',[_c('li',[(row.years)?_c('span',[_vm._v(_vm._s(row.years)+" år")]):_vm._e(),_vm._v(" "),(row.hasDegree)?_c('span',[(row.years)?_c('span',[_vm._v("-")]):_vm._e(),_vm._v("\n                  Har examen\n                ")]):_vm._e(),_vm._v(" "),(!row.hasDegree)?_c('span',[(row.years)?_c('span',[_vm._v("-")]):_vm._e(),_vm._v("\n                  Har inte examen\n                ")]):_vm._e()]),_vm._v(" "),(row.hasDocuments)?_c('li',[_vm._v("Har dokument")]):_vm._e(),_vm._v(" "),(row.hasDocumentsEnglish)?_c('li',[_vm._v("Har dokument på engelska")]):_vm._e()])])})],2)]),_vm._v(" "),_c('section',{staticClass:"profile-row"},[_c('section',{staticClass:"section-language-skills"},[_c('af-h2',[_vm._v("Språkkunskaper")]),_vm._v(" "),_c('list',{staticClass:"profile__list-items",attrs:{"items":_vm.languages}})],1)])])],1),_vm._v(" "),_c('modal',{attrs:{"name":"ModalMessage"}},[_c('modal-content',[_c('af-information-notification',{attrs:{"slot":"notification"},slot:"notification"},[_c('template',{slot:"content"},[_c('p',[_vm._v("Ditt meddelande skickas till användarens mejladress och svaret går till din mejl.")]),_vm._v(" "),_c('p',[_vm._v("\n            Självklart får du inte uttrycka något hot eller formulera dig så att det kan uppfattas som stötande.  Tänk på att du som arbetsgivare är personuppgiftsansvarig för de uppgifter som du behandlar om användaren utanför Jobskills.\n          ")])])],2),_vm._v(" "),_c('header',{attrs:{"slot":"title"},slot:"title"},[_vm._v("\n        Kontakta profil #"+_vm._s(_vm.user.id)+"\n      ")]),_vm._v(" "),_c('section',{attrs:{"slot":"content"},slot:"content"},[_c('message-form',{attrs:{"userId":_vm.user.id}})],1)],1)],1)],1):_c('div',{key:"profile-loading",staticClass:"body"},[_c('div',{staticClass:"loading"},[_c('icon',{attrs:{"spin":"","type":"circle-o-notch"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_403_vue__ = __webpack_require__(291);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8bb6422e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_403_vue__ = __webpack_require__(782);
function injectStyle (ssrContext) {
  __webpack_require__(781)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8bb6422e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_403_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8bb6422e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_403_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 781 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fyranolltre"},[_c('h1',[_vm._v("Behörighet saknas")]),_vm._v(" "),(_vm.error === 'AccessDeniedForHandläggare')?_c('div',[_c('h2',[_vm._v("Åtkomst nekad")]),_vm._v(" "),_c('p',[_vm._v(" Jobskills sökgränssnitt är från och med fredagen den 11 maj bara tillgängligt för arbetsgivare och aktörer med arbetsgivarkonto hos Arbetsförmedlingen. Du som jobbar på Arbetsförmedlingen kan inte längre logga in i söktjänsten.")]),_vm._v(" "),_c('p',[_vm._v(" Bakgrunden till stängningen är att vi gör en översyn av hur Jobskills möter upp mot registerlagstiftningen. Vi tittar samtidigt på vilka möjligheter vi har att låta handläggare söka i Jobskillsdatabasen.")]),_vm._v(" "),_c('p',[_vm._v(" Om du vill informera om och visa hur Jobskills sökgränssnitt fungerar så kommer du inom kort kunna använda dig av vår demonstrationsdatabas. Information om hur du kommer till denna kommer inom kort.")]),_vm._v(" "),_c('p',[_vm._v(" Det går givetvis fortfarande bra att använda informationen från Jobskills vid inskrivningen t ex genom att personen som ska skriva in sig tar med sig en utskrift av sin Jobskillsprofil till inskrivningssamtalet. Planerna på att integrera Jobskills med AIS/Mina sidor så att informationen kan föras över digitalt finns kvar.")]),_vm._v(" "),_c('p',[_vm._v(" Det går också fint att hjälpa arbetsgivare som ber om stöd att göra urval i söktjänsten tillsammans med dem t ex genom att ni sitter ihop eller delar skärm. (När vi gör detta måste vi säkerställa att vi efter genomförd stödinsats inte behåller någon information om individen eller sökningen.)")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v(" Hälsningar Jobskillsteamet")])]):_c('div',[_c('p',[_vm._v("\n      Du saknar behörighet att söka på Jobskills.se\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_404_vue__ = __webpack_require__(292);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37f26d8b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_404_vue__ = __webpack_require__(785);
function injectStyle (ssrContext) {
  __webpack_require__(784)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-37f26d8b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_404_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37f26d8b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_404_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 784 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"outer-wrapper"},[_c('div',{staticClass:"inner-wrapper"},[_c('div',{staticClass:"left"},[_c('af-h1',{attrs:{"noUnderline":""}},[_vm._v("Sidan hittades inte!")]),_vm._v(" "),_c('p',[_vm._v("Sidan du letade efter på den här adressen finns inte. Det kan bero på flera saker, till exempel kan adressen vara felstavad eller så har sidan tagits bort.")]),_vm._v(" "),_c('router-link',{staticClass:"beta-information__link",attrs:{"to":"/"}},[_c('icon',{attrs:{"link":"","type":"angle-right"}}),_vm._v(" "),_c('span',[_vm._v("Gå till startsidan")])],1)],1),_vm._v(" "),_c('div',{staticClass:"right"},[_c('img',{staticClass:"img",attrs:{"src":(_vm.baseURL + "static/img/404.svg")}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23f8583e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoggedOut_vue__ = __webpack_require__(788);
function injectStyle (ssrContext) {
  __webpack_require__(787)
}
var normalizeComponent = __webpack_require__(1)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-23f8583e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23f8583e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoggedOut_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 787 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logout"},[_c('h1',[_vm._v("Utloggningssida jobskills.se")]),_vm._v(" "),_c('p',[_vm._v("Du har ej blivit utloggad från Arbetsförmedlingen, för att göra det,\n    "),_c('a',{attrs:{"href":"https://arbetsformedlingen.se/logout"}},[_vm._v("klicka här")]),_vm._v(".\n  ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmployerInfo_vue__ = __webpack_require__(293);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43b73b31_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmployerInfo_vue__ = __webpack_require__(791);
function injectStyle (ssrContext) {
  __webpack_require__(790)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-43b73b31"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmployerInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43b73b31_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmployerInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 790 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('breadcrumbs',{attrs:{"parentUrl":"/","parentTitle":"Start","currentTitle":"Arbetsgivarinformation"}}),_vm._v(" "),_c('div',{staticClass:"outer-wrapper"},[_c('div',{staticClass:"inner-wrapper"},[_c('af-h1',[_vm._v("När du vill anställa någon som är ny i Sverige")]),_vm._v(" "),_c('div',{staticClass:"left"},[_c('p',{staticClass:"lead-paragraph"},[_vm._v("\n          När du anställer personer som nyss har kommit till Sverige har du möjlighet att fånga upp ny kompetens tidigt, samtidigt som du bidrar till integrationen. Här får du som är arbetsgivare tips och råd.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Den som är ny i Sverige har nyligen fått uppehållstillstånd, eller väntar fortfarande på Migrationsverkets beslut.\n        ")]),_vm._v(" "),_c('af-h2',[_vm._v("Att anställa en person som inte har rätt att arbeta än")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',[_vm._v("\n          Du får inget ekonomiskt stöd från Arbetsförmedlingen för att anställa personer som inte fått uppehållstillstånd.\n        ")]),_vm._v(" "),_c('af-h2',[_vm._v("Att anställa en person som har rätt att arbeta")]),_vm._v(" "),_c('p',[_vm._v("\n          En person som väntar på uppehållstillstånd har i vissa fall rätt att arbeta i Sverige. Personen har rätt att jobba i Sverige om det står ”AT-UND” under punkt 7 på LMA-kortet. LMA-kortet utfärdas av Migrationsverket och är ingen identitetshandling, utan ett kort som visar att personen har sökt asyl.\n        ")]),_vm._v(" "),_c('af-h3',[_vm._v("Meddela Migrationsverket")]),_vm._v(" "),_c('p',[_vm._v("\n          När du anställer en person som har rätt att jobba i Sverige behöver du meddela Migrationsverket genom att fylla i en blankett. Du kan läsa mer och hitta blanketten på "),_c('external-link',{attrs:{"href":"https://www.migrationsverket.se/Andra-aktorer/Arbetsgivare/Anstalla-nagon-som-redan-ar-i-Sverige/Asylsokande.html","inline":true}},[_vm._v(" Migrationsverkets webbsida")]),_vm._v(". Du behöver även meddela Migrationsverket när personen slutar jobba hos dig.\n        ")],1),_vm._v(" "),_c('p',[_vm._v("\n          Du kan behöva hjälpa personen att ordna ett samordningsnummer från Skatteverket om hen inte har ett sedan tidigare. Samordningsnumret är till för att personen ska kunna betala skatt och få sjukpenning.\n        ")]),_vm._v(" "),_c('p',[_c('external-link',{attrs:{"href":"https://www.migrationsverket.se/download/18.5e83388f141c129ba6312eab/1519893956227/anst_erbj_232011_sv.pdf"}},[_vm._v("\n            Anställningserbjudande, blankett nummer 232011 (på svenska och engelska) på Migrationsverkets webbplats\n          ")])],1),_vm._v(" "),_c('p',[_c('external-link',{attrs:{"href":"https://www.migrationsverket.se/download/18.5e83388f141c129ba63110a1/1511190563415/atnamnlista_234011_sv.pdf"}},[_vm._v("\n            Namnlista, blankett nummer 234011 (på svenska)  på Migrationsverkets webbplats\n          ")])],1),_vm._v(" "),_c('p',[_c('external-link',{attrs:{"href":"https://www.migrationsverket.se/download/18.5e83388f141c129ba6312ea7/1504173277674/atanst_asylsok_152011_sv.pdf"}},[_vm._v("\n            Anmälan om anställning av asylsökande. För arbetsgivare som anställer asylsökande, blankett nummer 152011 (på svenska) på Migrationsverkets webbplats\n          ")])],1),_vm._v(" "),_c('af-h2',[_vm._v("Att anställa en person med uppehållstillstånd")]),_vm._v(" "),_c('p',[_vm._v("\n          En person med uppehållstillstånd kan anställas precis som vanligt. Det finns inga speciella regler eller krav du behöver förhålla dig till som arbetsgivare. I vissa fall kan du få ekonomiskt stöd när du anställer nyanlända. Du kan läsa mer på "),_c('external-link',{attrs:{"href":"https://arbetsformedlingen.se/for-arbetsgivare/anstallningsstod/anstall-med-ekonomiskt-stod","target":"_blank","inline":true}},[_vm._v("Arbetsförmedlingens webbsida")]),_vm._v(".\n        ")],1),_vm._v(" "),_c('af-h2',[_vm._v("Håll koll på utbildningar och legitimationer")]),_vm._v(" "),_c('p',[_vm._v("\n          Vissa yrken är reglerade i Sverige, till exempel yrken inom sjukvård och utbildning. Det betyder att en legitimation från en myndighet för att få utöva yrket behövs. Om en person som är ny i Sverige har en utbildning inom ett legitimationsyrke från ett annat land kan hen få sin utbildning bedömd av den aktuella myndigheten för att sedan få en legitimation.\n        ")])],1),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"right-content"},[_c('af-h2',{staticClass:"title-right"},[_vm._v("Viktiga begrepp")]),_vm._v(" "),_c('af-h3',[_vm._v("AT-UND")]),_vm._v(" "),_c('p',[_vm._v("\n            AT-UND står för ”undantag från kravet att ha arbetstillstånd” vilket betyder att personen har rätt att jobba i Sverige.\n          ")]),_vm._v(" "),_c('p',[_c('external-link',{attrs:{"href":"https://www.migrationsverket.se/Privatpersoner/Skydd-och-asyl-i-Sverige/Vanliga-fragor-och-svar-/Om-AT-UND-och-ratten-att-arbeta.html","inline":true}},[_vm._v("Läs mer om AT-UND hos Migrationsverket webbsida")])],1),_vm._v(" "),_c('af-h3',[_vm._v("LMA-kort")]),_vm._v(" "),_c('p',[_vm._v("\n            LMA står för ”lagen om mottagande av asylsökande”. Kortet är utfärdat av Migrationsverket och är ingen identitetshandling utan ett bevis på att personen är asylsökande i Sverige. Kortet visar bland annat om personen har rätt att jobba i Sverige.\n          ")]),_vm._v(" "),_c('af-h3',[_vm._v("Nyanländ")]),_vm._v(" "),_c('p',[_vm._v("\n            En nyanländ är en person som har fått uppehållstillstånd i Sverige och omfattas av lagen om etableringsinsatser.\n          ")]),_vm._v(" "),_c('af-h3',[_vm._v("Samordningsnummer")]),_vm._v(" "),_c('p',[_vm._v("\n            Samordningsnummer utfärdas av Skatteverket och fungerar som ett personnummer för personer som inte har ett svenskt personnummer. Personer som har rätt att jobba i Sverige behöver ett samordningsnummer för att kunna betala skatt och få sjukpenning.\n          ")]),_vm._v(" "),_c('p',[_c('external-link',{attrs:{"href":"https://www.skatteverket.se/privat/skatter/internationellt/bosattutomlands/samordningsnummer.4.53a97fe91163dfce2da80001279.html","inline":true}},[_vm._v("Läs mer om samordningsnummer hos Skatteverket")])],1)],1)])],1)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n          En person som inte har rätt att jobba än i Sverige har inte fått bevis om AT-UND "),_c('em',[_vm._v("(undantag från kravet på arbetstillstånd)")]),_vm._v(" på sitt LMA-kort. Vill du anställa en person som ännu inte fått bevis om  AT-UND?  Be personen kontakta Migrationsverket för att fråga om hen kommer att få AT-UND.\n        ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__ = __webpack_require__(294);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fadf70b8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__ = __webpack_require__(794);
function injectStyle (ssrContext) {
  __webpack_require__(793)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fadf70b8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fadf70b8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 793 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('breadcrumbs',{attrs:{"parentUrl":"/","parentTitle":"Start","currentTitle":"Kontakta oss"}}),_vm._v(" "),_c('div',{staticClass:"outer-wrapper"},[_c('div',{staticClass:"inner-wrapper"},[_c('af-h1',[_vm._v("Kontakta oss")]),_vm._v(" "),_c('div',{staticClass:"section"},[_c('af-h2',[_vm._v("Kontakta oss som arbetsgivare")]),_vm._v(" "),_vm._m(0)],1),_vm._v(" "),_c('div',{staticClass:"info-box-wrapper"},[_c('div',{staticClass:"info-box section"},[_c('af-h2',{attrs:{"noMarginTop":""}},[_vm._v("Få tillgång till Jobskills söktjänst")]),_vm._v(" "),_c('p',[_vm._v("\n            För att få tillgång till Jobskills kandidatsök behöver du ha ett\n            arbetsgivarkonto hos Arbetsförmedlingen. Med arbetsgivarkontot får\n            du också tillgång till andra tjänster hos Arbetsförmedlingen,\n            t.ex. möjligheten att lägga upp annonser på Platsbanken.\n          ")]),_vm._v(" "),_c('external-link',{attrs:{"href":"https://arbetsformedlingen.se/for-arbetsgivare/skapa-arbetsgivarkonto#/valjforetag"}},[_vm._v("Skapa ett arbetsgivarkonto")])],1)])],1)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n          Kontakta oss om du har några frågor eller funderingar om Jobskills.\n          Se mer information\n          "),_c('a',{attrs:{"href":"https://arbetsformedlingen.se/kontakt/tekniska-problem"}},[_vm._v("här.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutJobskills_vue__ = __webpack_require__(295);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42bb33af_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutJobskills_vue__ = __webpack_require__(797);
function injectStyle (ssrContext) {
  __webpack_require__(796)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-42bb33af"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutJobskills_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42bb33af_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutJobskills_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 796 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('breadcrumbs',{attrs:{"parentUrl":"/","parentTitle":"Start","currentTitle":"Om Jobskills"}}),_vm._v(" "),_c('div',{staticClass:"outer-wrapper"},[_c('div',{staticClass:"inner-wrapper"},[_c('af-h1',[_vm._v("Om Jobskills")]),_vm._v(" "),_c('div',{staticClass:"section"},[_c('af-h2',[_vm._v("Hitta ny kompetens med Jobskills")]),_vm._v(" "),_c('p',[_vm._v("\n          Jobskills är en tjänst för personer som är nya i Sverige och för\n          arbetsgivare som vill hitta ny kompetens. De som är nya i Sverige\n          kan själva kartlägga sin kompetens och förbereda sig för ett jobb i\n          Sverige, och du som arbetsgivare har chans att vara först med att\n          hitta ny värdefull kompetens.\n        ")]),_vm._v(" "),_c('p',[_vm._v("Med Jobskills kan du som arbetsgivare:")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('af-h2',[_vm._v("Personer som är nya i Sverige skapar en profil och ett cv")]),_vm._v(" "),_c('p',[_vm._v("\n          De som är nya i Sverige kan skapa en kompetensprofil på sitt\n          förstaspråk utifrån valbara alternativ. Kompetensprofilen blir som\n          ett cv som automatiskt kan översättas till svenska. Den\n          arbetssökande väljer själv om profilen ska vara publicerad och visas\n          i sökresultatet när arbetsgivare söker efter kompetens.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Jobskills finns på arabiska, engelska, persiska, somaliska, svenska\n          och tigrinja för de arbetssökande, och sökverktyget för arbetsgivare\n          är på svenska.\n        ")]),_vm._v(" "),_c('div',{staticClass:"alert-info"},[_c('icon',{staticClass:"alert-info__information-icon",attrs:{"link":"","type":"info-circle"}}),_vm._v(" "),_c('p',[_vm._v("\n            Kompetensprofilerna baseras på hur de arbetssökande själva\n            beskriver sin utbildning och sin erfarenhet och de arbetssökande\n            ansvarar för informationen i sina kompetensprofiler.\n          ")])],1),_vm._v(" "),_c('af-h2',[_vm._v("Använd Jobskills sökverktyg för att hitta ny kompetens")]),_vm._v(" "),_c('p',[_vm._v("\n          I sökverktyget för arbetsgivare kan du söka efter kandidater utifrån\n          erfarenhet, kompetenser och utbildning. I sökresultatet ser du de\n          kandidater som matchar din sökning, och du kan gå in på personernas\n          profiler för att se cv:n och för att komma i kontakt med en för dig\n          intressant profil.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          För att kunna använda Jobskills sökverktyg behöver du ha ett\n          arbetsgivarkonto hos Arbetsförmedlingen.\n        ")])],1),_vm._v(" "),_c('div',{staticClass:"info-box-wrapper"},[_c('div',{staticClass:"info-box section"},[_c('af-h2',{attrs:{"noMarginTop":""}},[_vm._v("Få tillgång till Jobskills söktjänst")]),_vm._v(" "),_c('p',[_vm._v("\n            För att få tillgång till Jobskills kandidatsök behöver du ha ett\n            arbetsgivarkonto hos Arbetsförmedlingen. Med arbetsgivarkontot får\n            du också tillgång till andra tjänster hos Arbetsförmedlingen,\n            t.ex. möjligheten att lägga upp annonser på Platsbanken.\n          ")]),_vm._v(" "),_c('external-link',{staticClass:"text-link",attrs:{"href":"https://arbetsformedlingen.se/for-arbetsgivare/skapa-arbetsgivarkonto#/valjforetag"}},[_vm._v("Skapa ett arbetsgivarkonto")])],1),_vm._v(" "),_c('div',{staticClass:"info-box section"},[_c('af-h2',{attrs:{"noMarginTop":""}},[_vm._v("Att anställa nya i Sverige ")]),_vm._v(" "),_c('p',[_vm._v("\n            Läs mer om vilka regler som gäller och känn dig trygg när du\n            anställer nya i Sverige.\n          ")]),_vm._v(" "),_c('router-link',{staticClass:"text-link",attrs:{"to":"/arbetsgivarinformation"}},[_c('icon',{attrs:{"link":"","size":18,"type":"chevron-right"}}),_vm._v("Att anställa\n            nya i Sverige\n          ")],1)],1)])],1)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("vara först med att hitta ny kompetens")]),_vm._v(" "),_c('li',[_vm._v("hitta ny arbetskraft snabbt")]),_vm._v(" "),_c('li',[_vm._v("bidra till integrationen.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = requireToken;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_cookies__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_helpers__ = __webpack_require__(53);



function requireToken(_to, _from, next) {
  var token = __WEBPACK_IMPORTED_MODULE_0__utils_cookies__["a" /* default */].getItem('search-token');

  if (!token || tokenHasExpired(token)) {
    next('/');
  } else {
    next();
  }
}

function tokenHasExpired(token) {
  var expiry = Object(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["b" /* deconstructJWT */])(token).exp * 1000;

  return Date.now() > expiry;
}

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_dist_logger__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_dist_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_dist_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(806);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== 'production' && "production" !== 'testing';

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    activeTab: '',
    query: {
      city: [],
      skills: [],
      experiences: [],
      educations: [],
      languages: [],
      asylumStatus: []
    },
    modal: '',
    results: {
      hits: [],
      total: 0
    },
    hasSearched: false,
    noResults: false,
    error: null,
    skip: 0,
    limit: 10,
    strict: true,
    loggedIn: false,
    sort: 'relevance',
    permissions: [],
    cities: [],
    userMessage: {
      bodyEn: '',
      bodySv: '',
      bodyAr: '',
      bodyFa: '',
      bodySo: '',
      bodyTi: '',
      subjectEn: '',
      subjectSv: '',
      subjectAr: '',
      subjectFa: '',
      subjectSo: '',
      subjectTi: '',
      fallbackToEnglish: false
    },
    tree: {
      experiences: {
        columnOne: [],
        columnTwo: [],
        columnThree: []
      },
      skills: {
        columnOne: [],
        columnTwo: [],
        columnThree: []
      },
      locations: {
        columnOne: [],
        columnTwo: [],
        columnThree: []
      }
    },
    searchStats: {
      emailCount: 0,
      languagesUsed: [],
      phoneNumberCount: 0,
      savedSearchId: null,
      totalCount: 0
    }
  },

  getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */],

  strict: debug,
  plugins: debug ? [__WEBPACK_IMPORTED_MODULE_2_vuex_dist_logger___default()()] : []
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 800 */,
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loggedIn", function() { return loggedIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasPermissionUserEmailBatches", function() { return hasPermissionUserEmailBatches; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasPermissionUnlimitedSearch", function() { return hasPermissionUnlimitedSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "educations", function() { return educations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasWorkPermitChecked", function() { return hasWorkPermitChecked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasResidencePermitChecked", function() { return hasResidencePermitChecked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "noWorkPermitChecked", function() { return noWorkPermitChecked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasLanguage", function() { return hasLanguage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasError", function() { return hasError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasDuplicateTag", function() { return hasDuplicateTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getQueryType", function() { return getQueryType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSelectedFromQuery", function() { return getSelectedFromQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasValue", function() { return hasValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentModal", function() { return currentModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__(805);





var loggedIn = function loggedIn(state) {
  return state.loggedIn;
};
var hasPermissionUserEmailBatches = function hasPermissionUserEmailBatches(state) {
  return state.permissions.includes('user_message_batches');
};
var hasPermissionUnlimitedSearch = function hasPermissionUnlimitedSearch(state) {
  return state.permissions.includes('unlimited_search');
};

var educations = function educations(state) {
  return state.query.educations;
};

var hasWorkPermitChecked = function hasWorkPermitChecked(state) {
  var valid = {
    hasAtUnd: true
  };

  return !!Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* checkAsylumStatus */])(state, valid, 'hasAtUnd');
};

var hasResidencePermitChecked = function hasResidencePermitChecked(state) {
  var valid = {
    hasResidencePermit: true
  };

  return !!Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* checkAsylumStatus */])(state, valid, 'hasResidencePermit');
};

var noWorkPermitChecked = function noWorkPermitChecked(state) {
  var valid = {
    hasAtUnd: false
  };

  return !!Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* checkAsylumStatus */])(state, valid, 'hasAtUnd');
};

var hasLanguage = function hasLanguage(state) {
  return function (language) {
    return !!state.query.languages.find(function (l) {
      return l.name === language;
    });
  };
};

var hasError = function hasError(state) {
  return !!state.error;
};

var hasDuplicateTag = function hasDuplicateTag(state) {
  return function (name) {
    return !!state.query.experiences.find(function (e) {
      return e.name === name;
    }) && !!state.query.skills.find(function (s) {
      return s.name === name;
    });
  };
};

var getQueryType = function getQueryType(state) {
  return function (type) {
    var selected = state.query[type];
    return selected ? selected.length : 0;
  };
};

var getSelectedFromQuery = function getSelectedFromQuery(state) {
  return function (types) {
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(state.query).reduce(function (acc, type) {
      if (types.includes(type)) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, acc, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, type, state.query[type]));
      }

      return acc;
    }, {});
  };
};

var hasValue = function hasValue(state) {
  return function (path, type) {
    return !!state.query[type].find(function (item) {
      return item.path === path.replace('county-', '');
    });
  };
};

var currentModal = function currentModal(state) {
  return state.modal;
};

/***/ }),
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkAsylumStatus; });
var checkAsylumStatus = function checkAsylumStatus(state, input, type) {
  return state.query.asylumStatus.find(function (status) {
    return status[type] === input[type];
  });
};

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_freeze__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actionTypes__ = __webpack_require__(13);




var _types$UPDATE_TAB_COL;



/* harmony default export */ __webpack_exports__["a"] = (_types$UPDATE_TAB_COL = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_TAB_COL, __WEBPACK_IMPORTED_MODULE_3__actionTypes__["w" /* UPDATE_TAB_COLUMN */], function (state, _ref) {
  var type = _ref.type,
      payload = _ref.payload;

  state.tree[type] = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_freeze___default()(payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_TAB_COL, __WEBPACK_IMPORTED_MODULE_3__actionTypes__["d" /* ADD_TO_QUERY */], function (state, _ref2) {
  var type = _ref2.type,
      payload = _ref2.payload;

  var alreadyAdded = state.query[type].find(function (_ref3) {
    var path = _ref3.path;
    return path === payload.path.replace('county-', '');
  });

  if (alreadyAdded) {
    return false;
  }

  if (type === 'languages') {
    state.query.languages = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.query.languages), [{
      name: payload.name,
      path: payload.path
    }]);

    return;
  }

  state.query[type] = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.query[type]), [{
    name: payload.name,
    path: payload.path.replace('county-', ''),
    years: payload.years ? payload.years : []
  }]);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_TAB_COL, __WEBPACK_IMPORTED_MODULE_3__actionTypes__["n" /* REMOVE_FROM_QUERY */], function (state, _ref4) {
  var type = _ref4.type,
      path = _ref4.path,
      subject = _ref4.subject,
      value = _ref4.value;

  if (type === 'asylumStatus') {
    state.query.asylumStatus = state.query.asylumStatus.filter(function (x) {
      return x[path] === undefined || x[path] !== value;
    });

    return;
  }

  if (type === 'educations') {
    if (subject && subject.path) {
      state.query.educations = state.query.educations.filter(function (education) {
        return education.path !== path || education.subject.path !== subject.path;
      });
    } else {
      state.query.educations = state.query.educations.filter(function (education) {
        return education.path !== path;
      });
    }

    return;
  }

  state.query[type] = state.query[type].filter(function (x) {
    return x.path !== path;
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_TAB_COL, __WEBPACK_IMPORTED_MODULE_3__actionTypes__["e" /* CLEAR_FROM_QUERY */], function (state, type) {
  state.query[type] = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_TAB_COL, __WEBPACK_IMPORTED_MODULE_3__actionTypes__["f" /* CLEAR_QUERY_OF_TYPE */], function (state, _ref5) {
  var type = _ref5.type,
      path = _ref5.path;

  state.query[type] = state.query[type].filter(function (x) {
    var innerPath = x.path.split('.');
    var inputPath = path.replace('county-', '').split('.');

    switch (inputPath.length) {
      case 3:
        return innerPath.slice(0, 3).join('.') !== inputPath.slice(0, 3).join('.');
      case 2:
        return innerPath.slice(0, 2).join('.') !== inputPath.slice(0, 2).join('.');
      case 1:
        return innerPath[0] !== inputPath[0];
    }
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_TAB_COL, __WEBPACK_IMPORTED_MODULE_3__actionTypes__["o" /* RESET_QUERY */], function (state) {
  state.query = {
    city: [],
    skills: [],
    experiences: [],
    educations: [],
    languages: [],
    asylumStatus: []
  };
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_TAB_COL, __WEBPACK_IMPORTED_MODULE_3__actionTypes__["c" /* ADD_SKILL_YEARS */], function (state, payload) {
  var name = payload.name,
      years = payload.years;


  var foundSkill = state.query.skills.filter(function (_ref6) {
    var path = _ref6.path;
    return path !== payload.path;
  });

  state.query.skills = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(foundSkill), [{
    name: name,
    path: payload.path,
    years: years
  }]);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_TAB_COL, __WEBPACK_IMPORTED_MODULE_3__actionTypes__["b" /* ADD_EXPERIENCE_YEARS */], function (state, payload) {
  var name = payload.name,
      years = payload.years;


  var foundExperience = state.query.experiences.filter(function (_ref7) {
    var path = _ref7.path;
    return path !== payload.path;
  });

  state.query.experiences = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(foundExperience), [{
    name: name,
    path: payload.path,
    years: years
  }]);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_TAB_COL, __WEBPACK_IMPORTED_MODULE_3__actionTypes__["a" /* ADD_EDUCATION_TO_QUERY */], function (state, _ref8) {
  var payload = _ref8.payload;

  var alreadyAddedLevelPath = state.query.educations.find(function (_ref9) {
    var path = _ref9.path;
    return path === payload.path;
  });

  var alreadyAddedSubjectPath = state.query.educations.find(function (_ref10) {
    var path = _ref10.subject.path;
    return path === payload.subject.path;
  });

  if (alreadyAddedLevelPath && alreadyAddedSubjectPath) {
    return false;
  }

  state.query.educations = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.query.educations), [payload]);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_TAB_COL, __WEBPACK_IMPORTED_MODULE_3__actionTypes__["s" /* SET_RESULTS */], function (state, payload) {
  state.results = payload;
  state.hasSearched = true;
  state.noResults = false;
  state.error = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_TAB_COL, __WEBPACK_IMPORTED_MODULE_3__actionTypes__["r" /* SET_NO_RESULTS */], function (state) {
  state.results = {
    hits: [],
    total: 0
  };
  state.noResults = true;
  state.error = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_TAB_COL, __WEBPACK_IMPORTED_MODULE_3__actionTypes__["t" /* SET_RESULT_ERROR */], function (state, error) {
  state.results = {
    hits: [],
    total: 0
  };
  state.error = error;
  state.noResults = true;
  state.hasSearched = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_TAB_COL, __WEBPACK_IMPORTED_MODULE_3__actionTypes__["j" /* LOG_IN */], function (state) {
  state.loggedIn = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_TAB_COL, __WEBPACK_IMPORTED_MODULE_3__actionTypes__["k" /* LOG_OUT */], function (state) {
  state.loggedIn = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_TAB_COL, __WEBPACK_IMPORTED_MODULE_3__actionTypes__["p" /* SET_ACTIVE_TAB */], function (state, payload) {
  state.activeTab = payload === state.activeTab ? '' : payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_TAB_COL, __WEBPACK_IMPORTED_MODULE_3__actionTypes__["q" /* SET_ACTIVE_TAB_ONLY */], function (state, payload) {
  state.activeTab = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_TAB_COL, __WEBPACK_IMPORTED_MODULE_3__actionTypes__["u" /* SET_SKIP */], function (state, payload) {
  state.skip = (payload - 1) * 10;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_TAB_COL, __WEBPACK_IMPORTED_MODULE_3__actionTypes__["h" /* HAS_RESIDENCE_PERMIT */], function (state) {
  var input = {
    hasResidencePermit: true
  };

  state.query.asylumStatus = state.query.asylumStatus.concat([input]);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_TAB_COL, __WEBPACK_IMPORTED_MODULE_3__actionTypes__["i" /* HAS_WORK_PERMIT */], function (state) {
  var input = {
    hasAtUnd: true
  };

  state.query.asylumStatus = state.query.asylumStatus.concat([input]);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_TAB_COL, __WEBPACK_IMPORTED_MODULE_3__actionTypes__["l" /* NO_WORK_PERMIT */], function (state) {
  var input = {
    hasAtUnd: false
  };

  state.query.asylumStatus = state.query.asylumStatus.concat([input]);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_TAB_COL, __WEBPACK_IMPORTED_MODULE_3__actionTypes__["v" /* SET_SORT */], function (state, payload) {
  state.sort = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_TAB_COL, __WEBPACK_IMPORTED_MODULE_3__actionTypes__["m" /* OPEN_MODAL */], function (state, payload) {
  state.modal = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_TAB_COL, __WEBPACK_IMPORTED_MODULE_3__actionTypes__["g" /* CLOSE_MODAL */], function (state) {
  state.modal = '';
}), _types$UPDATE_TAB_COL);

/***/ }),
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return requiredFields; });
var requiredFields = function requiredFields(field) {
  switch (field) {
    case 'email':
      return 'Ingen mejladress angiven';
    case 'name':
      return 'Namn saknas';
    case 'title':
      return 'Rubrik saknas';
    case 'message':
      return 'Meddelande saknas';
    default:
      return '';
  }
};

/***/ })
],[311]);


// WEBPACK FOOTER //
// static/js/app.f88f1f3064e6c82da9a7.js